/*
 * AUTO-GENERATED by scripts/generate-chapter.ts.
 * Source: LearningHub / beginner-level1
 * Do not edit by hand — regenerate from extracted JSON + translations.
 */
import type { Chapter, Level } from "../types";

export const CHAPTER_ID = "beginner-level1";

export const CHAPTER: Chapter = {
    id: "beginner-level1",
    title: { zh: "铂金", en: "Platinum" },
    description: {
        zh: "开局常识、死活与对杀初步",
        en: "Opening basics, life-and-death and capturing races",
    },
};

const bl1AtariLevels: Level[] = [
    {
        id: "beginner-level1-bl1-atari-1",
        chapterId: "beginner-level1",
        order: 1,
        title: { zh: "打吃 · 1/24", en: "Atari · 1/24" },
        instruction: { zh: "你可以吃掉被标记的黑棋棋子，但你需要正确开始，在正确的一侧打吃。在落子前，试着计算后续着法。白先。吃掉被标记的黑棋棋子。", en: "You can capture the marked black stones, but you need to start correctly, by giving atari at correct side. Try also to calculate the next moves, before you play. White to play. Capture the marked black stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hfdgegfghgchghhh", white: "dfefffgfcgggfh" },
            marks: { triangle: "dgegfg" },
            correct: ["dh"],
            wrong: ["ehdh"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-2",
        chapterId: "beginner-level1",
        order: 2,
        title: { zh: "打吃 · 2/24", en: "Atari · 2/24" },
        instruction: { zh: "白先。在正确的一侧打吃，吃掉被标记的黑棋棋子。", en: "White to play. Capture the marked black stones by giving atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccdfefhffggg", white: "eecfffegeh" },
            marks: { triangle: "dfef" },
            correct: ["dedgcgdhch", "dedgcgdhdichbh", "dedgdhcgbg"],
            wrong: ["dedgdhcgchbgbffe", "dedgdhcgchbgbhfe", "dgdecedd", "dgdeddcecdbe", "dgdeddcebecd"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-3",
        chapterId: "beginner-level1",
        order: 3,
        title: { zh: "打吃 · 3/24", en: "Atari · 3/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gdfeheefcgdgfggghg", white: "bfffgfbgegchdheh" },
            correct: ["eedfde"],
            wrong: ["eedfcfdedded", "eedfcfdeedhf", "eedfcfdeceed", "dfee"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-4",
        chapterId: "beginner-level1",
        order: 4,
        title: { zh: "打吃 · 4/24", en: "Atari · 4/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdcedfefdgfghgfh", white: "deeebfcfffegeh" },
            correct: ["dhcgbgchbhcibi", "dhcgbgchcibhah", "dhcgbgchcibhbiahag", "dhcgchbgbh", "dhcgchbgagbhbi", "dhcgchbgagbhahbici"],
            wrong: ["dhcgbgchbhcidiei", "dhcgbgchcibhbiahaidi", "dhcgchbgagbhahbiaiaf", "cgdhchei", "cgdhdiei"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-5",
        chapterId: "beginner-level1",
        order: 5,
        title: { zh: "打吃 · 5/24", en: "Atari · 5/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cddedfefffbgcgbhdhehci", white: "gcddcecfgfdgegfghgfh" },
            correct: ["fe"],
            wrong: ["eefefded", "eefeedbe", "eefegeed"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-6",
        chapterId: "beginner-level1",
        order: 6,
        title: { zh: "打吃 · 6/24", en: "Atari · 6/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "becefegehedfefcgdgfghgfh", white: "cccddebfffgfbgegchdheh" },
            correct: ["eecfbd", "eecfaebdbc", "eecfaebdadbcbb"],
            wrong: ["eecfaebdadbcacbbcbhf", "eecfaebdadbcacbbabhf", "cfee"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-7",
        chapterId: "beginner-level1",
        order: 7,
        title: { zh: "打吃 · 7/24", en: "Atari · 7/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdhebfcfffgfdgeg", white: "beceafbgcgfgdheh" },
            correct: ["ef"],
            wrong: ["dfef"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-8",
        chapterId: "beginner-level1",
        order: 8,
        title: { zh: "打吃 · 8/24", en: "Atari · 8/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bdedbefegecfefcgdg", white: "eebfffbgegfgchdh" },
            correct: ["ce"],
            wrong: ["dfce"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-9",
        chapterId: "beginner-level1",
        order: 9,
        title: { zh: "打吃 · 9/24", en: "Atari · 9/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "efffhfcgdggggheifi", white: "dedfbgegfgdhehfh" },
            correct: ["chcfcebfbe", "chcfcebfafbebd", "chcfbfcecdbebd", "chcfbfcecdbeaebdbc"],
            wrong: ["chcfcebfafbeaebd", "chcfbfcecdbeaebdadbc", "chcfbfcebecd", "cfchbhdi", "cfchcidi", "cfchdici"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-10",
        chapterId: "beginner-level1",
        order: 10,
        title: { zh: "打吃 · 10/24", en: "Atari · 10/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fcgddegebfdfcgbhch", white: "ccedceeeefdgfgdh" },
            correct: ["cfddcddcecdbebcbbb", "cfdddc"],
            wrong: ["cfddcddcecdbebcbdabbbcac", "cfddcddcecdbebcbdabbcabc", "cfddcddcecdbcbeb", "cfddcddcdbec", "ddcf"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-11",
        chapterId: "beginner-level1",
        order: 11,
        title: { zh: "打吃 · 11/24", en: "Atari · 11/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgeefffggeh", white: "fegfhfhggh" },
            correct: ["gdhehd"],
            wrong: ["gdheiehdfdhc", "gdheiehdhcfd", "hegd"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-12",
        chapterId: "beginner-level1",
        order: 12,
        title: { zh: "打吃 · 12/24", en: "Atari · 12/24" },
        instruction: { zh: "白先。在正确的一侧打吃黑棋棋串，尽可能多地吃子。", en: "White to play. Capture as many stones as possible by putting a black chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fdfeffcgggdhehfh", white: "deeedgegfgghhh" },
            correct: ["gfhghf"],
            wrong: ["gfhgighfhege", "gfhgighfifhe", "hggf"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-13",
        chapterId: "beginner-level1",
        order: 13,
        title: { zh: "打吃 · 13/24", en: "Atari · 13/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfdfdg", white: "bebfcg" },
            correct: ["bgchbhdheh"],
            wrong: ["bgchbhdhcieh", "bgchdhbh", "chbg"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-14",
        chapterId: "beginner-level1",
        order: 14,
        title: { zh: "打吃 · 14/24", en: "Atari · 14/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfffegdh", white: "ceeffggg" },
            correct: ["eedfde"],
            wrong: ["eedfdgde", "dfee"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-15",
        chapterId: "beginner-level1",
        order: 15,
        title: { zh: "打吃 · 15/24", en: "Atari · 15/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ddcegecfffdgfgeh", white: "cccdfddefedfeg" },
            correct: ["ee"],
            wrong: ["efee"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-16",
        chapterId: "beginner-level1",
        order: 16,
        title: { zh: "打吃 · 16/24", en: "Atari · 16/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfffcgeg", white: "ceeffggg" },
            correct: ["eedfde"],
            wrong: ["eedfdgde", "dfee"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-17",
        chapterId: "beginner-level1",
        order: 17,
        title: { zh: "打吃 · 17/24", en: "Atari · 17/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dccdcecfcgdh", white: "bfbgdgahchbi" },
            correct: ["eg"],
            wrong: ["dfeg"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-18",
        chapterId: "beginner-level1",
        order: 18,
        title: { zh: "打吃 · 18/24", en: "Atari · 18/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcdeeecfcg", white: "cedfefffhf" },
            correct: ["cdbebdbfbg"],
            wrong: ["cdbebdbfaebgchbhbidhahdgcidi", "cdbebfbdbcccddbb", "cdbebfbdbcccbbdd", "cdbebfbdbcccaddd", "cdbebfbdccbccbbb", "cdbebfbdccbcbbcbdbdddcedfefdgegdgfgghehd", "becd"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-19",
        chapterId: "beginner-level1",
        order: 19,
        title: { zh: "打吃 · 19/24", en: "Atari · 19/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfdfcg", white: "gfdgfg" },
            correct: ["egdhehchbh"],
            wrong: ["egdhehchdibhbgefahfheifi", "egdhcheh", "dheg"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-20",
        chapterId: "beginner-level1",
        order: 20,
        title: { zh: "打吃 · 20/24", en: "Atari · 20/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dedfgffgfh", white: "ecgcffgghg" },
            correct: ["feefeeegdgehdh", "feefeeegdgeheidhch", "feefeeegehdgcgdhch", "feefeg"],
            wrong: ["feefeeegdgeheidhdichcggehfhe", "feefeeegehdgdhcgcfgehfhe", "feefeeegehdgdhcgchgehfhe", "effegefd", "effeeefd"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-21",
        chapterId: "beginner-level1",
        order: 21,
        title: { zh: "打吃 · 21/24", en: "Atari · 21/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edbecedeafagcgdgggbhchghcifigi", white: "eebfcfdfgfhfbgegfghgdhehfhdiei" },
            correct: ["ff"],
            wrong: ["efff", "feffefgd"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-22",
        chapterId: "beginner-level1",
        order: 22,
        title: { zh: "打吃 · 22/24", en: "Atari · 22/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ddcecfeg", white: "dbcccdde" },
            correct: ["eedfdg", "eedfefdgdhcgbgchbh", "eedfefdgdhcgbgchcibhah", "eedfefdgdhcgbgchcibhbi"],
            wrong: ["eedfefdgdhcgchbgbhbf", "eedfefdgdhcgchbgbfaf", "eedfefdgcgdhched", "eedfefdgcgdhehed", "dfee"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-23",
        chapterId: "beginner-level1",
        order: 23,
        title: { zh: "打吃 · 23/24", en: "Atari · 23/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdcfdfdg", white: "cgegdhfh" },
            correct: ["chbgbhbfbe", "chbgbhbfagbebdahaiafceaheheiag"],
            wrong: ["chbgbhbfagbebdahaiafahci", "chbgbhbfagbecebdbcahaiafahci", "chbgbhbfagbecebdbcahaiafadah", "chbgbfbh", "bgch"],
        },
    },
    {
        id: "beginner-level1-bl1-atari-24",
        chapterId: "beginner-level1",
        order: 24,
        title: { zh: "打吃 · 24/24", en: "Atari · 24/24" },
        instruction: { zh: "黑先。在正确的一侧打吃白棋棋串，尽可能多地吃子。", en: "Black to play. Capture as many stones as possible by putting a white chain in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ccddefdg", white: "fedfegfg" },
            correct: ["cfdeeecebe"],
            wrong: ["decf", "cfdeeececdbebfed", "cfdeeececdbebdcg", "cfdeceee"],
        },
    },
];

const escapeFromNetLevels: Level[] = [
    {
        id: "beginner-level1-escape-from-net-1",
        chapterId: "beginner-level1",
        order: 25,
        title: { zh: "逃脱罗网 · 1/24", en: "Escape net · 1/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。白棋可以尝试在A或B点落子逃跑。在这种情况下，其中一点是成功的。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. White can try to escape by playing at A or B. In this case one of the two is successful. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbncoeobpcqdqeq", white: "cpdpbqfqgqbrcrer" },
            marks: { 1: "eo", square: "dpcp", A: "ep", B: "do" },
            correct: ["ep"],
            wrong: ["dodn", "drep"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-2",
        chapterId: "beginner-level1",
        order: 26,
        title: { zh: "逃脱罗网 · 2/24", en: "Escape net · 2/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "embndncoeobpcqeq", white: "docpdpbqgqbrerfr" },
            marks: { 1: "eq", square: "dpcpdo" },
            correct: ["dq"],
            wrong: ["epfp", "crdq"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-3",
        chapterId: "beginner-level1",
        order: 27,
        title: { zh: "逃脱罗网 · 3/24", en: "Escape net · 3/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eogogpeqgqdrerfr", white: "coiocpfpdqfqhqcrgrir" },
            marks: { 1: "eo", square: "fqfp" },
            correct: ["ep"],
            wrong: ["fofn", "dpep"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-4",
        chapterId: "beginner-level1",
        order: 28,
        title: { zh: "逃脱罗网 · 4/24", en: "Escape net · 4/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fndpepfpcqiqcrdrfr", white: "cmcocpbqdqeqbrcs" },
            marks: { 1: "fr", square: "eqdq" },
            correct: ["er"],
            wrong: ["dser", "fqgq"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-5",
        chapterId: "beginner-level1",
        order: 29,
        title: { zh: "逃脱罗网 · 5/24", en: "Escape net · 5/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocoeobpcqdqeqfqhr", white: "dlcnencpdpbqarcrdrer" },
            marks: { 1: "eo", square: "dpcp" },
            correct: ["do"],
            wrong: ["epfp"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-6",
        chapterId: "beginner-level1",
        order: 30,
        title: { zh: "逃脱罗网 · 6/24", en: "Escape net · 6/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmemgmeneogocpdpgpeqfqgr", white: "fnfoepfpdqgqhqbrdr" },
            marks: { 1: "gm", square: "fpepfofn" },
            correct: ["fr"],
            wrong: ["erfr", "fmfl", "gnhn"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-7",
        chapterId: "beginner-level1",
        order: 31,
        title: { zh: "逃脱罗网 · 7/24", en: "Escape net · 7/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfndpfpdqfqergr", white: "eobpepbqeqcrdr" },
            marks: { 1: "dn", square: "eqepeo" },
            correct: ["dococp"],
            wrong: ["docoenem", "docofogo", "enemdoco", "enemfogo", "fogoenem", "fogodoco"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-8",
        chapterId: "beginner-level1",
        order: 32,
        title: { zh: "逃脱罗网 · 8/24", en: "Escape net · 8/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dogodpeqfqgqgr", white: "dmcpepfpdqcrerfr" },
            marks: { 1: "go", square: "fpep" },
            correct: ["eoendn"],
            wrong: ["eoenfnfo", "eoengphp", "gphp", "eneo", "fofn", "fnfo"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-9",
        chapterId: "beginner-level1",
        order: 33,
        title: { zh: "逃脱罗网 · 9/24", en: "Escape net · 9/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfncogocpfpdqeqfqer", white: "eofodpepgphpbqcqiqbrdrgrcs" },
            marks: { 1: "dn", square: "epdpfoeo" },
            correct: ["gnhoenfmem"],
            wrong: ["gnhofmen", "enem", "gqen", "esen", "fren"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-10",
        chapterId: "beginner-level1",
        order: 34,
        title: { zh: "逃脱罗网 · 10/24", en: "Escape net · 10/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfncocpdpgphpcqeqfqgr", white: "dmdoeoepfpbqdqbrcrdr" },
            marks: { 1: "fn", square: "fpepeodo" },
            correct: ["encnfm", "encnem", "encnel"],
            wrong: ["cnen", "gofo", "fogo"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-11",
        chapterId: "beginner-level1",
        order: 35,
        title: { zh: "逃脱罗网 · 11/24", en: "Escape net · 11/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofogodpgpdqcrdrfr", white: "dnbodocpephpcqeqbrhr" },
            marks: { 1: "fr", square: "eqep" },
            correct: ["erescs", "eresdscsbs"],
            wrong: ["gqfq", "fqgq", "cser", "eser"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-12",
        chapterId: "beginner-level1",
        order: 36,
        title: { zh: "逃脱罗网 · 12/24", en: "Escape net · 12/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dogodpeqfqgq", white: "epfpcqdqhq" },
            marks: { 1: "go", square: "fpep" },
            correct: ["gphphoipfognfnfmgmhnemflen"],
            wrong: ["gphphoipfognfnfmgmhnemfldnen", "gphphoipfognfnfmgmhnioen", "gphphoipfognfnfmemen", "gphphoipfognenfneoem", "gphphoipgnfo", "gphphoipeoen", "gphpfofn", "fofn", "eoen", "eneo", "fnfo"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-13",
        chapterId: "beginner-level1",
        order: 37,
        title: { zh: "逃脱罗网 · 13/24", en: "Escape net · 13/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmdnfnbocoepfpbqcqdq", white: "blcmcndoeodpeqgqcrdrerhr" },
            marks: { 1: "fn", square: "dpeodo" },
            correct: ["fogogp"],
            wrong: ["fogognen", "fogoenem", "enem", "cpbp"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-14",
        chapterId: "beginner-level1",
        order: 38,
        title: { zh: "逃脱罗网 · 14/24", en: "Escape net · 14/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fndodpgpcqfqcrdrer", white: "bpcpepfpdqeq" },
            marks: { 1: "fn", square: "eqdqfpep" },
            correct: ["gqfrgohpfo"],
            wrong: ["gqfrfogo", "gqfreoen", "gqfreneo", "gqfrhpgo", "gofo", "eneo", "eoen", "fogo", "frgq"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-15",
        chapterId: "beginner-level1",
        order: 39,
        title: { zh: "逃脱罗网 · 15/24", en: "Escape net · 15/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emcndnfncodpdqeqfq", white: "dmendoeoiocpepcqcr" },
            marks: { 1: "fn", square: "epeodoen" },
            correct: ["fmelfogngo"],
            wrong: ["fogo", "gofo", "fpgp"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-16",
        chapterId: "beginner-level1",
        order: 40,
        title: { zh: "逃脱罗网 · 16/24", en: "Escape net · 16/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fndodpgpeqfqdr", white: "epfpcqdqer" },
            marks: { 1: "fn", square: "fpep" },
            correct: ["gqfrgohpfo", "gqfrgresgohpfo"],
            wrong: ["gqfrgohphofo", "gqfrgresgohphofo", "gqfrgreshpgo", "gqfrhpgo", "eoen", "eneo", "crfo", "fogo"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-17",
        chapterId: "beginner-level1",
        order: 41,
        title: { zh: "逃脱罗网 · 17/24", en: "Escape net · 17/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boeogocpdpeqfqgq", white: "embpepfpaqcqdqbrer" },
            marks: { 1: "go", square: "fpep" },
            correct: ["docofo"],
            wrong: ["docodnfo", "fofn", "gphp"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-18",
        chapterId: "beginner-level1",
        order: 42,
        title: { zh: "逃脱罗网 · 18/24", en: "Escape net · 18/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hneogodpgpfqdrfr", white: "ioepfphpeqgqhq" },
            marks: { 1: "dr", square: "eqfpep" },
            correct: ["fofndoendqcpcq", "dofodqcpcq"],
            wrong: ["fofndoendqcpercq", "fofndoeneres", "fofndoencpdq", "fofneres", "fofndqcq", "fofnendo", "dqcq", "eresgrfs", "eresdqcq", "eresfofn"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-19",
        chapterId: "beginner-level1",
        order: 43,
        title: { zh: "逃脱罗网 · 19/24", en: "Escape net · 19/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncnfnbobpcpdpfpeqfq", white: "codoeoepbqcqdqerfrgr" },
            marks: { 1: "fn", square: "epeodoco" },
            correct: ["fogogp"],
            wrong: ["fogoenem", "fogodndm", "enem", "dndm", "emen", "dmdn"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-20",
        chapterId: "beginner-level1",
        order: 44,
        title: { zh: "逃脱罗网 · 20/24", en: "Escape net · 20/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stone in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dogogpeqfq", white: "iofphpgqhq" },
            marks: { 1: "do", square: "fp" },
            correct: ["fofngn"],
            wrong: ["fofneoen", "fofneneo", "fofnhogn", "epdp", "eoen", "fnfo", "eneo"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-21",
        chapterId: "beginner-level1",
        order: 45,
        title: { zh: "逃脱罗网 · 21/24", en: "Escape net · 21/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emcndngncodpfpgpdqfqdrer", white: "clcmbnbodoeofobpcpepeqiqfr" },
            marks: { 1: "gn", square: "eqepfoeodo" },
            correct: ["gohohpgqgr"],
            wrong: ["gohohnfn", "gohofnfm", "endmgoho", "endmfnfm", "endmfmfn", "fnfm"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-22",
        chapterId: "beginner-level1",
        order: 46,
        title: { zh: "逃脱罗网 · 22/24", en: "Escape net · 22/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dogobpgpfqdrerfr", white: "epfpeqgqhq" },
            marks: { 1: "do", square: "eqfpep" },
            correct: ["eneofofngnfmho", "fofneneognfmho"],
            wrong: ["eneofofngnfmhndp", "eneofofngnfmgmdp", "eneofofngnfmdndp", "eneofofngnfmdpcp", "eneofofndpcp", "eneofofndqcq", "eneodpcp", "eneocpdp", "eneodqcq", "dqcq", "dpcp", "fofneneognfmhndp", "fofneneognfmhphohnio", "fofneneognfmhphoiohn", "eoenfnfodnemdpco"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-23",
        chapterId: "beginner-level1",
        order: 47,
        title: { zh: "逃脱罗网 · 23/24", en: "Escape net · 23/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfngncogocpgpbqdqeqgqdrfres", white: "eldoeofobpdpfpcqfqgrhr" },
            marks: { 1: "dn", square: "fqfpdpfoeodo" },
            correct: ["cnboen"],
            wrong: ["enem"],
        },
    },
    {
        id: "beginner-level1-escape-from-net-24",
        chapterId: "beginner-level1",
        order: 48,
        title: { zh: "逃脱罗网 · 24/24", en: "Escape net · 24/24" },
        instruction: { zh: "白先。黑棋意图用1号着法通过罩吃掉被标记的棋子。从这个罩中逃脱。", en: "White to play. Black intends to capture the marked stones in a net with move 1. Escape from this net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndpeqbrdrer", white: "emeoepcqdq" },
            marks: { 1: "br", square: "dqcq" },
            correct: ["cocpbp"],
            wrong: ["cpdo", "crbq", "bqcp"],
        },
    },
];

const bl1CalculateEscapeLevels: Level[] = [
    {
        id: "beginner-level1-bl1-calculate-escape-1",
        chapterId: "beginner-level1",
        order: 49,
        title: { zh: "计算逃脱 · 1/24", en: "Calculate Escape · 1/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "deeecfffcgfg", white: "cdcebfdfef" },
            marks: { triangle: "efdf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "deeecfffcgfg", white: "cdcebfdfef" },
                marks: { triangle: "efdf" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-2",
        chapterId: "beginner-level1",
        order: 50,
        title: { zh: "计算逃脱 · 2/24", en: "Calculate Escape · 2/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cefecfffdgegggfh", white: "bfdfefbgcgdheh" },
            marks: { triangle: "efdf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cefecfffdgegggfh", white: "bfdfefbgcgdheh" },
                marks: { triangle: "efdf" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-3",
        chapterId: "beginner-level1",
        order: 51,
        title: { zh: "计算逃脱 · 3/24", en: "Calculate Escape · 3/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ceahbhdh", white: "aibici" },
            marks: { triangle: "cibiai" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ceahbhdh", white: "aibici" },
                marks: { triangle: "cibiai" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-4",
        chapterId: "beginner-level1",
        order: 52,
        title: { zh: "计算逃脱 · 4/24", en: "Calculate Escape · 4/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cecfefcgdheh", white: "gcgedfgfdg" },
            marks: { triangle: "dgdf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cecfefcgdheh", white: "gcgedfgfdg" },
                marks: { triangle: "dgdf" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-5",
        chapterId: "beginner-level1",
        order: 53,
        title: { zh: "计算逃脱 · 5/24", en: "Calculate Escape · 5/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "fgdhfheifi", white: "efegehdi" },
            marks: { triangle: "di" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "fgdhfheifi", white: "efegehdi" },
                marks: { triangle: "di" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-6",
        chapterId: "beginner-level1",
        order: 54,
        title: { zh: "计算逃脱 · 6/24", en: "Calculate Escape · 6/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccddbedebfdfcgdg", white: "bccdcecfbgbhch" },
            marks: { triangle: "cfcecd" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccddbedebfdfcgdg", white: "bccdcecfbgbhch" },
                marks: { triangle: "cfcecd" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-7",
        chapterId: "beginner-level1",
        order: 55,
        title: { zh: "计算逃脱 · 7/24", en: "Calculate Escape · 7/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dedfbgcgegeh", white: "cdcecfdgdh" },
            marks: { triangle: "dhdg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dedfbgcgegeh", white: "cdcecfdgdh" },
                marks: { triangle: "dhdg" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-8",
        chapterId: "beginner-level1",
        order: 56,
        title: { zh: "计算逃脱 · 8/24", en: "Calculate Escape · 8/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cbdbcdddbeeecfff", white: "bcbdedfdcedege" },
            marks: { triangle: "dece" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cbdbcdddbeeecfff", white: "bcbdedfdcedege" },
                marks: { triangle: "dece" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-9",
        chapterId: "beginner-level1",
        order: 57,
        title: { zh: "计算逃脱 · 9/24", en: "Calculate Escape · 9/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dfefbgcgegbheh", white: "cdcecfdgchdh" },
            marks: { triangle: "dhchdg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dfefbgcgegbheh", white: "cdcecfdgchdh" },
                marks: { triangle: "dhchdg" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-10",
        chapterId: "beginner-level1",
        order: 58,
        title: { zh: "计算逃脱 · 10/24", en: "Calculate Escape · 10/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gcffgfegggeh", white: "dfefcgfgfh" },
            marks: { triangle: "fhfg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gcffgfegggeh", white: "dfefcgfgfh" },
                marks: { triangle: "fhfg" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-11",
        chapterId: "beginner-level1",
        order: 59,
        title: { zh: "计算逃脱 · 11/24", en: "Calculate Escape · 11/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "fccededfffcgegch", white: "cccdbebfcfdgdh" },
            marks: { triangle: "dhdg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "fccededfffcgegch", white: "cccdbebfcfdgdh" },
                marks: { triangle: "dhdg" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-12",
        chapterId: "beginner-level1",
        order: 60,
        title: { zh: "计算逃脱 · 12/24", en: "Calculate Escape · 12/24" },
        instruction: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dfffcgegchehci", white: "cecfdgdhfhdi" },
            marks: { triangle: "didhdg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。标记的棋子能逃跑吗？", en: "White to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dfffcgegchehci", white: "cecfdgdhfhdi" },
                marks: { triangle: "didhdg" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-13",
        chapterId: "beginner-level1",
        order: 61,
        title: { zh: "计算逃脱 · 13/24", en: "Calculate Escape · 13/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bcccddcedecg", white: "bbacdcecbdcd" },
            marks: { triangle: "ccbc" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bcccddcedecg", white: "bbacdcecbdcd" },
                marks: { triangle: "ccbc" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-14",
        chapterId: "beginner-level1",
        order: 62,
        title: { zh: "计算逃脱 · 14/24", en: "Calculate Escape · 14/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gchcedfdefgg", white: "ecfcddgdeege" },
            marks: { triangle: "fded" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gchcedfdefgg", white: "ecfcddgdeege" },
                marks: { triangle: "fded" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-15",
        chapterId: "beginner-level1",
        order: 63,
        title: { zh: "计算逃脱 · 15/24", en: "Calculate Escape · 15/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ecgcbdcddfef", white: "cefecfffdgeg" },
            marks: { triangle: "efdf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ecgcbdcddfef", white: "cefecfffdgeg" },
                marks: { triangle: "efdf" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-16",
        chapterId: "beginner-level1",
        order: 64,
        title: { zh: "计算逃脱 · 16/24", en: "Calculate Escape · 16/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "eefeffcgdggggh", white: "edfddegegfegfg" },
            marks: { triangle: "fffeee" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "eefeffcgdggggh", white: "edfddegegfegfg" },
                marks: { triangle: "fffeee" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-17",
        chapterId: "beginner-level1",
        order: 65,
        title: { zh: "计算逃脱 · 17/24", en: "Calculate Escape · 17/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bdcdddbfcgeggg", white: "bcccecbecedeee" },
            marks: { triangle: "ddcdbd" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bdcdddbfcgeggg", white: "bcccecbecedeee" },
                marks: { triangle: "ddcdbd" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-18",
        chapterId: "beginner-level1",
        order: 66,
        title: { zh: "计算逃脱 · 18/24", en: "Calculate Escape · 18/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cbccddeddecfcg", white: "dceccdceeedfef" },
            marks: { triangle: "deeddd" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cbccddeddecfcg", white: "dceccdceeedfef" },
                marks: { triangle: "deeddd" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-19",
        chapterId: "beginner-level1",
        order: 67,
        title: { zh: "计算逃脱 · 19/24", en: "Calculate Escape · 19/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gbccdcgcedfdfecg", white: "ecfcddgdbecegeff" },
            marks: { triangle: "fefded" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gbccdcgcedfdfecg", white: "ecfcddgdbecegeff" },
                marks: { triangle: "fefded" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-20",
        chapterId: "beginner-level1",
        order: 68,
        title: { zh: "计算逃脱 · 20/24", en: "Calculate Escape · 20/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "deeebfcfdfegdhehdi", white: "efffbgcgdgfgfheifi" },
            marks: { triangle: "diehdheg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "deeebfcfdfegdhehdi", white: "efffbgcgdgfgfheifi" },
                marks: { triangle: "diehdheg" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-21",
        chapterId: "beginner-level1",
        order: 69,
        title: { zh: "计算逃脱 · 21/24", en: "Calculate Escape · 21/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "fbgcedfdeedfffgfdgehhh", white: "dcddgddefegeefhfegfggh" },
            marks: { triangle: "gfff" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "fbgcedfdeedfffgfdgehhh", white: "dcddgddefegeefhfegfggh" },
                marks: { triangle: "gfff" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-22",
        chapterId: "beginner-level1",
        order: 70,
        title: { zh: "计算逃脱 · 22/24", en: "Calculate Escape · 22/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cbccdddeeecfffcg", white: "dcfccdcefedfefeh" },
            marks: { triangle: "eededd" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cbccdddeeecfffcg", white: "dcfccdcefedfefeh" },
                marks: { triangle: "eededd" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-23",
        chapterId: "beginner-level1",
        order: 71,
        title: { zh: "计算逃脱 · 23/24", en: "Calculate Escape · 23/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dbdcgchchegf", white: "fbgbecgdhdfe" },
            marks: { triangle: "hcgc" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dbdcgchchegf", white: "fbgbecgdhdfe" },
                marks: { triangle: "hcgc" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-escape-24",
        chapterId: "beginner-level1",
        order: 72,
        title: { zh: "计算逃脱 · 24/24", en: "Calculate Escape · 24/24" },
        instruction: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gcgfhfegfg", white: "fdgeffgghg" },
            marks: { triangle: "hfgf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。标记的棋子能逃跑吗？", en: "Black to play. Can the marked stones escape?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gcgfhfegfg", white: "fdgeffgghg" },
                marks: { triangle: "hfgf" },
            },
        },
    },
];

const bl1CalculateLadderLevels: Level[] = [
    {
        id: "beginner-level1-bl1-calculate-ladder-1",
        chapterId: "beginner-level1",
        order: 73,
        title: { zh: "征子 · 1/8", en: "Ladder · 1/8" },
        instruction: { zh: "如果你想用征子吃子，必须注意征子不利的棋子。黑棋想用征子吃掉被标记的棋子，但这个征子不会成功，因为另一颗白棋棋子是征子不利的棋子。尝试用征子吃掉被标记的棋子，看看会发生什么。", en: "If you want to capture in a ladder, you have to look out for a ladder-breaker. Black wants to capture the marked stone in a ladder, but this ladder will not work, because the other white stone is a ladder-breaker. Try to capture the marked stone in a ladder and see what happens." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edfeff", white: "eecg" },
            marks: { triangle: "ee" },
            correct: ["deefegdfcfdg"],
            wrong: ["efde"],
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-2",
        chapterId: "beginner-level1",
        order: 74,
        title: { zh: "征子 · 2/8", en: "Ladder · 2/8" },
        instruction: { zh: "有时你可以通过从正确的一侧开始来避免征子不利。黑棋可以选择在A或B点落子。通过选择正确的一侧，用征子吃掉被标记的棋子。", en: "Sometimes you can avoid the ladder-breaker, by starting at the correct side. Black can choose between playing at A or B. Capture the marked stones in a ladder by choosing the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edfeffeg", white: "eeefcg" },
            marks: { triangle: "eeef", A: "de", B: "df" },
            correct: ["df"],
            wrong: ["de"],
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-3",
        chapterId: "beginner-level1",
        order: 75,
        title: { zh: "征子 · 3/8", en: "Ladder · 3/8" },
        instruction: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ddedfegeeffg", white: "ecfdgddeeecg" },
            marks: { triangle: "eede" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ddedfegeeffg", white: "ecfdgddeeecg" },
                marks: { triangle: "eede" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-4",
        chapterId: "beginner-level1",
        order: 76,
        title: { zh: "征子 · 4/8", en: "Ladder · 4/8" },
        instruction: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ddedfegeef", white: "fcfddeeedh" },
            marks: { triangle: "eede" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ddedfegeef", white: "fcfddeeedh" },
                marks: { triangle: "eede" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-5",
        chapterId: "beginner-level1",
        order: 77,
        title: { zh: "征子 · 5/8", en: "Ladder · 5/8" },
        instruction: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ddedfegeef", white: "fcfddeeeeh" },
            marks: { triangle: "eede" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ddedfegeef", white: "fcfddeeeeh" },
                marks: { triangle: "eede" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-6",
        chapterId: "beginner-level1",
        order: 78,
        title: { zh: "征子 · 6/8", en: "Ladder · 6/8" },
        instruction: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cedeeefedgeg", white: "gchedfefhfgg" },
            marks: { triangle: "efdf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cedeeefedgeg", white: "gchedfefhfgg" },
                marks: { triangle: "efdf" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-7",
        chapterId: "beginner-level1",
        order: 79,
        title: { zh: "征子 · 7/8", en: "Ladder · 7/8" },
        instruction: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ddcebfffegdh", white: "fddecfdfefdg" },
            marks: { triangle: "dgefdfcfde" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ddcebfffegdh", white: "fddecfdfefdg" },
                marks: { triangle: "dgefdfcfde" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-calculate-ladder-8",
        chapterId: "beginner-level1",
        order: 80,
        title: { zh: "征子 · 8/8", en: "Ladder · 8/8" },
        instruction: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "deeecfff", white: "dfeffhgh" },
            marks: { triangle: "efdf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑先。你能用有效的征子吃掉标记的棋子吗？", en: "Black to play. Can you capture the marked stones in a ladder that works?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "deeecfff", white: "dfeffhgh" },
                marks: { triangle: "efdf" },
            },
        },
    },
];

const bl1LadderLevels: Level[] = [
    {
        id: "beginner-level1-bl1-ladder-1",
        chapterId: "beginner-level1",
        order: 81,
        title: { zh: "征子 · 1/12", en: "Ladder · 1/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eecfffeg", white: "ccdddfef" },
            marks: { triangle: "efdf" },
            correct: ["dedgdhcgbgchbh", "dedgdhcgbgchcibhah", "dedgdhcgbgchcibhbi", "dedgcgdhehchbh"],
            wrong: ["dedgdhcgchbgbfbhbiehfgdi", "dedgdhcgchbgbhbfcebebdcd", "dgde"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-2",
        chapterId: "beginner-level1",
        order: 82,
        title: { zh: "征子 · 2/12", en: "Ladder · 2/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eegfhffg", white: "fdgeheff" },
            marks: { triangle: "ff" },
            correct: ["feefdfegehdgcgdhch", "feefdfegehdgcgdhdichbh", "feefdfegdgehfhdhch"],
            wrong: ["feefdfegehdgcgdhdichcibhbgfh", "feefdfegehdgdhcgcfggfhhg", "feefdfegdgehdhfhggghhhifhghi", "feefegdfdecf", "feefegdfdgdeedec", "effe"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-3",
        chapterId: "beginner-level1",
        order: 83,
        title: { zh: "征子 · 3/12", en: "Ladder · 3/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eceddefedfffdg", white: "ebdcddceeecfefeg" },
            marks: { triangle: "egefee" },
            correct: ["ehfgggfhgh", "ehfgggfhfighhh", "fgehdhfhgh"],
            wrong: ["ehfgggfhfighgihhhgdh", "ehfgggfhfighgihhhidh", "ehfgfhggghhg", "ehfgfhgggfghhgdhcgchbgei", "fgehfhdhcgbgchbh"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-4",
        chapterId: "beginner-level1",
        order: 84,
        title: { zh: "征子 · 4/12", en: "Ladder · 4/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecdeeecfffgfdg", white: "cefegedfefhfeg" },
            marks: { triangle: "egefdf" },
            correct: ["ehfgggfhgh"],
            wrong: ["ehfgggfhfighhhhg", "ehfgggfhfighhghh", "ehfgfhgg", "fgehfhcgbfchbgbhahbeaeagafad", "fgehfhcgbfchbgbhahbebiaf", "fgehfhcgbfchbgbhbedi", "fgehdhfhgghgghhh"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-5",
        chapterId: "beginner-level1",
        order: 85,
        title: { zh: "征子 · 5/12", en: "Ladder · 5/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfffdgegfh", white: "dfefhffggg" },
            marks: { triangle: "efdf" },
            correct: ["eededdcebecdccbdbc", "eededdcebecdccbdadbcbb"],
            wrong: ["eededdcebecdccbdadbcacbbcbed", "eededdcebecdccbdadbcacbbabed", "eededdcebecdbdccdcfe", "eededdcebecdbdccbcfe", "eededdcecdbebdfe", "eededdcecdbebffe", "eedeceddedfe", "eedeceddcdfe", "deeefeedddfdgegdhehd", "deeefeedfdec", "deeeedfe"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-6",
        chapterId: "beginner-level1",
        order: 86,
        title: { zh: "征子 · 6/12", en: "Ladder · 6/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdhdgegffgfh", white: "gcgdfeffgggh" },
            marks: { triangle: "fffe" },
            correct: ["eeefdfegehdgcgdhch", "eeefdfegehdgcgdhdichbh"],
            wrong: ["eeefdfegehdgcgdhdichcibhbgde", "eeefdfegehdgcgdhdichcibhbide", "eeefdfegehdgdhcgcfed", "eeefdfegehdgdhcgchde", "eeefdfegdgeh", "eeefegdfdedgdhfiehchcgcfbgdi", "eeefegdfdedgdhfiehchcfcg", "eeefegdfdedgcffiehdh", "eeefegdfdged", "efeedeedfcfbecdddccddfccebdb", "efeedeedfcfbecdddccddfcccbdb", "efeedeedfcfbecdddccddfccdbcb", "efeedeedfcfbecdddccddfccdbhchecb", "efeedeedfcfbecdddccdceegdfeh", "efeedeedfcfbecddcddcebdb", "efeeeddedfddecdcebegehdgcfdh", "efeeeddedfddecdcebegdgeh", "efeeeddedfddecdcdbeb", "efeeeddedfdddcec", "efeeeddedddfegdgdhfiehch"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-7",
        chapterId: "beginner-level1",
        order: 87,
        title: { zh: "征子 · 7/12", en: "Ladder · 7/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdbeeecfdfeffg", white: "dbfbddeddefeff" },
            marks: { triangle: "fffe" },
            correct: ["gegfhfggghhghh", "gegfhfggghhgighhih", "gegfhfggghhgighhhi", "gfgegdhehdhfgghghh"],
            wrong: ["gegfhfgghgghfhgd", "gegfhfgghgghhhgd", "gegfgghfhegdfcgc", "gegfgghfhggd", "gfgehegdfcgc", "gfgegdhehfhdhcgc", "gfgegdhehfhdiegc"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-8",
        chapterId: "beginner-level1",
        order: 88,
        title: { zh: "征子 · 8/12", en: "Ladder · 8/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gbgcfdeegefg", white: "dbfbddedfeff" },
            marks: { triangle: "fffe" },
            correct: ["efgfhfggghhghh", "efgfhfggghhgighhih", "efgfhfggghhgighhhi", "efgfgghfhghegdegdgehdf", "efgfgghfhehghh"],
            wrong: ["efgfhfgghgghfhhhihhegdif", "efgfhfgghgghfhhhgihegdif", "efgfhfgghgghhhfhegehdhdgdfcgcfch", "efgfgghfhghegdegehdg", "gfefdedfcecf"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-9",
        chapterId: "beginner-level1",
        order: 89,
        title: { zh: "征子 · 9/12", en: "Ladder · 9/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gdcefegfggfh", white: "fffghgghihhi" },
            marks: { triangle: "fgff" },
            correct: ["egefdfeeed"],
            wrong: ["egefdfeedeedddeh", "egefdfeedeedfdeh", "egefdfeedeedeceh", "egefeedfdgeh", "egefeedfdeeh", "egefeedfcfeh", "efegdgeh", "efegehdgdfdh", "efegehdgdhchcgdfeecfbgbfbhbecdbdbccccbdc", "efegehdgdhchcgdfeecfbgbfbhbecdbdbcccbbcbadaeacba", "efegehdgdhchcgdfeecfbgbfbhbecdbdbcccbbcbadaeabacdeba"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-10",
        chapterId: "beginner-level1",
        order: 90,
        title: { zh: "征子 · 10/12", en: "Ladder · 10/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdgegffgfh", white: "dcfeffhfggghihhi" },
            marks: { triangle: "fffe" },
            correct: ["eeefdfegehdgcgdhch", "eeefdfegehdgcgdhdichbh"],
            wrong: ["eeefdfegehdgcgdhdichcibhbgde", "eeefdfegehdgcgdhdichcibhbide", "eeefdfegehdgdhcgcfeddegd", "eeefdfegehdgdhcgchde", "eeefdfegdgeh", "eeefegdfdegdheedfcce", "eeefegdfdggdheed", "efeedeed", "efeeeddedddfegdgdhfiehch", "efeeeddedfdd"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-11",
        chapterId: "beginner-level1",
        order: 91,
        title: { zh: "征子 · 11/12", en: "Ladder · 11/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecdeeecfffgf", white: "cefegedfefhf" },
            marks: { triangle: "efdf" },
            correct: ["dgegehfgggfhgh"],
            wrong: ["dgegehfgggfhfighhhhg", "dgegehfgggfhfighhghh", "dgegehfgfhgg", "dgegfgehfhcg", "dgegfgehdhfhgghgghhh", "egdgcgdhehfgggfhcheighhh", "egdgcgdhchehfgfhgghgghhh", "egdgdhcgbffg"],
        },
    },
    {
        id: "beginner-level1-bl1-ladder-12",
        chapterId: "beginner-level1",
        order: 92,
        title: { zh: "征子 · 12/12", en: "Ladder · 12/12" },
        instruction: { zh: "黑先。用征子吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dcfcedfeffeg", white: "fdgdeeeffggg" },
            marks: { triangle: "efee" },
            correct: ["dfdece"],
            wrong: ["dfdeddcecfge", "dfdeddcecdgf", "dedfcfdgehgf", "dedfdgcfcegf", "dedfdgcfcggf"],
        },
    },
];

const bl1DoubleAtariLevels: Level[] = [
    {
        id: "beginner-level1-bl1-double-atari-1",
        chapterId: "beginner-level1",
        order: 93,
        title: { zh: "双打吃 · 1/12", en: "Double-Atari · 1/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcfegeefdg", white: "ffegggdh" },
            correct: ["df"],
            wrong: ["eedf", "cgdf"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-2",
        chapterId: "beginner-level1",
        order: 94,
        title: { zh: "双打吃 · 2/12", en: "Double-Atari · 2/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eedfegggfhgh", white: "eddeeffffg" },
            correct: ["dg"],
            wrong: ["fedg", "cfdg", "ehdg"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-3",
        chapterId: "beginner-level1",
        order: 95,
        title: { zh: "双打吃 · 3/12", en: "Double-Atari · 3/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "edfdgddgegggfhhh", white: "gedfefffcgfggh" },
            correct: ["eh"],
            wrong: ["figi", "gfgi", "hggi", "dheh"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-4",
        chapterId: "beginner-level1",
        order: 96,
        title: { zh: "双打吃 · 4/12", en: "Double-Atari · 4/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dccdcfbgcgegfgbhdh", white: "gcgedfefffdgggch" },
            correct: ["eh"],
            wrong: ["fheh", "dieh"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-5",
        chapterId: "beginner-level1",
        order: 97,
        title: { zh: "双打吃 · 5/12", en: "Double-Atari · 5/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccecbdcecfbgdgbhdhbi", white: "bccddddedfffcgchfh" },
            correct: ["be"],
            wrong: ["bfbe", "adbe", "dcbe", "cbbe"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-6",
        chapterId: "beginner-level1",
        order: 98,
        title: { zh: "双打吃 · 6/12", en: "Double-Atari · 6/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bcccecbdcedfbgdgch", white: "cdddfddeefegdheh" },
            correct: ["cf"],
            wrong: ["becf", "cgcf"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-7",
        chapterId: "beginner-level1",
        order: 99,
        title: { zh: "双打吃 · 7/12", en: "Double-Atari · 7/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bdefffcgeggghgbhdh", white: "deeefegedfgfdgch" },
            correct: ["eh"],
            wrong: ["bgci", "cfci", "fgfh", "dieh"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-8",
        chapterId: "beginner-level1",
        order: 100,
        title: { zh: "双打吃 · 8/12", en: "Double-Atari · 8/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgecgeghgdhfhci", white: "fdcfdfeffffgch" },
            correct: ["dg"],
            wrong: ["ehei", "diei", "bibh", "bgdg"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-9",
        chapterId: "beginner-level1",
        order: 101,
        title: { zh: "双打吃 · 9/12", en: "Double-Atari · 9/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dfefffcggghgchehfhghdihi", white: "deeefecfgfhfbgfgbhbici" },
            correct: ["dg"],
            wrong: ["dhdg", "egdg", "eidh"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-10",
        chapterId: "beginner-level1",
        order: 102,
        title: { zh: "双打吃 · 10/12", en: "Double-Atari · 10/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdgebfdfefffcgfgbhehgh", white: "becedeeefecfgfbgggfhhh" },
            correct: ["dg"],
            wrong: ["chag", "egdg", "afdh", "giag"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-11",
        chapterId: "beginner-level1",
        order: 103,
        title: { zh: "双打吃 · 11/12", en: "Double-Atari · 11/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgebgcgfgahchehghdi", white: "bdeebfcfagdgegdhbi" },
            correct: ["ci"],
            wrong: ["eificiaf", "eifibhaf", "bhaf", "aiaf", "fhficiaf"],
        },
    },
    {
        id: "beginner-level1-bl1-double-atari-12",
        chapterId: "beginner-level1",
        order: 104,
        title: { zh: "双打吃 · 12/12", en: "Double-Atari · 12/12" },
        instruction: { zh: "白先。下出一步好的双打吃。", en: "White to play. Play a good double-atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecgcgdgedfffcgdgfgggbhehhhcigi", white: "deeefebfcfgfhfbghgchdhfhgh" },
            correct: ["eg", "ef"],
            wrong: ["fiei", "diei", "bidi", "ahdi", "ihfi", "eidi", "hifi"],
        },
    },
];

const bl1SnapbackLevels: Level[] = [
    {
        id: "beginner-level1-bl1-snapback-1",
        chapterId: "beginner-level1",
        order: 105,
        title: { zh: "倒扑 · 1/12", en: "Snapback · 1/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccecfffgfbgdgfgeh", white: "eefegedfhfggfhgh" },
            marks: { triangle: "fggfff" },
            correct: ["eg"],
            wrong: ["efeg"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-2",
        chapterId: "beginner-level1",
        order: 106,
        title: { zh: "倒扑 · 2/12", en: "Snapback · 2/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbddcebfdfefffhfbggghg", white: "ecedfegecfgfcgdgegfg" },
            marks: { triangle: "ffefdf" },
            correct: ["de"],
            wrong: ["eede"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-3",
        chapterId: "beginner-level1",
        order: 107,
        title: { zh: "倒扑 · 3/12", en: "Snapback · 3/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ffegfghgchdhghihhi", white: "fegedfefhfdgehfh" },
            marks: { triangle: "fgegff" },
            correct: ["gg"],
            wrong: ["gfgg"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-4",
        chapterId: "beginner-level1",
        order: 108,
        title: { zh: "倒扑 · 4/12", en: "Snapback · 4/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddeddefegedfgfbgcgggdheh", white: "bcdceccdfdgdcecfffdgeg" },
            marks: { triangle: "dfdeeddd" },
            correct: ["ee"],
            wrong: ["efee"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-5",
        chapterId: "beginner-level1",
        order: 109,
        title: { zh: "倒扑 · 5/12", en: "Snapback · 5/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gdhdideefeiehfgghgehfh", white: "geheffgfcgfgghhhihgi" },
            marks: { triangle: "hggghf" },
            correct: ["if"],
            wrong: ["igif"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-6",
        chapterId: "beginner-level1",
        order: 110,
        title: { zh: "倒扑 · 6/12", en: "Snapback · 6/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "acbcccdcadbebfag", white: "bdcdcecfbgcgah" },
            marks: { triangle: "agbfbe" },
            correct: ["ae"],
            wrong: ["afae"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-7",
        chapterId: "beginner-level1",
        order: 111,
        title: { zh: "倒扑 · 7/12", en: "Snapback · 7/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ffgfhfifighhgihi", white: "cgegfggghgghfi" },
            marks: { triangle: "higihh" },
            correct: ["ih"],
            wrong: ["iiih"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-8",
        chapterId: "beginner-level1",
        order: 112,
        title: { zh: "倒扑 · 8/12", en: "Snapback · 8/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bcbdcedefeafbf", white: "adcfagbgcgfg" },
            marks: { triangle: "bfaf" },
            correct: ["be"],
            wrong: ["aebe"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-9",
        chapterId: "beginner-level1",
        order: 113,
        title: { zh: "倒扑 · 9/12", en: "Snapback · 9/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fcgchcicidhehfhg", white: "gdhdgegfggighh" },
            marks: { triangle: "hghfhe" },
            correct: ["ie"],
            wrong: ["ifie"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-10",
        chapterId: "beginner-level1",
        order: 114,
        title: { zh: "倒扑 · 10/12", en: "Snapback · 10/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dcddceeeefgfdgfggg", white: "edfecfffcgegdheh" },
            marks: { triangle: "dgefee" },
            correct: ["de"],
            wrong: ["dfde"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-11",
        chapterId: "beginner-level1",
        order: 115,
        title: { zh: "倒扑 · 11/12", en: "Snapback · 11/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdfehefffgghhhfi", white: "fdeeefhfegggehfh" },
            marks: { triangle: "fgfffe" },
            correct: ["ge"],
            wrong: ["gfge"],
        },
    },
    {
        id: "beginner-level1-bl1-snapback-12",
        chapterId: "beginner-level1",
        order: 116,
        title: { zh: "倒扑 · 12/12", en: "Snapback · 12/12" },
        instruction: { zh: "白先。用倒扑吃掉被标记的棋子。", en: "White to play. Capture the marked stones with a snapback." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dedfcgegchehcidiei", white: "cfefbgfgbhfhbifi" },
            marks: { triangle: "eidiciehchegcg" },
            correct: ["dg"],
            wrong: ["dhdg"],
        },
    },
];

const bl1NetLevels: Level[] = [
    {
        id: "beginner-level1-bl1-net-1",
        chapterId: "beginner-level1",
        order: 117,
        title: { zh: "罩 · 1/24", en: "Net · 1/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dgcggfffefhecegddd", white: "hgggfgeghfdfeedebd" },
            marks: { triangle: "dfeede" },
            correct: ["edfege"],
            wrong: ["edfefdge", "fdcfbfcdbeeddcec", "fdcfbfcdbeedecdc", "fdcfbfcdedbe", "fdcfedbf", "feedecfdgefc", "cffdfcge", "cffdedfegefc"],
        },
    },
    {
        id: "beginner-level1-bl1-net-2",
        chapterId: "beginner-level1",
        order: 118,
        title: { zh: "罩 · 2/24", en: "Net · 2/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gdceheefffgfcgdg", white: "bddedfhfegfggghg" },
            marks: { triangle: "dfde" },
            correct: ["ddeeed"],
            wrong: ["edddcddc", "eddddccd", "eedd", "cfdd"],
        },
    },
    {
        id: "beginner-level1-bl1-net-3",
        chapterId: "beginner-level1",
        order: 119,
        title: { zh: "罩 · 3/24", en: "Net · 3/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stone in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gdheefffgfcgdg", white: "bddfhfegfggghg" },
            marks: { triangle: "df" },
            correct: ["cededdeeed"],
            wrong: ["decfbfce", "cfdecddddcceccbcbebf", "ddce"],
        },
    },
    {
        id: "beginner-level1-bl1-net-4",
        chapterId: "beginner-level1",
        order: 120,
        title: { zh: "罩 · 4/24", en: "Net · 4/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edgdffgfdgegbhchdh", white: "beeeefbgfggghgehfi" },
            marks: { triangle: "efee" },
            correct: ["defege"],
            wrong: ["defefdgehfhe", "fede", "dfdececdcfdd", "cddddefddcfefcgehfhe", "cddddefddcfegefc", "cddddcfdecfegefc", "cddddcfdecfefcgehfhe"],
        },
    },
    {
        id: "beginner-level1-bl1-net-5",
        chapterId: "beginner-level1",
        order: 121,
        title: { zh: "罩 · 5/24", en: "Net · 5/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stone in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gdffgfdgegbhchdh", white: "beefbgfggghgehfi" },
            marks: { triangle: "ef" },
            correct: ["deeeed"],
            wrong: ["dddecdce", "eddeddcd", "eedfcfdeddce", "eedfcfdecedd", "eedfdecf", "dfee"],
        },
    },
    {
        id: "beginner-level1-bl1-net-6",
        chapterId: "beginner-level1",
        order: 122,
        title: { zh: "罩 · 6/24", en: "Net · 6/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ccecbfcfdfefdgehfhgh", white: "gehebgcgegfgbhdhhhci" },
            marks: { triangle: "fgeg" },
            correct: ["gf"],
            wrong: ["ggff", "ffgghggf", "ffgggfhghfif"],
        },
    },
    {
        id: "beginner-level1-bl1-net-7",
        chapterId: "beginner-level1",
        order: 123,
        title: { zh: "罩 · 7/24", en: "Net · 7/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "decfgfdgeg", white: "fcdfefgghg" },
            marks: { triangle: "efdf" },
            correct: ["fe"],
            wrong: ["ffeeedfegefd", "eefffefg", "eefffgfefdge", "fdfffgge"],
        },
    },
    {
        id: "beginner-level1-bl1-net-8",
        chapterId: "beginner-level1",
        order: 124,
        title: { zh: "罩 · 8/24", en: "Net · 8/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bcccgcdedfdgggehfh", white: "bdgecfefcgegfgchdh" },
            marks: { triangle: "fgegef" },
            correct: ["fe"],
            wrong: ["ffeeedfe", "ffeefeed", "eeffgffe", "eefffegf"],
        },
    },
    {
        id: "beginner-level1-bl1-net-9",
        chapterId: "beginner-level1",
        order: 125,
        title: { zh: "罩 · 9/24", en: "Net · 9/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edcecfdfegfg", white: "eeefbgcgdgeh" },
            marks: { triangle: "efee" },
            correct: ["fe", "fd"],
            wrong: ["defe", "fffegefdfcgdhdgfhegg"],
        },
    },
    {
        id: "beginner-level1-bl1-net-10",
        chapterId: "beginner-level1",
        order: 126,
        title: { zh: "罩 · 10/24", en: "Net · 10/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dbdddedfgfhfegfgdh", white: "bcgchdceeecfefcgdg" },
            marks: { triangle: "efee" },
            correct: ["fd"],
            wrong: ["edfegefd", "feedecfd", "fffd"],
        },
    },
    {
        id: "beginner-level1-bl1-net-11",
        chapterId: "beginner-level1",
        order: 127,
        title: { zh: "罩 · 11/24", en: "Net · 11/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bdcebfbgfgcheh", white: "fdgecfdfcggggh" },
            marks: { triangle: "cgdfcf" },
            correct: ["ee"],
            wrong: ["efdeddee", "efdeeedd", "deefffee", "deefeeff", "dgee"],
        },
    },
    {
        id: "beginner-level1-bl1-net-12",
        chapterId: "beginner-level1",
        order: 128,
        title: { zh: "罩 · 12/24", en: "Net · 12/24" },
        instruction: { zh: "黑先。用罩吃掉被标记的棋子。", en: "Black to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cbbcbddebfdfdgfgehfh", white: "dcfcgdefbgcgegbhdhci" },
            marks: { triangle: "egef" },
            correct: ["fe"],
            wrong: ["eeffgffe", "eefffegf", "ffeeedfe", "ffeefeed"],
        },
    },
    {
        id: "beginner-level1-bl1-net-13",
        chapterId: "beginner-level1",
        order: 129,
        title: { zh: "罩 · 13/24", en: "Net · 13/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnboepbqfqhqfr", white: "gmfohofpdqeq" },
            correct: ["do"],
            wrong: ["dndo", "eodpcpdo", "eodpdocp"],
        },
    },
    {
        id: "beginner-level1-bl1-net-14",
        chapterId: "beginner-level1",
        order: 130,
        title: { zh: "罩 · 14/24", en: "Net · 14/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gnbpepcqdqcrerds", white: "cmcnbocpdpeqfq" },
            correct: ["fodocoeoen"],
            wrong: ["fodocoeofnfpgpgqenfr", "fodocoeofnfpgpgqdnfr", "fodocoeofnfpgpgqfrgr", "fodoeoco", "fnfpgpgqfrgr", "fnfpgpgqfofr", "fnfpgpgqeofr", "fnfpgqgo", "enfo", "eofpgpfo", "fpeofoen"],
        },
    },
    {
        id: "beginner-level1-bl1-net-15",
        chapterId: "beginner-level1",
        order: 131,
        title: { zh: "罩 · 15/24", en: "Net · 15/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmeocpdpgpgq", white: "bnencobpcqdqeq" },
            correct: ["foepfp"],
            wrong: ["doepfofp", "doepfpfofqgn", "epdofodn", "epdodnfo", "fpfo"],
        },
    },
    {
        id: "beginner-level1-bl1-net-16",
        chapterId: "beginner-level1",
        order: 132,
        title: { zh: "罩 · 16/24", en: "Net · 16/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cogoepgpbqfqergrfs", white: "fngnfofpdqeqdrds" },
            correct: ["do"],
            wrong: ["eodp", "dpeodoenemdncndmcmdl", "dpeodoenemdncndmdlcm", "dpeodoenemdndmcn", "dpeodoendnem"],
        },
    },
    {
        id: "beginner-level1-bl1-net-17",
        chapterId: "beginner-level1",
        order: 133,
        title: { zh: "罩 · 17/24", en: "Net · 17/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hoepbqcqdqerfr", white: "cncpdpeqfqgq" },
            correct: ["foeoen", "eofpgo"],
            wrong: ["foeodoen", "foeofpen", "eofpgpfofngo", "eofpfogphpgo", "eofpfogpgohp", "fpeo"],
        },
    },
    {
        id: "beginner-level1-bl1-net-18",
        chapterId: "beginner-level1",
        order: 134,
        title: { zh: "罩 · 18/24", en: "Net · 18/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmcpdpcqgqdrerfrhr", white: "cobpbqdqeqfqbrcr" },
            correct: ["eo"],
            wrong: ["doepfpeoenfogogp", "doepfpeoenfogpgohpho", "epdodneo", "enfp", "fofp"],
        },
    },
    {
        id: "beginner-level1-bl1-net-19",
        chapterId: "beginner-level1",
        order: 135,
        title: { zh: "罩 · 19/24", en: "Net · 19/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmcngnepgpfqgqer", white: "flfmfofpdqeqdr" },
            correct: ["do"],
            wrong: ["dpeoendo", "eodpcpdo", "dndocoendmfn", "coeoenfn", "coeofndn"],
        },
    },
    {
        id: "beginner-level1-bl1-net-20",
        chapterId: "beginner-level1",
        order: 136,
        title: { zh: "罩 · 20/24", en: "Net · 20/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmhndoeobpcpdqcreres", white: "cmdnbocodpepgpeqfr" },
            correct: ["fnfogo"],
            wrong: ["enfogofn", "enfofngo", "foenemfn", "fmfn"],
        },
    },
    {
        id: "beginner-level1-bl1-net-21",
        chapterId: "beginner-level1",
        order: 137,
        title: { zh: "罩 · 21/24", en: "Net · 21/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emfmgnhocpdpephp", white: "dncobpcqdqeqgq" },
            correct: ["fofpgpeoen"],
            wrong: ["fofpgpeofnen", "fofpgpeofqen", "fofpeogp", "fofpfqgp", "fpeoenfo", "eofpgpfo", "eofpfogp", "enfo"],
        },
    },
    {
        id: "beginner-level1-bl1-net-22",
        chapterId: "beginner-level1",
        order: 138,
        title: { zh: "罩 · 22/24", en: "Net · 22/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmepbqfqgqcrdrer", white: "fofphpcqdqeqhq" },
            correct: ["do"],
            wrong: ["dpeoendo", "eodpcpdodnco", "dncp", "cocp"],
        },
    },
    {
        id: "beginner-level1-bl1-net-23",
        chapterId: "beginner-level1",
        order: 139,
        title: { zh: "罩 · 23/24", en: "Net · 23/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmbnhnbodocpcqcrdr", white: "bmcmcncodpdqfqer" },
            correct: ["eneofoepeq", "eodnemepeqenfnfodmeogo", "fneneodnem", "fnepeqenemfodneogo", "fnepeqeofo", "fnepeqfogoenemfmdngnfp", "fnepeqfoeneogo"],
            wrong: ["eneofoepfpeq", "dneo", "eodndmenfnemelfm", "eodnendmdlemfmelflek", "eodnendmemdl", "emepeqfo", "fnenemfogofmgngp", "fnenemfodneogofmgngp"],
        },
    },
    {
        id: "beginner-level1-bl1-net-24",
        chapterId: "beginner-level1",
        order: 140,
        title: { zh: "罩 · 24/24", en: "Net · 24/24" },
        instruction: { zh: "白先。用罩吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmgncohodpepbqcqbrdr", white: "bmcndnbobpcpdqeqfq" },
            correct: ["fo"],
            wrong: ["dofo", "fpeofnfo", "fpeoenfo", "fpeofoen", "eofpgpfo", "fnfo", "enfo", "gpfo"],
        },
    },
];

const bl1ChaseDownLevels: Level[] = [
    {
        id: "beginner-level1-bl1-chase-down-1",
        chapterId: "beginner-level1",
        order: 141,
        title: { zh: "追击 · 1/13", en: "Chase Down · 1/13" },
        instruction: { zh: "有时可以通过将棋子与其他棋子隔离来吃掉它们。你可以追击这些孤立的棋子，直到它们无处可逃。黑先。通过追击吃掉被标记的孤立棋子。", en: "Sometimes it is possible to capture stones by isolating them from other stones. You can chase these isolated stones down until there is nowhere to go for them. Black to play. Capture the marked isolated stone by chasing it down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqfp", white: "cpcqeoepfq" },
            marks: { triangle: "fq", cross: "gq" },
            correct: ["gqfrgrerdr"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-2",
        chapterId: "beginner-level1",
        order: 142,
        title: { zh: "追击 · 2/13", en: "Chase Down · 2/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cogocpgpipdqeqfq", white: "fndpepfpaqbqcqgqgr" },
            correct: ["foeoen"],
            wrong: ["doen", "hqfr", "frdr", "crfr"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-3",
        chapterId: "beginner-level1",
        order: 143,
        title: { zh: "追击 · 3/13", en: "Chase Down · 3/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fogoepfpdqdrds", white: "cncpdpgpipeqgqbreres" },
            correct: ["fqfrgr"],
            wrong: ["cqbq"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-4",
        chapterId: "beginner-level1",
        order: 144,
        title: { zh: "追击 · 4/13", en: "Chase Down · 4/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqfqcrdr", white: "bqcqdqerfr" },
            correct: ["gr"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-5",
        chapterId: "beginner-level1",
        order: 145,
        title: { zh: "追击 · 5/13", en: "Chase Down · 5/13" },
        instruction: { zh: "黑先。通过追击吃掉一颗棋子。", en: "Black to play. Capture a stone by chasing it down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncocpdqeq", white: "dpepfpcqfq" },
            correct: ["crbqbrbpbo"],
            wrong: ["bqcrbrer", "bqcrdrer", "bqcrerfr"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-6",
        chapterId: "beginner-level1",
        order: 146,
        title: { zh: "追击 · 6/13", en: "Chase Down · 6/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drcrbrdqfpcpeodocodm", white: "frhqeqcqbqepdpbpbocn" },
            correct: ["fqergr"],
            wrong: ["erfq"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-7",
        chapterId: "beginner-level1",
        order: 147,
        title: { zh: "追击 · 7/13", en: "Chase Down · 7/13" },
        instruction: { zh: "黑先。通过追击吃掉一颗棋子。", en: "Black to play. Capture a stone by chasing it down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcmcncodpdqgqdrer", white: "bmbnbodofocpepcqeqbrfr" },
            correct: ["fqgrhr"],
            wrong: ["crcs"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-8",
        chapterId: "beginner-level1",
        order: 148,
        title: { zh: "追击 · 8/13", en: "Chase Down · 8/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeocpepcqcr", white: "emdngnbocodpgpdqeq" },
            correct: ["fqerfr"],
            wrong: ["drfq"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-9",
        chapterId: "beginner-level1",
        order: 149,
        title: { zh: "追击 · 9/13", en: "Chase Down · 9/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncoeocpfpdqgqdr", white: "clflcmbnbobpdpepcqeqcr" },
            correct: ["er"],
            wrong: ["fqer", "doer"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-10",
        chapterId: "beginner-level1",
        order: 150,
        title: { zh: "追击 · 10/13", en: "Chase Down · 10/13" },
        instruction: { zh: "黑先。通过追击吃掉一颗棋子。", en: "Black to play. Capture a stone by chasing it down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpeqerfr", white: "epfpdqfqgrfs" },
            correct: ["drcqbq", "drcqcrbqbpbrbsarap", "drcqcrbqbpbrbsarcsesap", "drcqcrbqbrbpbo"],
            wrong: ["drcqcrbqbpbrbsarascs", "drcqcrbqbpbrbsaraqap", "drcqcrbqbpbraqbsares", "drcqcrbqbpbraqbscses", "cqdr", "crdr"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-11",
        chapterId: "beginner-level1",
        order: 151,
        title: { zh: "追击 · 11/13", en: "Chase Down · 11/13" },
        instruction: { zh: "黑先。通过追击吃掉一颗棋子。", en: "Black to play. Capture a stone by chasing it down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "elcmcndodpfpeqfq", white: "dneneogoepgpdqgqhr" },
            correct: ["cqdrcrerfr"],
            wrong: ["drcqcrco"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-12",
        chapterId: "beginner-level1",
        order: 152,
        title: { zh: "追击 · 12/13", en: "Chase Down · 12/13" },
        instruction: { zh: "黑先。通过追击吃掉棋子。", en: "Black to play. Capture stones by chasing them down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codobpbqcrbs", white: "eocpdpcqdr" },
            correct: ["epdqeqerfr"],
        },
    },
    {
        id: "beginner-level1-bl1-chase-down-13",
        chapterId: "beginner-level1",
        order: 153,
        title: { zh: "追击 · 13/13", en: "Chase Down · 13/13" },
        instruction: { zh: "黑先。通过追击吃掉一颗棋子。", en: "Black to play. Capture a stone by chasing it down." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncpdpdq", white: "fpcqeqdrer" },
            correct: ["crbqbrbpbo"],
            wrong: ["bqcr"],
        },
    },
];

const bl1Capture1Levels: Level[] = [
    {
        id: "beginner-level1-bl1-capture1-1",
        chapterId: "beginner-level1",
        order: 154,
        title: { zh: "提子1 · 1/24", en: "Capture 1 · 1/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbobpcqfqdrer", white: "emfngodp" },
            marks: { triangle: "dp" },
            correct: ["eo"],
            wrong: ["epdodneo", "epdoeodn", "doepfpeo", "doepeofp", "dneo", "fpeo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-2",
        chapterId: "beginner-level1",
        order: 155,
        title: { zh: "提子1 · 2/24", en: "Capture 1 · 2/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodoapepfpdqcr", white: "bpcpdpaqeqbrercs" },
            marks: { triangle: "bpcpdp" },
            correct: ["bq"],
            wrong: ["cqbq", "drds"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-3",
        chapterId: "beginner-level1",
        order: 156,
        title: { zh: "提子1 · 3/24", en: "Capture 1 · 3/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlelcmfmfneodq", white: "flgldmemdnenfofp" },
            marks: { triangle: "dmemdnen" },
            correct: ["docnbncocp"],
            wrong: ["docnbncobocpdpgn", "docnbncobocpbpdp", "docncobnbmgn", "cododpep", "codoepgn", "cndodpep", "cndoepgn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-4",
        chapterId: "beginner-level1",
        order: 157,
        title: { zh: "提子1 · 4/24", en: "Capture 1 · 4/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "endodpeq", white: "dmdncoeoep" },
            marks: { triangle: "eoep" },
            correct: ["fofpgpfqfrgqhq"],
            wrong: ["fofpgpfqfrgqgrhq", "fofpgpfqgqfrerdqcpdr", "fofpgpfqgqfrerdqdrcp", "fofpgpfqgqfrgrdq", "fofpfqgp", "fpfogofnemdqcpfq", "fpfogofnemdqcqcp", "fpfogofnemdqfmcp", "fpfogofnemdqgncp", "fpfogofnfmem", "fpfogofngnfm", "fpfofngo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-5",
        chapterId: "beginner-level1",
        order: 158,
        title: { zh: "提子1 · 5/24", en: "Capture 1 · 5/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmenfndodpdqfq", white: "alcldlelemcndnbpcqbrdr" },
            marks: { triangle: "cndn" },
            correct: ["bo"],
            wrong: ["bncocpbo", "bncobocp", "cobnboanaoam", "cobnboanambl", "cobnanbo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-6",
        chapterId: "beginner-level1",
        order: 159,
        title: { zh: "提子1 · 6/24", en: "Capture 1 · 6/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmcncpaqbqcq", white: "anbncodoapbpdpdqdr" },
            marks: { triangle: "anbnapbp" },
            correct: ["bo"],
            wrong: ["aobo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-7",
        chapterId: "beginner-level1",
        order: 160,
        title: { zh: "提子1 · 7/24", en: "Capture 1 · 7/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnenfoep", white: "emfngndoeo" },
            marks: { triangle: "doeo" },
            correct: ["codpdqcpbpcqcr"],
            wrong: ["codpdqcpbpcqbqcr", "codpdqcpcqbpbocndmbn", "codpdqcpcqbpbocnbndm", "codpdqcpcqbpbqcn", "codpcpdq", "dpcocncpcqbqbobpbndqcrfp", "dpcocncpcqbqbobpbndqeqcr", "dpcocncpcqbqbobpbrbn", "dpcocncpcqbqbrbnbpboaqcm", "dpcocncpbocq", "dpcocpcndmdl", "cpdpdqfp", "cpdpcodq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-8",
        chapterId: "beginner-level1",
        order: 161,
        title: { zh: "提子1 · 8/24", en: "Capture 1 · 8/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbmfmcndncodpdqeqer", white: "bnbodoeohocpgpcqfqcrdr" },
            marks: { triangle: "doeo" },
            correct: ["foenem", "foenfnemel"],
            wrong: ["gnfo", "fnfo", "fpfo", "enfo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-9",
        chapterId: "beginner-level1",
        order: 162,
        title: { zh: "提子1 · 9/24", en: "Capture 1 · 9/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doepcq", white: "dpeq" },
            marks: { triangle: "dp" },
            correct: ["dqcpbpcocn", "dqcpcobpbobqbrcrdrercs", "dqcpcobpbqbobn"],
            wrong: ["dqcpbpcobocn", "dqcpcobpbobqbrcraqdr", "dqcpcobpbobqbrcrapdr", "dqcpcobpbobqapcrdrer", "cpdqfqfrerdr", "cpdqfqfrdrercrfp", "cpdqfqfrdrergrcr", "cpdqdrfq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-10",
        chapterId: "beginner-level1",
        order: 163,
        title: { zh: "提子1 · 10/24", en: "Capture 1 · 10/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocodocpdqdrerfr", white: "gnbpdpepaqcqeqbrcr" },
            marks: { triangle: "dpepeq" },
            correct: ["fofpgp"],
            wrong: ["eofpfogp", "eofpgpfo", "fqfo", "fpeoenfo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-11",
        chapterId: "beginner-level1",
        order: 164,
        title: { zh: "提子1 · 11/24", en: "Capture 1 · 11/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emencodofogoeq", white: "cndnfngneohoepgr" },
            marks: { triangle: "eoep" },
            correct: ["fpdpcpdqdrcqbq"],
            wrong: ["fpdpcpdqdrcqcrbqbpap", "fpdpcpdqdrcqcrbqbrbo", "fpdpcpdqcqdrerfqgpfr", "fpdpcpdqcqdrerfqcrgp", "fpdpcpdqcqdrcrerfqfr", "fpdpdqcpcqbo", "fpdpdqcpbocqcrfqbqgp", "fpdpdqcpbocqcrfqgpgqhpip", "dpfpgpfqfrgqhpiphqhr", "dpfpgpfqfrgqhqhp", "dpfpgpfqgqfrerhq", "dpfpgpfqgqfrhrhq", "dpfpfqgp", "fqdpcpdqdrcqbqbpbobrapcrarerfrdsbsfpgpgq", "fqdpcpdqdrcqbqbpbobrapcrarerfrdsbsfpgqgp", "fqdpcpdqdrcqbqbpbobrapcrarerfrdsbsfpfsgp", "fqdpcpdqdrcqbqbpbobrapcrarerfrdsfpbs", "fqdpcpdqdrcqbqbpbobrapcrarerdsfrbsfpgqgp", "fqdpcpdqdrcqbqbpbobrapcrarerdsfrbsfpgpgq", "fqdpcpdqdrcqbqbpbobrapcrarerdsfrcsgqfpgp", "fqdpcpdqdrcqbqbpbobrapcrarerdsfrcsgqbsfp", "fqdpcpdqdrcqbqbpbobrapcrcserdses", "fqdpcpdqdrcqbqbpbobrcraqaobsapbqerbn", "fqdpcpdqdrcqbqbpbobrcraqaobsapbqfpbn", "fqdpcpdqdrcqbqbpcrbo", "fqdpcpdqdrcqcrbqbpap", "fqdpcpdqcqdrcrfpgpgqhper", "fqdpcpdqcqdrcrfpgpgqerhp", "fqdpcpdqcqdrcrfpergp", "fqdpcpdqcqdrfperfrfscrgq", "fqdpcpdqcqdrfperfrfsgqhq", "fqdpcpdqcqdrfperfrfshpgpgqhq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-12",
        chapterId: "beginner-level1",
        order: 165,
        title: { zh: "提子1 · 12/24", en: "Capture 1 · 12/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fngneohocphp", white: "enhnfogogp" },
            marks: { triangle: "fogogp" },
            correct: ["gqfpepfqfreqdq", "gqfpfqepdoeqerdqcqdrcrfrgresgshqiqhrir"],
            wrong: ["gqfpepfqfreqerdqcqdrcrgrhqes", "gqfpepfqeqfrgrhqhriqipjpioinjoko", "gqfpfqepdoeqerdqcqdrcrfrgresgshqhriqirio", "gqfpfqepdoeqerdqcqdrcrfrgresgshqhriqipjpioin", "fpgqfqgrfriq", "fpgqfqgrhqfrerep", "fpgqhqep"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-13",
        chapterId: "beginner-level1",
        order: 166,
        title: { zh: "提子1 · 13/24", en: "Capture 1 · 13/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fnbpepcqdq", white: "cpdpbqbrcr" },
            marks: { triangle: "cpdp" },
            correct: ["cododn"],
            wrong: ["docobocn", "dococnbo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-14",
        chapterId: "beginner-level1",
        order: 167,
        title: { zh: "提子1 · 14/24", en: "Capture 1 · 14/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmbncngndoeo", white: "fldnencogocpfphpdq" },
            marks: { triangle: "dnen" },
            correct: ["fmfnfo"],
            wrong: ["emfnfmfo", "emfnfofm", "fnem"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-15",
        chapterId: "beginner-level1",
        order: 168,
        title: { zh: "提子1 · 15/24", en: "Capture 1 · 15/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alblcldmdnaoco", white: "ambmcmcnbobpcqeq" },
            marks: { triangle: "ambmcmcn" },
            correct: ["bn"],
            wrong: ["anbn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-16",
        chapterId: "beginner-level1",
        order: 169,
        title: { zh: "提子1 · 16/24", en: "Capture 1 · 16/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpepfpcqdqfqbrfrcs", white: "gngpeqgqcrdrergrfsgs" },
            marks: { triangle: "eqcrdrer" },
            correct: ["es"],
            wrong: ["dses"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-17",
        chapterId: "beginner-level1",
        order: 170,
        title: { zh: "提子1 · 17/24", en: "Capture 1 · 17/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlelfmfneodq", white: "flgldmemenfofp" },
            marks: { triangle: "dmemen" },
            correct: ["cmdndocnbncocp"],
            wrong: ["cmdndocnbncobocp", "cmdndocncobnbmgn", "cmdncndoepgn", "cmdncndodpep", "dncm", "cngn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-18",
        chapterId: "beginner-level1",
        order: 171,
        title: { zh: "提子1 · 18/24", en: "Capture 1 · 18/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fogodpephp", white: "doeohofpgp" },
            marks: { triangle: "fpgp" },
            correct: ["gqfqfreqdq"],
            wrong: ["gqfqfreqerdqcphq", "gqfqfreqerdqcqcp", "gqfqeqfr", "fqgqhqgr", "fqgqgrhqiqip", "fqgqgrhqipgn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-19",
        chapterId: "beginner-level1",
        order: 172,
        title: { zh: "提子1 · 19/24", en: "Capture 1 · 19/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alblcldlambncn", white: "bmcmdmemanaoeodpcqbr" },
            marks: { triangle: "anao" },
            correct: ["bp"],
            wrong: ["apbobpco", "apbocobp", "boapaqbp", "boapbpaqbqar"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-20",
        chapterId: "beginner-level1",
        order: 173,
        title: { zh: "提子1 · 20/24", en: "Capture 1 · 20/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofodpgpgq", white: "dogoepfpfq" },
            marks: { triangle: "epfpfq" },
            correct: ["freqdq"],
            wrong: ["freqerdq", "eqfr"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-21",
        chapterId: "beginner-level1",
        order: 174,
        title: { zh: "提子1 · 21/24", en: "Capture 1 · 21/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndncocpcqfqgqdrer", white: "gndoephpdqeqhq" },
            marks: { triangle: "doepdqeq" },
            correct: ["fo"],
            wrong: ["eofpgpfo", "eofpfogp", "fpfo", "dpfp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-22",
        chapterId: "beginner-level1",
        order: 175,
        title: { zh: "提子1 · 22/24", en: "Capture 1 · 22/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdnbococpdqeqfq", white: "gmhndoeobpdpepaqcqbrdr" },
            marks: { triangle: "doeodpep" },
            correct: ["fn"],
            wrong: ["enfo", "foenemfn", "foenfnem", "fpfn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-23",
        chapterId: "beginner-level1",
        order: 176,
        title: { zh: "提子1 · 23/24", en: "Capture 1 · 23/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfncodogoho", white: "cndngnhneofofr" },
            marks: { triangle: "eofo" },
            correct: ["fpepeqdpcpdqdrcqbq"],
            wrong: ["fpepeqdpcpdqdrcqcrbq", "fpepeqdpcpdqcqdrerfq", "fpepeqdpcpdqcqdrcrfq", "fpepeqdpdqcp", "fpepdpeq", "epfpgpfq", "epfpfqgphpgq", "epfpfqgpgqhp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture1-24",
        chapterId: "beginner-level1",
        order: 177,
        title: { zh: "提子1 · 24/24", en: "Capture 1 · 24/24" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmgmhmenhneogoepgpgq", white: "dmemfngnfohocpfpcqfqcr" },
            marks: { triangle: "fngnfofpfq" },
            correct: ["freqdqerdr", "ereqdq"],
            wrong: ["freqdqeresdr", "freqerdq", "eqfrergrhrhq", "eqfrgrerdrdq", "ereqfrdq"],
        },
    },
];

const bl1Capture2Levels: Level[] = [
    {
        id: "beginner-level1-bl1-capture2-1",
        chapterId: "beginner-level1",
        order: 178,
        title: { zh: "提子2 · 1/24", en: "Capture 2 · 1/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpbqeqfq", white: "dneoepdq" },
            marks: { triangle: "dodp" },
            correct: ["cpcobocncm"],
            wrong: ["cpcobocnbncm", "cpcocnbobncq", "cpcocnbobpcq", "cocp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-2",
        chapterId: "beginner-level1",
        order: 179,
        title: { zh: "提子2 · 2/24", en: "Capture 2 · 2/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnfncodobpbqcqdqerfr", white: "cmbnbocpdpepeq" },
            marks: { triangle: "cncodo" },
            correct: ["en"],
            wrong: ["eodndmen", "eodnendmdlemfmelekfl", "dneo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-3",
        chapterId: "beginner-level1",
        order: 180,
        title: { zh: "提子2 · 3/24", en: "Capture 2 · 3/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfpdqgqdrgrdsfsgs", white: "cpdpcqeqcrfrcs" },
            marks: { triangle: "dqdrds" },
            correct: ["es"],
            wrong: ["eres"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-4",
        chapterId: "beginner-level1",
        order: 181,
        title: { zh: "提子2 · 4/24", en: "Capture 2 · 4/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elfmfnhndoeohofphpfqer", white: "emencofogoepeqdr" },
            marks: { triangle: "doeo" },
            correct: ["dndpdqcpbpcqcr"],
            wrong: ["dndpdqcpbpcqbqcr", "dndpdqcpcqbpbogn", "dndpdqcpcqbpbqgn", "dndpcpdq", "dpdndmcnbncmcldl", "dpdndmcnbncmdlgn", "dpdndmcnbncmbmdl", "dpdndmcncmbnbmgn", "dpdndmcncmbnbogn", "dpdncndm"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-5",
        chapterId: "beginner-level1",
        order: 182,
        title: { zh: "提子2 · 5/24", en: "Capture 2 · 5/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "flgmdnhndodpepfp", white: "cmdmcncocpgpdqeqfqgq" },
            marks: { triangle: "dndodpepfp" },
            correct: ["fn"],
            wrong: ["enfofngo", "enfogofn", "foenfnem", "foenemfn", "eoenfogofnem"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-6",
        chapterId: "beginner-level1",
        order: 183,
        title: { zh: "提子2 · 6/24", en: "Capture 2 · 6/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmemfmbncnfnbodoeogobpgpbqcqfqgqer", white: "dlelflcmgmgncofocpdpepfp" },
            marks: { triangle: "dmemfmfndoeo" },
            correct: ["dn"],
            wrong: ["endn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-7",
        chapterId: "beginner-level1",
        order: 184,
        title: { zh: "提子2 · 7/24", en: "Capture 2 · 7/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnenfofpfq", white: "fneogoepgpgq" },
            marks: { triangle: "fofpfq" },
            correct: ["freqdq", "eqfrergrhr", "eqfrgrerdr"],
            wrong: ["freqerdq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-8",
        chapterId: "beginner-level1",
        order: 185,
        title: { zh: "提子2 · 8/24", en: "Capture 2 · 8/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlcmfmeobpepbqcqdqerfr", white: "bocogocpdpfpeqfqhqgr" },
            marks: { triangle: "eoep" },
            correct: ["en"],
            wrong: ["fnenemel", "fnendnem", "dnfn", "foen", "doen"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-9",
        chapterId: "beginner-level1",
        order: 186,
        title: { zh: "提子2 · 9/24", en: "Capture 2 · 9/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpeqdrer", white: "dobpepdq" },
            marks: { triangle: "cpdp" },
            correct: ["cqcocn"],
            wrong: ["cqcobocndnbq", "cqcobocnbnbq", "cocq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-10",
        chapterId: "beginner-level1",
        order: 187,
        title: { zh: "提子2 · 10/24", en: "Capture 2 · 10/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hmcoeofocpfpcqeqdrer", white: "cndndodpepgpdqfqhqfr" },
            marks: { triangle: "eofofp" },
            correct: ["gnfnfm"],
            wrong: ["fngognho", "fngohogn", "engn", "gofnfmgn", "gofngnfm"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-11",
        chapterId: "beginner-level1",
        order: 188,
        title: { zh: "提子2 · 11/24", en: "Capture 2 · 11/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmdpepfqgq", white: "eofpcqdqeq" },
            marks: { triangle: "dpep" },
            correct: ["docpbpcocn", "docpcobpbobqbr", "docpcobpbqbobn"],
            wrong: ["docpbpcobocn", "cpdodncobocn", "cpdodncocnbobnfo", "cpdodncocnbobpfo", "cpdocodn", "cofogpdodnen", "cofogpdoendn", "cofodogp", "cofocpgp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-12",
        chapterId: "beginner-level1",
        order: 189,
        title: { zh: "提子2 · 12/24", en: "Capture 2 · 12/24" },
        instruction: { zh: "白先。吃掉被标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hodpepeqhq", white: "doeocpcqdqer" },
            marks: { triangle: "dpepeq" },
            correct: ["fpfqgqfrgr"],
            wrong: ["fpfqgqfrfsgrgphr", "fpfqgqfrfsgrhrgp", "fpfqfrgq", "fqfpgpfofngo", "fqfpgpfogofn", "fqfpfogp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-13",
        chapterId: "beginner-level1",
        order: 190,
        title: { zh: "提子2 · 13/24", en: "Capture 2 · 13/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbncodpbqdqcr", white: "cndndoepeqdrer" },
            correct: ["cp"],
            wrong: ["bocpbpcq", "cqcp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-14",
        chapterId: "beginner-level1",
        order: 191,
        title: { zh: "提子2 · 14/24", en: "Capture 2 · 14/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqdqfqarcrergr", white: "apbpcpdpepaqeq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-15",
        chapterId: "beginner-level1",
        order: 192,
        title: { zh: "提子2 · 15/24", en: "Capture 2 · 15/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpephpfqgq", white: "fmcpfpdqeq" },
            correct: ["eododncobocncm"],
            wrong: ["eododncobocnbncm", "eododncocnbo", "eodocodn", "doeoenfo", "doeofoen"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-16",
        chapterId: "beginner-level1",
        order: 193,
        title: { zh: "提子2 · 16/24", en: "Capture 2 · 16/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codocpepfphpcqdrds", white: "cndnenboeobpbqarcrcses" },
            correct: ["dq"],
            wrong: ["dpdq", "erdq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-17",
        chapterId: "beginner-level1",
        order: 194,
        title: { zh: "提子2 · 17/24", en: "Capture 2 · 17/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpgpgqdrergrcsfsgs", white: "cqdqeqfqcrfrbs" },
            correct: ["es"],
            wrong: ["dses"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-18",
        chapterId: "beginner-level1",
        order: 195,
        title: { zh: "提子2 · 18/24", en: "Capture 2 · 18/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcmdnencodpepcqcr", white: "dmemfneofofpdqeq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-19",
        chapterId: "beginner-level1",
        order: 196,
        title: { zh: "提子2 · 19/24", en: "Capture 2 · 19/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqfqardrfrbses", white: "eoapbpcpfpaqdqeqer" },
            correct: ["cr"],
            wrong: ["brcr", "cscr", "dscs"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-20",
        chapterId: "beginner-level1",
        order: 197,
        title: { zh: "提子2 · 20/24", en: "Capture 2 · 20/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gndoeobpepbqcqdqerds", white: "cnenbococpdpeqfqfr" },
            correct: ["fo"],
            wrong: ["dnfo", "gofnfodnemdmdlcmbmclckel", "fpfo", "gpfo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-21",
        chapterId: "beginner-level1",
        order: 198,
        title: { zh: "提子2 · 21/24", en: "Capture 2 · 21/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmboeoapcpepbqdqdr", white: "dmcododpfpeqer" },
            correct: ["fndncn"],
            wrong: ["fndnencn", "foenfnem", "enfogofn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-22",
        chapterId: "beginner-level1",
        order: 199,
        title: { zh: "提子2 · 22/24", en: "Capture 2 · 22/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bndnbocpdpeqgqfr", white: "cobpbqcqdqdrerfs" },
            correct: ["ep"],
            wrong: ["doep", "grfq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-23",
        chapterId: "beginner-level1",
        order: 200,
        title: { zh: "提子2 · 23/24", en: "Capture 2 · 23/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmemdnfndofoepcqdqeqfqgq", white: "dlelflcmgmcngncoeogocpdpfpgp" },
            correct: ["fm"],
        },
    },
    {
        id: "beginner-level1-bl1-capture2-24",
        chapterId: "beginner-level1",
        order: 201,
        title: { zh: "提子2 · 24/24", en: "Capture 2 · 24/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndoepdqfq", white: "dmcncocpdpfp" },
            correct: ["eo"],
            wrong: ["eneo"],
        },
    },
];

const bl1Capture3Levels: Level[] = [
    {
        id: "beginner-level1-bl1-capture3-1",
        chapterId: "beginner-level1",
        order: 202,
        title: { zh: "提子3 · 1/24", en: "Capture 3 · 1/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfpfq", white: "eocpdq" },
            correct: ["epdodn"],
            wrong: ["epdocodn", "doep", "eqep"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-2",
        chapterId: "beginner-level1",
        order: 203,
        title: { zh: "提子3 · 2/24", en: "Capture 3 · 2/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmbncocpdqbrdrcs", white: "cndnbododpeqerdses" },
            correct: ["bpcqbqcrar"],
            wrong: ["bpcqarbq", "cqbp", "crcq", "bqbpcqao"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-3",
        chapterId: "beginner-level1",
        order: 204,
        title: { zh: "提子3 · 3/24", en: "Capture 3 · 3/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncodpdqcrer", white: "bocpcqeqdr" },
            correct: ["do"],
            wrong: ["epdo", "cndobmbp", "brds", "dsbqfrbp", "frds"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-4",
        chapterId: "beginner-level1",
        order: 205,
        title: { zh: "提子3 · 4/24", en: "Capture 3 · 4/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eodpfpdqergrfs", white: "codocpcqcrdrdses" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-5",
        chapterId: "beginner-level1",
        order: 206,
        title: { zh: "提子3 · 5/24", en: "Capture 3 · 5/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlgmdoeobpdpaqcqbrcrdr", white: "dnbococpepdqeqfq" },
            correct: ["fnfogo"],
            wrong: ["enfo", "foenemfn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-6",
        chapterId: "beginner-level1",
        order: 207,
        title: { zh: "提子3 · 6/24", en: "Capture 3 · 6/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndofoepgpfq", white: "bncocpdpeqer" },
            correct: ["dn"],
            wrong: ["cmdn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-7",
        chapterId: "beginner-level1",
        order: 208,
        title: { zh: "提子3 · 7/24", en: "Capture 3 · 7/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "foapbpcpcqfqbrerbscsds", white: "cmbocodpbqdqarcrdr" },
            correct: ["ao"],
            wrong: ["aqas", "asaq", "esaq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-8",
        chapterId: "beginner-level1",
        order: 209,
        title: { zh: "提子3 · 8/24", en: "Capture 3 · 8/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfqfr", white: "eocpfpeq" },
            correct: ["dqdodn"],
            wrong: ["dodq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-9",
        chapterId: "beginner-level1",
        order: 210,
        title: { zh: "提子3 · 9/24", en: "Capture 3 · 9/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnaobpcqarcrcs", white: "bocoeocpfpdqdrbsds" },
            correct: ["bq"],
            wrong: ["brbq", "apaq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-10",
        chapterId: "beginner-level1",
        order: 211,
        title: { zh: "提子3 · 10/24", en: "Capture 3 · 10/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clelbmbodoeohoapcpbqcqcr", white: "bncnencodpdqgqhqdr" },
            correct: ["foepfpeqer"],
            wrong: ["foepfpeqfqer", "foepeqfpfqgp", "foepeqfpgpfngodn", "dnfo", "fpfogofnfmgn", "fpfogofngnfm", "fpfofngo", "epfo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-11",
        chapterId: "beginner-level1",
        order: 212,
        title: { zh: "提子3 · 11/24", en: "Capture 3 · 11/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blclcododp", white: "dneocpepdq" },
            correct: ["bocncmbnbm", "cnbobnbpcqbqbr"],
            wrong: ["bocncmbnanbm", "bocnbncm", "cnbobpbnbmcm"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-12",
        chapterId: "beginner-level1",
        order: 213,
        title: { zh: "提子3 · 12/24", en: "Capture 3 · 12/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cngobpgpdqeqfq", white: "hnepfphpgqhq" },
            correct: ["fn"],
            wrong: ["hofn", "fognfngm", "fogngmfnenfmflemdmdpeodn", "gnfoeofnfmendnemeldo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-13",
        chapterId: "beginner-level1",
        order: 214,
        title: { zh: "提子3 · 13/24", en: "Capture 3 · 13/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmfndoeo", white: "dnenfoep" },
            correct: ["codpdq"],
            wrong: ["dpco"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-14",
        chapterId: "beginner-level1",
        order: 215,
        title: { zh: "提子3 · 14/24", en: "Capture 3 · 14/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hneohoephpbqcqdqcrerds", white: "dmenbpcpdpeqfqfr" },
            correct: ["fodoco"],
            wrong: ["fodocnfpgpgo", "dofo", "fpfogofnfmgn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-15",
        chapterId: "beginner-level1",
        order: 216,
        title: { zh: "提子3 · 15/24", en: "Capture 3 · 15/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblcldlambnbodoapcpdpaqardras", white: "bmcmcncobpbqbrbs" },
            correct: ["an"],
            wrong: ["aoan"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-16",
        chapterId: "beginner-level1",
        order: 217,
        title: { zh: "提子3 · 16/24", en: "Capture 3 · 16/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncodpdqcrer", white: "bocpcqeqdr" },
            correct: ["do"],
            wrong: ["brdsdocn", "brdscndobmbp", "epdo", "frdscndobmbp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-17",
        chapterId: "beginner-level1",
        order: 218,
        title: { zh: "提子3 · 17/24", en: "Capture 3 · 17/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbmcnbococpbqar", white: "cmdmdndoapdpcqbrcr" },
            correct: ["aqaoas"],
            wrong: ["aqaobpbq", "bpaoaqbq", "anao", "aoan"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-18",
        chapterId: "beginner-level1",
        order: 219,
        title: { zh: "提子3 · 18/24", en: "Capture 3 · 18/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobpcqeqdrfr", white: "dncpdpdqer" },
            correct: ["cr"],
            wrong: ["bqcr", "fqes", "epes", "dscr"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-19",
        chapterId: "beginner-level1",
        order: 220,
        title: { zh: "提子3 · 19/24", en: "Capture 3 · 19/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpcq", white: "gmdncocpdq" },
            correct: ["epeofoenem"],
            wrong: ["epeofoenfnem", "epeoenfo", "eoepfpeq", "eoepeqfp", "crbq", "bqcr"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-20",
        chapterId: "beginner-level1",
        order: 221,
        title: { zh: "提子3 · 20/24", en: "Capture 3 · 20/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbndncobpdpdqcr", white: "doeoepeqbrdr" },
            correct: ["cq"],
            wrong: ["cpcq", "cscq", "bqcq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-21",
        chapterId: "beginner-level1",
        order: 222,
        title: { zh: "提子3 · 21/24", en: "Capture 3 · 21/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpbqcqfqardrfrbses", white: "eoapbpcpaqdqeqer" },
            correct: ["cr"],
            wrong: ["brcr", "dscs", "cscr"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-22",
        chapterId: "beginner-level1",
        order: 223,
        title: { zh: "提子3 · 22/24", en: "Capture 3 · 22/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gncodogoepfpdq", white: "hmcndneofohogphp" },
            correct: ["fm"],
            wrong: ["hnen", "fnfmgmen", "fnfmengm", "gmen"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-23",
        chapterId: "beginner-level1",
        order: 224,
        title: { zh: "提子3 · 23/24", en: "Capture 3 · 23/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmgmgngoepfphphqgr", white: "fnfodpgpfqgqfr" },
            correct: ["eoeqerdqcq"],
            wrong: ["eoeqerdqdrcq", "eoeqdqer", "eqeoendocodndmcn", "eqeoendocodncndm", "eqeoendodnco", "eqeodoen"],
        },
    },
    {
        id: "beginner-level1-bl1-capture3-24",
        chapterId: "beginner-level1",
        order: 225,
        title: { zh: "提子3 · 24/24", en: "Capture 3 · 24/24" },
        instruction: { zh: "白先。吃掉一或多颗黑棋棋子。", en: "White to play. Capture one or more black stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndncqdqfqergrfs", white: "epeqbrcrdr" },
            correct: ["cpbqbp"],
            wrong: ["cpbqaqbpbodp", "bqcp", "dpcpcobo", "bpdpdoco"],
        },
    },
];

const bl1Capture4Levels: Level[] = [
    {
        id: "beginner-level1-bl1-capture4-1",
        chapterId: "beginner-level1",
        order: 226,
        title: { zh: "提子4 · 1/24", en: "Capture 4 · 1/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpcqeqcrdr", white: "cmbncodpfpdqerfr" },
            correct: ["do"],
            wrong: ["epdo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-2",
        chapterId: "beginner-level1",
        order: 227,
        title: { zh: "提子4 · 2/24", en: "Capture 4 · 2/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmandneoepdqeqer", white: "bncnaodobpdpcqbrdrds" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-3",
        chapterId: "beginner-level1",
        order: 228,
        title: { zh: "提子4 · 3/24", en: "Capture 4 · 3/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcmbndnbobpcqcrdr", white: "dmcnencocpdqfqer" },
            correct: ["dp"],
            wrong: ["dodp", "emdo", "dldo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-4",
        chapterId: "beginner-level1",
        order: 229,
        title: { zh: "提子4 · 4/24", en: "Capture 4 · 4/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdnboeocpepdq", white: "blclbncncododpeqer" },
            correct: ["bm"],
            wrong: ["anbm"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-5",
        chapterId: "beginner-level1",
        order: 230,
        title: { zh: "提子4 · 5/24", en: "Capture 4 · 5/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gofpeqgqdrer", white: "focpepdq" },
            correct: ["eo"],
            wrong: ["cqdp", "fneo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-6",
        chapterId: "beginner-level1",
        order: 231,
        title: { zh: "提子4 · 6/24", en: "Capture 4 · 6/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmeoepgpfqhqfr", white: "hmdninfocpfpdqeq" },
            correct: ["gn"],
            wrong: ["gofnengn", "gofngnen", "fngognho", "fngohogn", "engn"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-7",
        chapterId: "beginner-level1",
        order: 232,
        title: { zh: "提子4 · 7/24", en: "Capture 4 · 7/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbndnbobpfpcqgqdrerfr", white: "dmcnencoeofocpgpdqeqfq" },
            correct: ["dp"],
            wrong: ["dodp", "epdp", "hpep", "dldo", "emdo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-8",
        chapterId: "beginner-level1",
        order: 233,
        title: { zh: "提子4 · 8/24", en: "Capture 4 · 8/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmbncodoeodp", white: "bmcnbofocpepdqeq" },
            correct: ["bp"],
            wrong: ["anaobpam", "cman", "dnan", "aoanbpbqcqap"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-9",
        chapterId: "beginner-level1",
        order: 234,
        title: { zh: "提子4 · 9/24", en: "Capture 4 · 9/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmancncocpbqbrbs", white: "alblcldlambnbobpdpcqeqcr" },
            correct: ["ap"],
            wrong: ["aoapanaoaqan", "aoapaqan", "aoapaoan"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-10",
        chapterId: "beginner-level1",
        order: 235,
        title: { zh: "提子4 · 10/24", en: "Capture 4 · 10/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "endofofpeq", white: "fmfneodpep" },
            correct: ["cpdqdr"],
            wrong: ["cpdqcqdr", "dqcp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-11",
        chapterId: "beginner-level1",
        order: 236,
        title: { zh: "提子4 · 11/24", en: "Capture 4 · 11/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmcnbobpdpfqgqdrer", white: "dnfncoeocpfpdqeq" },
            correct: ["cq"],
            wrong: ["doep", "epdo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-12",
        chapterId: "beginner-level1",
        order: 237,
        title: { zh: "提子4 · 12/24", en: "Capture 4 · 12/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncodocpfpdqfqcrdrer", white: "clhneobpdpephpbqcqeqbrfrgr" },
            correct: ["fnenem"],
            wrong: ["enfofngo", "enfogofnfmgn", "enfogofngnfm", "foen"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-13",
        chapterId: "beginner-level1",
        order: 238,
        title: { zh: "提子4 · 13/24", en: "Capture 4 · 13/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eodpdq", white: "codoep" },
            correct: ["fpeqer", "fpeqfqerdr"],
            wrong: ["fpeqfqerfrdrcrcq", "eqfp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-14",
        chapterId: "beginner-level1",
        order: 239,
        title: { zh: "提子4 · 14/24", en: "Capture 4 · 14/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdpcqfqdrer", white: "cmhobpepbqdqeqhqarcrbs" },
            correct: ["foeoen"],
            wrong: ["eofpgpfofngo", "eofpgpfogofn", "eofpfogp", "fpeo"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-15",
        chapterId: "beginner-level1",
        order: 240,
        title: { zh: "提子4 · 15/24", en: "Capture 4 · 15/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeoepbqfqdr", white: "dpcqeqbrcrfrgr" },
            correct: ["dq"],
            wrong: ["erdq", "cpdq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-16",
        chapterId: "beginner-level1",
        order: 241,
        title: { zh: "提子4 · 16/24", en: "Capture 4 · 16/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dndoepeqbrdrds", white: "cmcobpdpdqcrcs" },
            correct: ["cqcpbq"],
            wrong: ["cnbq", "bscq", "bqcq", "cpcq"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-17",
        chapterId: "beginner-level1",
        order: 242,
        title: { zh: "提子4 · 17/24", en: "Capture 4 · 17/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmeneoepcqeqdr", white: "cldlemfmdnbocodpbqdqcr" },
            correct: ["do"],
            wrong: ["cndo", "cpdo", "brcp", "cscp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-18",
        chapterId: "beginner-level1",
        order: 243,
        title: { zh: "提子4 · 18/24", en: "Capture 4 · 18/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpbqeqfqbrdrfrcs", white: "gncodoepgpcqdqgqcrergres" },
            correct: ["fsdsdr"],
            wrong: ["fsdscpbsdpfp", "cpdsdpbsfsfp", "dpdscpbsfsfp", "dsbs"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-19",
        chapterId: "beginner-level1",
        order: 244,
        title: { zh: "提子4 · 19/24", en: "Capture 4 · 19/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "docpcqcrdrdses", white: "dpdqergrfs" },
            correct: ["eq"],
            wrong: ["epeqfqfr"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-20",
        chapterId: "beginner-level1",
        order: 245,
        title: { zh: "提子4 · 20/24", en: "Capture 4 · 20/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fmendodpeq", white: "dmdneoepcqdq" },
            correct: ["fpfogo"],
            wrong: ["fpfofngo", "fofpgpfq", "fofpfqgp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-21",
        chapterId: "beginner-level1",
        order: 246,
        title: { zh: "提子4 · 21/24", en: "Capture 4 · 21/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmbncnenbocpcqeq", white: "emfmdngncodobpdpgpgq" },
            correct: ["eoepfp"],
            wrong: ["epeo", "dqeo", "bqep", "foeofnfp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-22",
        chapterId: "beginner-level1",
        order: 247,
        title: { zh: "提子4 · 22/24", en: "Capture 4 · 22/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlcndncobpdqgqdr", white: "bodocpepbqeq" },
            correct: ["dp"],
            wrong: ["bnap", "cqapdpeo", "eodp"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-23",
        chapterId: "beginner-level1",
        order: 248,
        title: { zh: "提子4 · 23/24", en: "Capture 4 · 23/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "elcmdmfmfndoeo", white: "emcndnengnfofpcqdq" },
            correct: ["bncocpbobp", "cobnbmbobp"],
            wrong: ["bncocpboaobp", "bncobocp", "cobnbobmblflgmdl", "cobnbobmblflamgm", "cobnbobmblflangm"],
        },
    },
    {
        id: "beginner-level1-bl1-capture4-24",
        chapterId: "beginner-level1",
        order: 249,
        title: { zh: "提子4 · 24/24", en: "Capture 4 · 24/24" },
        instruction: { zh: "黑先。吃掉一或多颗白棋棋子。", en: "Black to play. Capture one or more white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepcqbrbscs", white: "dnbobpgpbqdqgqcrdrgr" },
            correct: ["ereqfq"],
            wrong: ["eqerfrfq", "frdserar", "frdsesar", "frdseqar", "fqdserar", "fqdsesar", "fqdseqar", "dser"],
        },
    },
];

const bl1ConnectLevels: Level[] = [
    {
        id: "beginner-level1-bl1-connect-1",
        chapterId: "beginner-level1",
        order: 250,
        title: { zh: "连接 · 1/24", en: "Connect · 1/24" },
        instruction: { zh: "两个被标记的棋串都可以通过追击被吃掉。但黑棋可以通过在下方连接来加强棋子。黑先。连接被标记的棋子。", en: "The two marked chains can each be captured by chasing them down. But Black can strengthen the stones by connecting them underneath. Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crdrfrgr", white: "dqeqfqgqer" },
            marks: { triangle: "grfrdrcr", cross: "es" },
            correct: ["es"],
            wrong: ["dses", "fses"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-2",
        chapterId: "beginner-level1",
        order: 251,
        title: { zh: "连接 · 2/24", en: "Connect · 2/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqdqfqgqhq", white: "fmgncpdpfpgpeq" },
            marks: { triangle: "hqgqfqdqcqbq" },
            correct: ["er"],
            wrong: ["drerfres", "dreresfsfrds", "dreresfsdsfr", "frerdres", "freresdsfsdr", "freresdsdrfs"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-3",
        chapterId: "beginner-level1",
        order: 252,
        title: { zh: "连接 · 3/24", en: "Connect · 3/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dndpeq", white: "bncpfpcqdqgq" },
            marks: { triangle: "dndpeq" },
            correct: ["epdoeocoen", "epdoeocoem", "epdoeocofn"],
            wrong: ["doep", "eoep", "enep"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-4",
        chapterId: "beginner-level1",
        order: 253,
        title: { zh: "连接 · 4/24", en: "Connect · 4/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eneodpbqcqeqfq", white: "dmdndofobpcpfphpgq" },
            marks: { triangle: "eneodpbqcqeqfq" },
            correct: ["ep"],
            wrong: ["dqep"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-5",
        chapterId: "beginner-level1",
        order: 254,
        title: { zh: "连接 · 5/24", en: "Connect · 5/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcndocpcqdr", white: "enbocofodpep" },
            marks: { triangle: "dmcndo" },
            correct: ["dn"],
            wrong: ["cmdn"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-6",
        chapterId: "beginner-level1",
        order: 255,
        title: { zh: "连接 · 6/24", en: "Connect · 6/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnencoeocqeq", white: "bobpcpepfpfq" },
            marks: { triangle: "cnencoeocqeq" },
            correct: ["dp"],
            wrong: ["dqdp", "dodp", "dndp"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-7",
        chapterId: "beginner-level1",
        order: 256,
        title: { zh: "连接 · 7/24", en: "Connect · 7/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofogocqeqcrer", white: "cndncocpepfpbqfqhqfr" },
            marks: { triangle: "doeofogocqeqcrer" },
            correct: ["dp"],
            wrong: ["dqdp", "drdp"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-8",
        chapterId: "beginner-level1",
        order: 257,
        title: { zh: "连接 · 8/24", en: "Connect · 8/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndncpcqcrdr", white: "bododpdqfqer" },
            marks: { triangle: "cndncpcqcrdr" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-9",
        chapterId: "beginner-level1",
        order: 258,
        title: { zh: "连接 · 9/24", en: "Connect · 9/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnfndocpbq", white: "cmbocobpeqgqdr" },
            marks: { triangle: "dnfndocpbq" },
            correct: ["dqepdpeoen"],
            wrong: ["dqepdpeofoenemdm", "dqepeodp", "dqepfodp", "cqdp", "eodp", "epcq", "endp", "fodp", "dpcq"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-10",
        chapterId: "beginner-level1",
        order: 259,
        title: { zh: "连接 · 10/24", en: "Connect · 10/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndneodpfp", white: "enfncocpcqdqfr" },
            marks: { triangle: "cndneodpfp" },
            correct: ["do"],
            wrong: ["fodo", "epdo"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-11",
        chapterId: "beginner-level1",
        order: 260,
        title: { zh: "连接 · 11/24", en: "Connect · 11/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfngncpdqdr", white: "clfmcnepeqhqer" },
            marks: { triangle: "enfngncpdqdr" },
            correct: ["dodpcocqcr"],
            wrong: ["dodpcocqbqcr", "dodpeoco", "dodpcqco", "dpdo", "codndoeo", "codndpdo", "cqdo", "eodo", "dncododp", "dncodpdo"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-12",
        chapterId: "beginner-level1",
        order: 261,
        title: { zh: "连接 · 12/24", en: "Connect · 12/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpeqdr", white: "cqdqcrfr" },
            marks: { triangle: "fpeqdr" },
            correct: ["er"],
            wrong: ["fqer", "eper"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-13",
        chapterId: "beginner-level1",
        order: 262,
        title: { zh: "连接 · 13/24", en: "Connect · 13/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "focpdpfpeqfr", white: "gpbqcqfqgqdrhr" },
            marks: { triangle: "freqfpdpcpfo" },
            correct: ["er"],
            wrong: ["dqer", "eper", "eser"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-14",
        chapterId: "beginner-level1",
        order: 263,
        title: { zh: "连接 · 14/24", en: "Connect · 14/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncocqdqbr", white: "cpdpepeq" },
            marks: { triangle: "brdqcqcocn" },
            correct: ["bp"],
            wrong: ["bqbp", "crbp"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-15",
        chapterId: "beginner-level1",
        order: 264,
        title: { zh: "连接 · 15/24", en: "Connect · 15/24" },
        instruction: { zh: "有时可以通过吃掉一颗棋子来连接棋子。黑先。连接被标记的棋子。", en: "You can sometimes connect stones by capturing a stone. Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codocpdqdr", white: "bpdpaqcqfqbrcr" },
            marks: { triangle: "drdqcpdoco", cross: "ep" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-16",
        chapterId: "beginner-level1",
        order: 265,
        title: { zh: "连接 · 16/24", en: "Connect · 16/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dndodpcqeqfqcr", white: "coeocpepbqdqbrer" },
            marks: { triangle: "crfqeqcqdpdodn" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-17",
        chapterId: "beginner-level1",
        order: 266,
        title: { zh: "连接 · 17/24", en: "Connect · 17/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpbqdqcrer", white: "cncocpcqbrdr" },
            marks: { triangle: "ercrdqbqbpbo" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-18",
        chapterId: "beginner-level1",
        order: 267,
        title: { zh: "连接 · 18/24", en: "Connect · 18/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcnbobqbrbs", white: "bpcpdpfpdr" },
            marks: { triangle: "bsbrbqbocncl" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-19",
        chapterId: "beginner-level1",
        order: 268,
        title: { zh: "连接 · 19/24", en: "Connect · 19/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpfpeqdrfres", white: "epgpbqcqdqfqgqgr" },
            marks: { triangle: "esfrdreqfpdp" },
            correct: ["eo"],
            wrong: ["erfo"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-20",
        chapterId: "beginner-level1",
        order: 269,
        title: { zh: "连接 · 20/24", en: "Connect · 20/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epcqdqfq", white: "cpdpeqgqfr" },
            marks: { triangle: "fqdqcqep" },
            correct: ["er"],
            wrong: ["fper"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-21",
        chapterId: "beginner-level1",
        order: 270,
        title: { zh: "连接 · 21/24", en: "Connect · 21/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpcqfqcrer", white: "cododpdqdr" },
            marks: { triangle: "ercrfqcqcp" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-22",
        chapterId: "beginner-level1",
        order: 271,
        title: { zh: "连接 · 22/24", en: "Connect · 22/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "coeobpcqeq", white: "bncndndodqbrcrdr" },
            marks: { triangle: "eqcqbpeoco" },
            correct: ["dp"],
            wrong: ["cpdp", "epdp"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-23",
        chapterId: "beginner-level1",
        order: 272,
        title: { zh: "连接 · 23/24", en: "Connect · 23/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqeqfq", white: "bofodpdq" },
            marks: { triangle: "fqeqcqbq" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level1-bl1-connect-24",
        chapterId: "beginner-level1",
        order: 273,
        title: { zh: "连接 · 24/24", en: "Connect · 24/24" },
        instruction: { zh: "黑先。连接被标记的棋子。", en: "Black to play. Connect the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpfphpgq", white: "emcneoep" },
            marks: { triangle: "gqhpfpdpcp" },
            correct: ["eq"],
            wrong: ["gpeq", "fqeq"],
        },
    },
];

const bl1CutLevels: Level[] = [
    {
        id: "beginner-level1-bl1-cut-1",
        chapterId: "beginner-level1",
        order: 274,
        title: { zh: "切断 · 1/24", en: "Cut · 1/24" },
        instruction: { zh: "白棋可以切断黑棋棋子，将它们分成两个弱棋块。白先。切断被标记的棋子。", en: "White can cut the black stones and separate them into two weak groups. White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcocpdqdr", white: "eobqcqeqgqcr" },
            marks: { triangle: "cmcocpdqdr", cross: "dp" },
            correct: ["dp"],
            wrong: ["dodp", "epdp", "cndp"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-2",
        chapterId: "beginner-level1",
        order: 275,
        title: { zh: "切断 · 2/24", en: "Cut · 2/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eldnencocpbq", white: "cmdodpcqdqgqbr" },
            marks: { triangle: "eldnencocpbq" },
            correct: ["cn"],
            wrong: ["dmcn", "bpcn"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-3",
        chapterId: "beginner-level1",
        order: 276,
        title: { zh: "切断 · 3/24", en: "Cut · 3/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpepfpeqdrds", white: "cnencocqfqcrerfr" },
            marks: { triangle: "bpcpdpepfpeqdrds" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-4",
        chapterId: "beginner-level1",
        order: 277,
        title: { zh: "切断 · 4/24", en: "Cut · 4/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcncoeodpdrer", white: "bnbocpfpcqfqcrfr" },
            marks: { triangle: "cmcncoeodpdrer" },
            correct: ["dqeqep"],
            wrong: ["doepdnem", "epdq", "eqdq"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-5",
        chapterId: "beginner-level1",
        order: 278,
        title: { zh: "切断 · 5/24", en: "Cut · 5/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emdncoeocpbqbr", white: "dlbmdmcnbocqeqcr" },
            marks: { triangle: "emdncoeocpbqbr" },
            correct: ["bp", "dpdobp"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-6",
        chapterId: "beginner-level1",
        order: 279,
        title: { zh: "切断 · 6/24", en: "Cut · 6/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fnfobpcpdpfphpfq", white: "bndnbqcqdqeqfrgr" },
            marks: { triangle: "fnfobpcpdpfphpfq" },
            correct: ["epeodo"],
            wrong: ["gqep", "gpep"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-7",
        chapterId: "beginner-level1",
        order: 280,
        title: { zh: "切断 · 7/24", en: "Cut · 7/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emdoeodpdrer", white: "cncocpepcqfqhqcrfr" },
            marks: { triangle: "emdoeodpdrer" },
            correct: ["dqeqfp"],
            wrong: ["eqdq", "endq", "dndq"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-8",
        chapterId: "beginner-level1",
        order: 281,
        title: { zh: "切断 · 8/24", en: "Cut · 8/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cofocpepgp", white: "cmdmeneobqcqdq" },
            marks: { triangle: "cofocpepgp" },
            correct: ["dp"],
            wrong: ["dodp"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-9",
        chapterId: "beginner-level1",
        order: 282,
        title: { zh: "切断 · 9/24", en: "Cut · 9/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnencpdpeq", white: "cmdmcncofpfq" },
            marks: { triangle: "dnencpdpeq" },
            correct: ["doeoep"],
            wrong: ["epdo", "eodo"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-10",
        chapterId: "beginner-level1",
        order: 283,
        title: { zh: "切断 · 10/24", en: "Cut · 10/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmcncofpfq", white: "dnendocpdpeq" },
            marks: { triangle: "dmcnco" },
            correct: ["cm"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-11",
        chapterId: "beginner-level1",
        order: 284,
        title: { zh: "切断 · 11/24", en: "Cut · 11/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmemcndoeoepeq", white: "cldldmcocpdpdq" },
            marks: { triangle: "cmemcndoeoepeq" },
            correct: ["dn"],
            wrong: ["endn"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-12",
        chapterId: "beginner-level1",
        order: 285,
        title: { zh: "切断 · 12/24", en: "Cut · 12/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epcqeqgqdr", white: "cncpdpdq" },
            marks: { triangle: "cqdr" },
            correct: ["crbqbr", "crbqer"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-13",
        chapterId: "beginner-level1",
        order: 286,
        title: { zh: "切断 · 13/24", en: "Cut · 13/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqeqgqfr", white: "dndpdq" },
            marks: { triangle: "frgqeqcqbq" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-14",
        chapterId: "beginner-level1",
        order: 287,
        title: { zh: "切断 · 14/24", en: "Cut · 14/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcocpcqeqfqcr", white: "dndofodpdq" },
            marks: { triangle: "crfqeqcqcpcocm" },
            correct: ["dr"],
            wrong: ["cndr"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-15",
        chapterId: "beginner-level1",
        order: 288,
        title: { zh: "切断 · 15/24", en: "Cut · 15/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocqdqbr", white: "cpdpepeq" },
            marks: { triangle: "brdqcqbo" },
            correct: ["bp"],
            wrong: ["bqbp"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-16",
        chapterId: "beginner-level1",
        order: 289,
        title: { zh: "切断 · 16/24", en: "Cut · 16/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocqcrerfr", white: "epgpdqhqdr" },
            marks: { triangle: "frercrcqco" },
            correct: ["ds", "cs", "es"],
            wrong: ["cpbpdpds", "cpbpdsdp"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-17",
        chapterId: "beginner-level1",
        order: 290,
        title: { zh: "切断 · 17/24", en: "Cut · 17/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "crcmdmfmbncncoapbqcq", white: "drdnbodofobpcpdq" },
            marks: { triangle: "crcqbqapcocnbnfmdmcm" },
            correct: ["ao"],
            wrong: ["anamaodp", "anamdpao"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-18",
        chapterId: "beginner-level1",
        order: 291,
        title: { zh: "切断 · 18/24", en: "Cut · 18/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbnboaqbqcqcr", white: "dnbpcpdpdqdr" },
            marks: { triangle: "crcqbqaqbobncm" },
            correct: ["ap"],
            wrong: ["aoap"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-19",
        chapterId: "beginner-level1",
        order: 292,
        title: { zh: "切断 · 19/24", en: "Cut · 19/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gogqarbrcrfrgres", white: "bqcqdqeqfqer" },
            marks: { triangle: "esgrfrcrbrargqgo" },
            correct: ["dsdrfs"],
            wrong: ["drds"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-20",
        chapterId: "beginner-level1",
        order: 293,
        title: { zh: "切断 · 20/24", en: "Cut · 20/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eocpdpeqfr", white: "bqcqfqgqdrhr" },
            marks: { triangle: "freqdpcpeo" },
            correct: ["er"],
            wrong: ["dqer"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-21",
        chapterId: "beginner-level1",
        order: 294,
        title: { zh: "切断 · 21/24", en: "Cut · 21/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dncobqcqdqeq", white: "cpdpepfpfq" },
            marks: { triangle: "eqdqcqbqcodn" },
            correct: ["bp"],
            wrong: ["bobp"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-22",
        chapterId: "beginner-level1",
        order: 295,
        title: { zh: "切断 · 22/24", en: "Cut · 22/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodpepgpeqdr", white: "bmcnenbpcpcqdqbr" },
            marks: { triangle: "dreqgpepdpcobo" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-23",
        chapterId: "beginner-level1",
        order: 296,
        title: { zh: "切断 · 23/24", en: "Cut · 23/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcnbpcpbq", white: "dncodpcqeqcr" },
            marks: { triangle: "bqcpbpcncm" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level1-bl1-cut-24",
        chapterId: "beginner-level1",
        order: 297,
        title: { zh: "切断 · 24/24", en: "Cut · 24/24" },
        instruction: { zh: "白先。切断被标记的棋子。", en: "White to play. Cut the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gpdqfqhqfr", white: "dofofpeqgq" },
            marks: { triangle: "frhqfqdqgp" },
            correct: ["er"],
        },
    },
];

const bl1CancelCutLevels: Level[] = [
    {
        id: "beginner-level1-bl1-cancel-cut-1",
        chapterId: "beginner-level1",
        order: 298,
        title: { zh: "切断 · 1/9", en: "Cut · 1/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcncocpgpcqeqbrdr", white: "elemdndodpdqer" },
            marks: { 1: "eq" },
            correct: ["fq"],
            wrong: ["fpfr", "epfq"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-2",
        chapterId: "beginner-level1",
        order: 299,
        title: { zh: "切断 · 2/9", en: "Cut · 2/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmeobpcpdpdqbrdr", white: "bocodogoepeqer" },
            marks: { 1: "eo" },
            correct: ["enfofn"],
            wrong: ["enfofpfn", "foen", "fnenemdndmcnbncmclbmblan", "fnenemdncndmdlelfmcldkcmbmaobnbl", "fnenemdncndmdlelfmcldkcmckao"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-3",
        chapterId: "beginner-level1",
        order: 300,
        title: { zh: "切断 · 3/9", en: "Cut · 3/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqfqdrer", white: "cnbpcpipdqeqfrgr" },
            marks: { 1: "fq" },
            correct: ["fpgqhqgpgo"],
            wrong: ["fpgqhqgphpgo", "fpgqgphqhriq", "gpfpfoepdpeoengo", "gqfp"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-4",
        chapterId: "beginner-level1",
        order: 301,
        title: { zh: "切断 · 4/9", en: "Cut · 4/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dobpcpfpaqcqbrbs", white: "enbocodpdqcrdr" },
            marks: { 1: "do" },
            correct: ["eodndmcnbncmcl"],
            wrong: ["eodndmcnbncmbmcl", "eodndmcncmbn", "eodncndm", "dneo"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-5",
        chapterId: "beginner-level1",
        order: 302,
        title: { zh: "切断 · 5/9", en: "Cut · 5/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpcqeqfqcrdr", white: "codobpdpdq" },
            marks: { 1: "bo" },
            correct: ["bn"],
            wrong: ["aobn"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-6",
        chapterId: "beginner-level1",
        order: 303,
        title: { zh: "切断 · 6/9", en: "Cut · 6/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gnepbqcqdqardrbscs", white: "enbpcpdpeqer" },
            marks: { 1: "ep" },
            correct: ["fpeofododncobocncm", "fpeofodocodndmcnbn", "fpeofodocn"],
            wrong: ["fpeofododncobocnbncm", "fpeofododncocnbo", "fpeofodocodndmcncmbn", "fpeofodocodncndm", "fpeodofo", "eofp"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-7",
        chapterId: "beginner-level1",
        order: 304,
        title: { zh: "切断 · 7/9", en: "Cut · 7/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hndpepbqcqdrer", white: "cmdobpcpdqeqfq" },
            marks: { 1: "dp" },
            correct: ["fo"],
            wrong: ["fpeoenfogofn", "fpeoenfofngo", "fpeofoen", "eofpgpfofngo", "eofpgpfogofn", "eofpfogp"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-8",
        chapterId: "beginner-level1",
        order: 305,
        title: { zh: "切断 · 8/9", en: "Cut · 8/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmeobpcpdpdqbrdr", white: "fnbocodoepeqer" },
            marks: { 1: "eo" },
            correct: ["enfogo"],
            wrong: ["enfofpgo", "foenemdn", "foendnem"],
        },
    },
    {
        id: "beginner-level1-bl1-cancel-cut-9",
        chapterId: "beginner-level1",
        order: 306,
        title: { zh: "切断 · 9/9", en: "Cut · 9/9" },
        instruction: { zh: "白先。黑棋在1位切断。请吃掉这颗切断的棋子。", en: "White to play. Black has cut with 1. Capture this cutting stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpfphpcqdqbr", white: "dobpcpbq" },
            marks: { 1: "co" },
            correct: ["cn"],
            wrong: ["bocn"],
        },
    },
];

const bl1EyeLevels: Level[] = [
    {
        id: "beginner-level1-bl1-eye-1",
        chapterId: "beginner-level1",
        order: 307,
        title: { zh: "眼 · 1/14", en: "Eye · 1/14" },
        instruction: { zh: "如果你想确保你的眼是真眼，你需要控制眼位对角线上的A、B、C、D四个点中的三个。黑先。请将这个眼做成真眼。", en: "If you want to make sure that your eye is real, you need to control three of the four points A, B, C and D, diagonally to the eye. Black to play. Make the eye real." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dddedfedeffe", white: "" },
            marks: { A: "dd", B: "fd", C: "df", D: "ff" },
            correct: ["fd", "ff", "fc", "fg", "gd", "gf"],
        },
    },
    {
        id: "beginner-level1-bl1-eye-2",
        chapterId: "beginner-level1",
        order: 308,
        title: { zh: "眼 · 2/14", en: "Eye · 2/14" },
        instruction: { zh: "对于边上的眼A，两个对角点（B和C）都需要被控制。白先。请将眼A做成假眼。", en: "For an eye A at the edge, both diagonal points (B and C) need to be controlled. White to play. Make the eye A false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ahbhbichdi", white: "dg" },
            marks: { A: "ci", B: "bh", C: "dh" },
            correct: ["dh"],
        },
    },
    {
        id: "beginner-level1-bl1-eye-3",
        chapterId: "beginner-level1",
        order: 309,
        title: { zh: "眼 · 3/14", en: "Eye · 3/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "apbqcqarcrbs", white: "bnbpcpdpdqdr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "apbqcqarcrbs", white: "bnbpcpdpdqdr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-4",
        chapterId: "beginner-level1",
        order: 310,
        title: { zh: "眼 · 4/14", en: "Eye · 4/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "apcpbqarcrbs", white: "cnbobpdpcqdqdr" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "real",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "apcpbqarcrbs", white: "cnbobpdpcqdqdr" },
                marks: { A: "br" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-5",
        chapterId: "beginner-level1",
        order: 311,
        title: { zh: "眼 · 5/14", en: "Eye · 5/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "apcpbqarcrbs", white: "cnbobpdpcqdqdr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "apcpbqarcrbs", white: "cnbobpdpcqdqdr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-6",
        chapterId: "beginner-level1",
        order: 312,
        title: { zh: "眼 · 6/14", en: "Eye · 6/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cnbpcpaqeqbras", white: "dpbqcqdqcrer" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cnbpcpaqeqbras", white: "dpbqcqdqcrer" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-7",
        chapterId: "beginner-level1",
        order: 313,
        title: { zh: "眼 · 7/14", en: "Eye · 7/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bqarcrdrbsds", white: "cobpcqdqfqer" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "real",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bqarcrdrbsds", white: "cobpcqdqfqer" },
                marks: { A: "br" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-8",
        chapterId: "beginner-level1",
        order: 314,
        title: { zh: "眼 · 8/14", en: "Eye · 8/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "boapbqcqarcrdrbs", white: "bncnbpcpdpdqfqer" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "boapbqcqarcrdrbs", white: "bncnbpcpdpdqfqer" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-9",
        chapterId: "beginner-level1",
        order: 315,
        title: { zh: "眼 · 9/14", en: "Eye · 9/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bobpaqcqfqbrdr", white: "anbncnaoapcpdp" },
            marks: { A: "bq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bobpaqcqfqbrdr", white: "anbncnaoapcpdp" },
                marks: { A: "bq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-10",
        chapterId: "beginner-level1",
        order: 316,
        title: { zh: "眼 · 10/14", en: "Eye · 10/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dqeqbrdrfrascses", white: "clcodpbqcqcr" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dqeqbrdrfrascses", white: "clcodpbqcqcr" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-11",
        chapterId: "beginner-level1",
        order: 317,
        title: { zh: "眼 · 11/14", en: "Eye · 11/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bpbqarcrdrerbs", white: "cnboapcpcqdqeqfqfr" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "real",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpbqarcrdrerbs", white: "cnboapcpcqdqeqfqfr" },
                marks: { A: "br" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-12",
        chapterId: "beginner-level1",
        order: 318,
        title: { zh: "眼 · 12/14", en: "Eye · 12/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "boapbqarcrdrerbs", white: "bncndobpcpcqdqeqfqfr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "boapbqarcrdrerbs", white: "bncndobpcpcqdqeqfqfr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-13",
        chapterId: "beginner-level1",
        order: 319,
        title: { zh: "眼 · 13/14", en: "Eye · 13/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "doeocpepcqdqbrdrercs", white: "dmcnfncofobpfpeqfqfr" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "doeocpepcqdqbrdrercs", white: "dmcnfncofobpfpeqfqfr" },
                marks: { A: "dp" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-eye-14",
        chapterId: "beginner-level1",
        order: 320,
        title: { zh: "眼 · 14/14", en: "Eye · 14/14" },
        instruction: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cnbobpbqdqarcrdrbs", white: "coeocpepcqeqgqfrcsdses" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "A是真眼还是假眼？", en: "Is A a real or a false eye?" },
            options: [{ value: "real", label: { zh: "真眼", en: "Real" } }, { value: "false", label: { zh: "假眼", en: "False" } }],
            correctValue: "false",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cnbobpbqdqarcrdrbs", white: "coeocpepcqeqgqfrcsdses" },
                marks: { A: "br" },
            },
        },
    },
];

const bl1FalseEyeLevels: Level[] = [
    {
        id: "beginner-level1-bl1-false-eye-1",
        chapterId: "beginner-level1",
        order: 321,
        title: { zh: "假眼 · 1/12", en: "False Eye · 1/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbnboapaqbqarcrbs", white: "bmcmcncocpcqeqdr" },
            marks: { A: "ao" },
            correct: ["bp"],
            wrong: ["ambp"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-2",
        chapterId: "beginner-level1",
        order: 322,
        title: { zh: "假眼 · 2/12", en: "False Eye · 2/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boapbqarcrbs", white: "bncocpcqeqdr" },
            marks: { A: "aq" },
            correct: ["bp"],
            wrong: ["aobp", "anbp"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-3",
        chapterId: "beginner-level1",
        order: 323,
        title: { zh: "假眼 · 3/12", en: "False Eye · 3/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpaqcqbrdrercs", white: "cpdpdqfqfresfs" },
            marks: { A: "cr" },
            correct: ["ds"],
            wrong: ["eqds"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-4",
        chapterId: "beginner-level1",
        order: 324,
        title: { zh: "假眼 · 4/12", en: "False Eye · 4/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncnaocobpbqcqbrdrcs", white: "ambmcmdmandndpdqfqer" },
            marks: { A: "bo" },
            correct: ["cp"],
            wrong: ["docp"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-5",
        chapterId: "beginner-level1",
        order: 325,
        title: { zh: "假眼 · 5/12", en: "False Eye · 5/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbpbqarcrdrbs", white: "dpeqercsdses" },
            marks: { A: "br" },
            correct: ["cq"],
            wrong: ["dqcq", "cpcq"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-6",
        chapterId: "beginner-level1",
        order: 326,
        title: { zh: "假眼 · 6/12", en: "False Eye · 6/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnenbodofoapcpepbqbrbs", white: "bmcmdmembnfngngogpdqeqfqcr" },
            marks: { A: "co" },
            correct: ["dp"],
            wrong: ["cqdp"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-7",
        chapterId: "beginner-level1",
        order: 327,
        title: { zh: "假眼 · 7/12", en: "False Eye · 7/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnaoboapbqarcrdrbs", white: "bmcmcncocpfpcqeq" },
            marks: { A: "aq" },
            correct: ["bp"],
            wrong: ["ambp"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-8",
        chapterId: "beginner-level1",
        order: 328,
        title: { zh: "假眼 · 8/12", en: "False Eye · 8/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndncocpcqeqbrdrercs", white: "emendodpfpdqfqfresfs" },
            marks: { A: "cr" },
            correct: ["ds"],
            wrong: ["epds"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-9",
        chapterId: "beginner-level1",
        order: 329,
        title: { zh: "假眼 · 9/12", en: "False Eye · 9/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncnaocobpbqcqdrer", white: "ambmcmdmencpdpfpdqfq" },
            marks: { A: "bo" },
            correct: ["an"],
            wrong: ["doan", "dnan", "apan"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-10",
        chapterId: "beginner-level1",
        order: 330,
        title: { zh: "假眼 · 10/12", en: "False Eye · 10/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "amanbodofoapcpdpfpbqbrcrdr", white: "blembncnfngngogpcqdqeqfqhq" },
            marks: { A: "bp" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-11",
        chapterId: "beginner-level1",
        order: 331,
        title: { zh: "假眼 · 11/12", en: "False Eye · 11/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpdpbqdqbrcrerdses", white: "cmdnenbocofocpfpcqfqfrfs" },
            marks: { A: "dr" },
            correct: ["eq"],
            wrong: ["epeq", "eoeq"],
        },
    },
    {
        id: "beginner-level1-bl1-false-eye-12",
        chapterId: "beginner-level1",
        order: 332,
        title: { zh: "假眼 · 12/12", en: "False Eye · 12/12" },
        instruction: { zh: "白先。请将眼A做成假眼。", en: "White to play. Make eye A false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodoeoapcpbqarcrcs", white: "bmcmandnenfnfodpfpcqdqgqdr" },
            marks: { A: "bp" },
            correct: ["ao"],
            wrong: ["bnao", "cnao"],
        },
    },
];

const bl1CountEyesLevels: Level[] = [
    {
        id: "beginner-level1-bl1-count-eyes-1",
        chapterId: "beginner-level1",
        order: 333,
        title: { zh: "数眼 · 1/12", en: "Count Eyes · 1/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpepaqdqdr", white: "bqcqarcrbscs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "apbpcpepaqdqdr", white: "bqcqarcrbscs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-2",
        chapterId: "beginner-level1",
        order: 334,
        title: { zh: "数眼 · 2/12", en: "Count Eyes · 2/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpepaqbqcqeqgqarfr", white: "dqbrcrerbsds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpepaqbqcqeqgqarfr", white: "dqbrcrerbsds" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-3",
        chapterId: "beginner-level1",
        order: 335,
        title: { zh: "数眼 · 3/12", en: "Count Eyes · 3/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boepgpbqcqeqgqiqhr", white: "fqarbrcrdrergrcsesfsgs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "boepgpbqcqeqgqiqhr", white: "fqarbrcrdrergrcsesfsgs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-4",
        chapterId: "beginner-level1",
        order: 336,
        title: { zh: "数眼 · 4/12", en: "Count Eyes · 4/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpepfphpcqgqbrhrfsgs", white: "dqeqcrerfrgrds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpepfphpcqgqbrhrfsgs", white: "dqeqcrerfrgrds" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-5",
        chapterId: "beginner-level1",
        order: 337,
        title: { zh: "数眼 · 5/12", en: "Count Eyes · 5/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcndnenbofobpfpgpcqgqcrgrdsfs", white: "codoeocpepdqfqdrerfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcndnenbofobpfpgpcqgqcrgrdsfs", white: "codoeocpepdqfqdrerfr" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-6",
        chapterId: "beginner-level1",
        order: 338,
        title: { zh: "数眼 · 6/12", en: "Count Eyes · 6/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "encogoephpbqcqeqhqcrhrgshs", white: "fqgqarbrdrergrbscsesfs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "encogoephpbqcqeqhqcrhrgshs", white: "fqgqarbrdrergrbscsesfs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-7",
        chapterId: "beginner-level1",
        order: 339,
        title: { zh: "数眼 · 7/12", en: "Count Eyes · 7/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnengnbocofobpgpbqgqcrfrgrcsds", white: "doeocpepfpcqdqfqdrer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dnengnbocofobpgpbqgqcrfrgrcsds", white: "doeocpepfpcqdqfqdrer" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-8",
        chapterId: "beginner-level1",
        order: 340,
        title: { zh: "数眼 · 8/12", en: "Count Eyes · 8/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndngnboeofobpgpcqgqbrcrhrdses", white: "codocpepfpdqfqdrerfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cndngnboeofobpgpcqgqbrcrhrdses", white: "codocpepfpdqfqdrerfr" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-9",
        chapterId: "beginner-level1",
        order: 341,
        title: { zh: "数眼 · 9/12", en: "Count Eyes · 9/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elfldmgmcndnfnbocogohobqcqgqhqcrdrfrgrfs", white: "endofocpepgpdqfqer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "0",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "elfldmgmcndnfnbocogohobqcqgqhqcrdrfrgrfs", white: "endofocpepgpdqfqer" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-10",
        chapterId: "beginner-level1",
        order: 342,
        title: { zh: "数眼 · 10/12", en: "Count Eyes · 10/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlemfmgmbncndnhnhobpbqcqeqfqgqcr", white: "enfncodofocpepfpdq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dlemfmgmbncndnhnhobpbqcqeqfqgqcr", white: "enfncodofocpepfpdq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-11",
        chapterId: "beginner-level1",
        order: 343,
        title: { zh: "数眼 · 11/12", en: "Count Eyes · 11/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnenfnbogogpbqfqbrcrgrds", white: "codoeocpepfpcqdqerfr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncndnenfnbogogpbqfqbrcrgrds", white: "codoeocpepfpcqdqerfr" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-count-eyes-12",
        chapterId: "beginner-level1",
        order: 344,
        title: { zh: "数眼 · 12/12", en: "Count Eyes · 12/12" },
        instruction: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnengnbocofohodphpbqcqhqcrdrerhres", white: "doeocpfpgpdqeqgqfrgr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋棋块有几个真眼？", en: "How many real eyes does the white group have?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dnengnbocofohodphpbqcqhqcrdrerhres", white: "doeocpfpgpdqeqgqfrgr" },
            },
        },
    },
];

const bl1CloseTerritoryLevels: Level[] = [
    {
        id: "beginner-level1-bl1-close-territory-1",
        chapterId: "beginner-level1",
        order: 345,
        title: { zh: "领地 · 1/13", en: "Territory · 1/13" },
        instruction: { zh: "黑棋的棋块是安全的，因为它有两个眼。在收官阶段，黑棋可以再围出两个目。黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black's group is safe, because it has two eyes. In the endgame Black can make two more territory points. Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aparbrcqcsdqdrds", white: "aobocpdndpeqeresfsgr" },
            marks: { cross: "bp" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-2",
        chapterId: "beginner-level1",
        order: 346,
        title: { zh: "领地 · 2/13", en: "Territory · 2/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aqbqdqbrcreres", white: "apbpcpdpepcqfqfrfs" },
            correct: ["eq"],
            wrong: ["dreq"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-3",
        chapterId: "beginner-level1",
        order: 347,
        title: { zh: "领地 · 3/13", en: "Territory · 3/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndndocpcrdrds", white: "ambmcmdmemeneoepdqeqeres" },
            correct: ["cq"],
            wrong: ["dpcqbqbr"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-4",
        chapterId: "beginner-level1",
        order: 348,
        title: { zh: "领地 · 4/13", en: "Territory · 4/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnaocobpcpbqdqdrds", white: "clambmcndndofoepeqeres" },
            correct: ["an"],
            wrong: ["dpan"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-5",
        chapterId: "beginner-level1",
        order: 349,
        title: { zh: "领地 · 5/13", en: "Territory · 5/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndncpdqbrdrds", white: "ambmcmdmemendoeoepeqeres" },
            correct: ["co"],
            wrong: ["dpcobobp", "dpcobpbo"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-6",
        chapterId: "beginner-level1",
        order: 350,
        title: { zh: "领地 · 6/13", en: "Territory · 6/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbnbodobqdqdrds", white: "ambmcmdmeneodpepeqeres" },
            correct: ["cp"],
            wrong: ["cocp", "dncp"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-7",
        chapterId: "beginner-level1",
        order: 351,
        title: { zh: "领地 · 7/13", en: "Territory · 7/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmcndncpdpbqdqcrbs", white: "alblcldmemencodoeoepeqdrfrcsds" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-8",
        chapterId: "beginner-level1",
        order: 352,
        title: { zh: "领地 · 8/13", en: "Territory · 8/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeoapbpcpeqcreres", white: "bmcndnenfnaobofogpfqfrgs" },
            correct: ["ep"],
            wrong: ["fpep", "coepdpfp"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-9",
        chapterId: "beginner-level1",
        order: 353,
        title: { zh: "领地 · 9/13", en: "Territory · 9/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmdnbodobqdqdrds", white: "alblcldlelemencoeodpepeqeres" },
            correct: ["cp"],
            wrong: ["cncp", "cqcp"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-10",
        chapterId: "beginner-level1",
        order: 354,
        title: { zh: "领地 · 10/13", en: "Territory · 10/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndneocpepdrfres", white: "ambmcmdmemengnfofpeqgqgrfsgs" },
            correct: ["dq"],
            wrong: ["fqer", "erdqfqcr"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-11",
        chapterId: "beginner-level1",
        order: 355,
        title: { zh: "领地 · 11/13", en: "Territory · 11/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alamcmdmcododpcqeqeres", white: "akbkcldlelbmemeneoepfqfrfs" },
            correct: ["bnblandncn"],
            wrong: ["bnbldnan", "blan", "dnbn"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-12",
        chapterId: "beginner-level1",
        order: 356,
        title: { zh: "领地 · 12/13", en: "Territory · 12/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpepcqfqbrdrfrasbscsds", white: "cndoeogobpcpfpaqbqgqargrfsgs" },
            correct: ["er"],
            wrong: ["eseq", "eqes"],
        },
    },
    {
        id: "beginner-level1-bl1-close-territory-13",
        chapterId: "beginner-level1",
        order: 357,
        title: { zh: "领地 · 13/13", en: "Territory · 13/13" },
        instruction: { zh: "黑先。请下出最佳着法来封闭黑棋的领地。", en: "Black to play. Play the best move to close Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnencofocpgpcqdqeqfqgq", white: "dmemcnfngnbogobphpbqhqcrdrerfrgr" },
            correct: ["eo", "ep"],
            wrong: ["doep", "fpeodoep"],
        },
    },
];

const bl1ReduceTerritoryLevels: Level[] = [
    {
        id: "beginner-level1-bl1-reduce-territory-1",
        chapterId: "beginner-level1",
        order: 358,
        title: { zh: "领地 · 1/7", en: "Territory · 1/7" },
        instruction: { zh: "黑棋的棋块有两个眼，因此白棋无法吃掉它。在收官阶段，白棋可以阻止黑棋再围出两个目。白先。请下出最佳着法来缩减黑棋的领地。", en: "Black's group has two eyes, so White can not capture it. In the endgame White can prevent Black from making two additional territory points. White to play. Play the best move to reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aparbrcqcsdqdrds", white: "aobocpdndpeqeresfsgr" },
            marks: { cross: "bp" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level1-bl1-reduce-territory-2",
        chapterId: "beginner-level1",
        order: 359,
        title: { zh: "领地 · 2/7", en: "Territory · 2/7" },
        instruction: { zh: "白先。请缩减黑棋的领地。", en: "White to play. Reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boapbpcpdpdqbrcrdr", white: "cmanbncodofoepeqerds" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level1-bl1-reduce-territory-3",
        chapterId: "beginner-level1",
        order: 360,
        title: { zh: "领地 · 3/7", en: "Territory · 3/7" },
        instruction: { zh: "白先。请缩减黑棋的领地。", en: "White to play. Reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqardrbs", white: "apbpcpdpfpeqer" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level1-bl1-reduce-territory-4",
        chapterId: "beginner-level1",
        order: 361,
        title: { zh: "领地 · 4/7", en: "Territory · 4/7" },
        instruction: { zh: "白先。请缩减黑棋的领地。", en: "White to play. Reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpepaqbqeqfqcrfres", white: "aobocodoeogofpgqgr" },
            correct: ["dp"],
        },
    },
    {
        id: "beginner-level1-bl1-reduce-territory-5",
        chapterId: "beginner-level1",
        order: 362,
        title: { zh: "领地 · 5/7", en: "Territory · 5/7" },
        instruction: { zh: "白先。请缩减黑棋的领地。", en: "White to play. Reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpaqdqbr", white: "aobocodofoepeq" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level1-bl1-reduce-territory-6",
        chapterId: "beginner-level1",
        order: 363,
        title: { zh: "领地 · 6/7", en: "Territory · 6/7" },
        instruction: { zh: "白先。请缩减黑棋的领地。", en: "White to play. Reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aoapbpcqdqeqcrerds", white: "anbnbocodpepgpfqfrfs" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level1-bl1-reduce-territory-7",
        chapterId: "beginner-level1",
        order: 364,
        title: { zh: "领地 · 7/7", en: "Territory · 7/7" },
        instruction: { zh: "白先。请缩减黑棋的领地。", en: "White to play. Reduce Black's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqaqcpbpboaobn", white: "dqdpdococnbmamcl" },
            correct: ["cr", "drcrcs"],
        },
    },
];

const bl1CapturingRace1Levels: Level[] = [
    {
        id: "beginner-level1-bl1-capturing-race-1-1",
        chapterId: "beginner-level1",
        order: 365,
        title: { zh: "对杀 · 1/24", en: "Capturing Race · 1/24" },
        instruction: { zh: "两个标记的棋串都有3口气。在紧气时，你必须注意从哪口气开始。你有两块战斗棋串共用的气（公气A），还有外部的气（外气B和C）。始终先紧外气。白先。请赢得标记棋串之间的对杀。", en: "Both marked chains have 3 liberties. In filling the liberties of your opponent, you must pay attention with which liberties to start. You have liberties shared by the two struggling chains (common liberty A) and liberties at the outside (outside liberties B and C). Always start with filling the outside liberties. White to play. Win the capturing race between the marked chains." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdneneoapbpcpdp", white: "bnbocodoepfpcqdq" },
            marks: { triangle: "bnbocodoapbpcpdp", A: "ao", B: "aq", C: "bq" },
            correct: ["bqanaq", "aqbqbrarao"],
            wrong: ["bqanaocn", "aocn", "aqbqaobr", "aqbqarbrcras", "aqbqarbraocn"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-2",
        chapterId: "beginner-level1",
        order: 366,
        title: { zh: "对杀 · 2/24", en: "Capturing Race · 2/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldmemenaobocodo", white: "anbncndneodpepbqcq" },
            marks: { triangle: "anbncndnaobocodo" },
            correct: ["cpcmbp", "cpcmap", "apcmbp", "apcmcp", "bpcmap", "bpcmcp"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-3",
        chapterId: "beginner-level1",
        order: 367,
        title: { zh: "对杀 · 3/24", en: "Capturing Race · 3/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbncocpcqfqbr", white: "blclcndnbobp" },
            marks: { triangle: "bmbnbobp" },
            correct: ["cmbqam", "cmbqan", "anamcmaoal", "anamalaocm", "amancmalao", "amanalbqcm", "amanaoalcm"],
            wrong: ["anamcmaoapbq", "anamaobq", "anamalaoapbq", "amancmalakbq", "amanalbqaoap", "amanaoalakbq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-4",
        chapterId: "beginner-level1",
        order: 368,
        title: { zh: "对杀 · 4/24", en: "Capturing Race · 4/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boapbpcpepdqfqcrdrbs", white: "dmbncododpbqcqarbr" },
            marks: { triangle: "boapbpcpbqcqarbr" },
            correct: ["ancsao"],
            wrong: ["ancsaqas", "aqas"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-5",
        chapterId: "beginner-level1",
        order: 369,
        title: { zh: "对杀 · 5/24", en: "Capturing Race · 5/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncnbododpcqeqbr", white: "blcmdmdncoapbpcp" },
            marks: { triangle: "anbncnbocoapbpcp" },
            correct: ["ambqbm", "bmbqam"],
            wrong: ["ambqaoaq", "bmbqaoaq", "aobq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-6",
        chapterId: "beginner-level1",
        order: 370,
        title: { zh: "对杀 · 6/24", en: "Capturing Race · 6/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpcqeqfqbrergres", white: "epfpgpdqhqdrdsfs" },
            marks: { triangle: "dqeqfqdrergrdses" },
            correct: ["gqfrhrgshs"],
            wrong: ["frgs", "hrcr"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-7",
        chapterId: "beginner-level1",
        order: 371,
        title: { zh: "对杀 · 7/24", en: "Capturing Race · 7/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncnbododpdqgqbr", white: "bldmdncoapbpcp" },
            marks: { triangle: "anbncnbocoapbpcp" },
            correct: ["cmcqbmbqam", "cmcqambqbm", "bmbqcmcqam", "bmbqamcqcm", "amcqbmbqcm", "amcqcmbqbm"],
            wrong: ["cmcqbmbqaoaq", "cmcqambqaoaq", "cmcqaobq", "bmbqcmcqaoaq", "bmbqamcqaoaq", "bmbqaocq", "amcqbmbqaoaq", "amcqcmbqaoaq", "amcqaobq", "aobq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-8",
        chapterId: "beginner-level1",
        order: 372,
        title: { zh: "对杀 · 8/24", en: "Capturing Race · 8/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fogoephpeqhqerhresfs", white: "doeocpfpcqfqgqdrgrdsgs" },
            marks: { triangle: "epfpeqfqgqergresfsgs" },
            correct: ["dpgpdq", "dqgpdp"],
            wrong: ["dpgpfrhs", "dqgpfrhs", "frgp"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-9",
        chapterId: "beginner-level1",
        order: 373,
        title: { zh: "对杀 · 9/24", en: "Capturing Race · 9/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcndodpbqcqbr", white: "bpcpepdqfqcrdr" },
            marks: { triangle: "bpcpbqcqbr" },
            correct: ["bsboaq", "bsboar", "bsboapaoar", "bsboapaoaq", "aqbsarbocs", "aqbsarboapaocs", "aqbscsboar", "apboaq"],
            wrong: ["aqbsarboapaoasco", "aqbsarboasap"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-10",
        chapterId: "beginner-level1",
        order: 374,
        title: { zh: "对杀 · 10/24", en: "Capturing Race · 10/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndncoeoepbqcqdqeq", white: "bmcmdmenfndobpcpdp" },
            marks: { triangle: "anbncndncodobpcpdp" },
            correct: ["aoaqam"],
            wrong: ["aoaqboap", "amap", "boap"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-11",
        chapterId: "beginner-level1",
        order: 375,
        title: { zh: "对杀 · 11/24", en: "Capturing Race · 11/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndodpbqcqbrbs", white: "bpcpepdqfqcrdrcs" },
            marks: { triangle: "bsbrcqbqcpbp" },
            correct: ["aqboar", "aqboas", "apaoaq", "apaoar", "apaoas", "arapaoboaq", "arapaqasaq", "arapaqasao", "araqap", "arboaq", "arcoaq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-12",
        chapterId: "beginner-level1",
        order: 376,
        title: { zh: "对杀 · 12/24", en: "Capturing Race · 12/24" },
        instruction: { zh: "白先。请赢得标记棋块之间的对杀。", en: "White to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpepcqfqgqcrgrhrircsgs", white: "fpgpdqeqhqiqjqdrfrjrdses" },
            marks: { triangle: "dqeqfqgqdrfrgrhrirdsesgs" },
            correct: ["is"],
            wrong: ["fser", "hsis", "jsfs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-13",
        chapterId: "beginner-level1",
        order: 377,
        title: { zh: "对杀 · 13/24", en: "Capturing Race · 13/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codocpepcqeqfqcrfrgrcs", white: "eofodpfphpdqgqdrhrdsgs" },
            marks: { triangle: "dpepdqeqfqdrfrgrds" },
            correct: ["es", "er"],
            wrong: ["fshs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-14",
        chapterId: "beginner-level1",
        order: 378,
        title: { zh: "对杀 · 14/24", en: "Capturing Race · 14/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ckbldlbmdnencoapbpcp", white: "cmanbncnbododpdqgqbr" },
            marks: { triangle: "cmanbncnbocoapbpcp" },
            correct: ["ambqdmaqcl", "ambqclaqdm", "dmbqamaqcl", "dmbqclaqam", "clbqdmaqam", "clbqamaqdm"],
            wrong: ["ambqdmaqaocq", "ambqclaqaocq", "ambqaoaq", "dmbqamaqaocq", "dmbqclaqaocq", "dmbqaoaq", "clbqdmaqaocq", "clbqamaqaocq", "clbqaoaq", "aobq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-15",
        chapterId: "beginner-level1",
        order: 379,
        title: { zh: "对杀 · 15/24", en: "Capturing Race · 15/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndnaoeodpepcqbr", white: "blcmdmemencodoapbpcp" },
            marks: { triangle: "anbncndnaocodoapbpcp" },
            correct: ["bqbmaq", "aqbmbq"],
            wrong: ["bqbmboam", "aqbmboam", "bobm"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-16",
        chapterId: "beginner-level1",
        order: 380,
        title: { zh: "对杀 · 16/24", en: "Capturing Race · 16/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndnboeoepdqeqbr", white: "clbmemenaodoapbpcpdp" },
            marks: { triangle: "anbncndnaobodoapbpcpdp" },
            correct: ["bqcmcqdmaq", "bqcmaqdmcq", "aqcmcqdmbq", "aqcmbqdmcq", "cqcmbqdmaq", "cqcmaqdmbq"],
            wrong: ["bqcmcqdmcoam", "bqcmaqdmcoam", "bqcmcodm", "aqcmcqdmcoam", "aqcmbqdmcoam", "aqcmcodm", "cqcmbqdmcoam", "cqcmaqdmcoam", "cqcmcodm", "cocm"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-17",
        chapterId: "beginner-level1",
        order: 381,
        title: { zh: "对杀 · 17/24", en: "Capturing Race · 17/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodpepdr", white: "bmdndoapbpcp" },
            marks: { triangle: "aobocoapbpcp" },
            correct: ["cqbnbq"],
            wrong: ["bqcqcrbrdqaqbscnasbn", "bqcqcrbrdqaqbscnaras", "bqcqcrbraqardqcnbqaqbsbn", "bqcqbrcn", "bqcqdqbrcraqbscnasbn", "bqcqdqbrcraqbscnaras", "bqcqdqbrcraqcsbs", "aqbrcqbqcrcnbsarcsbn", "aqbrbqcqcrardqcnbqaq", "aqbrbqcqcrardqcnaqbq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-18",
        chapterId: "beginner-level1",
        order: 382,
        title: { zh: "对杀 · 18/24", en: "Capturing Race · 18/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blamcmdmdndoapbpcp", white: "clbmbncncodpepaqbqcqgq" },
            marks: { triangle: "bmbncncoapbpcp" },
            correct: ["an"],
            wrong: ["boao", "aobkanal", "aobkalak"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-19",
        chapterId: "beginner-level1",
        order: 383,
        title: { zh: "对杀 · 19/24", en: "Capturing Race · 19/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epfpdqgqhqiqdrirds", white: "cpdpcqeqfqbrergrhres" },
            marks: { triangle: "dqeqfqdrergrhrdses" },
            correct: ["fsfrhs"],
            wrong: ["fsfriscr", "fsfrgshs", "frfshscr", "frfsgshs", "hscr", "gscr"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-20",
        chapterId: "beginner-level1",
        order: 384,
        title: { zh: "对杀 · 20/24", en: "Capturing Race · 20/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmandndoapbpcp", white: "bmcnaobocodpcqdqgq" },
            marks: { triangle: "bmcnaobocoapbpcp" },
            correct: ["cmbnblamal"],
            wrong: ["cmbnamal", "bncmblam", "blbq", "ambq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-21",
        chapterId: "beginner-level1",
        order: 385,
        title: { zh: "对杀 · 21/24", en: "Capturing Race · 21/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blclcmdndoeoapbpcpcqarcr", white: "bmdmemancnfnaobocodpfpdq" },
            marks: { triangle: "bmancndnaobocodoeo" },
            correct: ["alfoam"],
            wrong: ["amalakbk"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-22",
        chapterId: "beginner-level1",
        order: 386,
        title: { zh: "对杀 · 22/24", en: "Capturing Race · 22/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncnencodpepbqcqarbr", white: "bofoapbpcpfpdqfqcrerbs" },
            marks: { triangle: "boapbpcpbqcqarbr" },
            correct: ["ancsao"],
            wrong: ["ancsaqas", "aqas", "aoanambm"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-23",
        chapterId: "beginner-level1",
        order: 387,
        title: { zh: "对杀 · 23/24", en: "Capturing Race · 23/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpgphpdqeqhqdrhrds", white: "cpdpepcqfqgqcrgrgs" },
            marks: { triangle: "dqeqfqgqdrgrdsgs" },
            correct: ["hserfs", "hserescsfr"],
            wrong: ["hserescsfsfr", "hserfrfsescs", "frfsercs", "frfseser", "erfshscs", "erfsfrcs", "erfsescs", "fsfrescs", "fsfreres", "fsfrhses", "esfrfscs", "esfrhscs", "esfrercs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-1-24",
        chapterId: "beginner-level1",
        order: 388,
        title: { zh: "对杀 · 24/24", en: "Capturing Race · 24/24" },
        instruction: { zh: "黑先。请赢得标记棋块之间的对杀。", en: "Black to play. Win the capturing race between the marked groups." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlbmcmancncododpbqcqarbr", white: "dmbnboeoapbpcpepdqfqcrerbs" },
            marks: { triangle: "bnboapbpcpbqcqarbr" },
            correct: ["amcsao"],
            wrong: ["amcsaqas", "aoamalaq", "aoamancsalas", "aoamancsaqas", "aoamaqas", "aqas"],
        },
    },
];

const bl1CapturingRace2Levels: Level[] = [
    {
        id: "beginner-level1-bl1-capturing-race-2-1",
        chapterId: "beginner-level1",
        order: 389,
        title: { zh: "对杀 · 1/13", en: "Capturing Race · 1/13" },
        instruction: { zh: "白先。你可以攻击两个标记棋串中的任何一个。你必须始终先攻击最重要的棋串。如果你先攻击标记的两颗棋子，你将失去正在被攻击的三颗棋子。但如果你先吃掉四颗棋子的棋串，你的三颗棋子就安全了。", en: "White to play. You can attack each of the two marked chains. You must always attack the most important chain first. If you attack the two marked stones first, you will loose the three stones under attack. But if you first capture the chain of four stones, your three stones are safe." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "brbscqdqdseqerfpgqhphr", white: "aqarbpbqcpcrdpepfqfrfs" },
            marks: { square: "brbs", triangle: "cqdqeqer", cross: "es" },
            correct: ["es"],
            wrong: ["asgr"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-2",
        chapterId: "beginner-level1",
        order: 390,
        title: { zh: "对杀 · 2/13", en: "Capturing Race · 2/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aoapgpbqcqeqardrerds", white: "dmanbncobpdpdqbrcrbs" },
            correct: ["cpaqbo"],
            wrong: ["bocs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-3",
        chapterId: "beginner-level1",
        order: 391,
        title: { zh: "对杀 · 3/13", en: "Capturing Race · 3/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eoephpcqdqfqbrcrfrhr", white: "fobpcpdpfpbqeqarer" },
            correct: ["en"],
            wrong: ["bses", "drds", "dres", "gqes"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-4",
        chapterId: "beginner-level1",
        order: 392,
        title: { zh: "对杀 · 4/13", en: "Capturing Race · 4/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "embncnbobpdpcqcrdrercs", white: "gmcodoeogocpbqfqbrfrbses" },
            correct: ["eq"],
            wrong: ["epaq", "apar"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-5",
        chapterId: "beginner-level1",
        order: 393,
        title: { zh: "对杀 · 5/13", en: "Capturing Race · 5/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpcqeqfqarbrcrfr", white: "cmboeocpepaqbqdqdrer" },
            correct: ["dn"],
            wrong: ["cses", "fsds"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-6",
        chapterId: "beginner-level1",
        order: 394,
        title: { zh: "对杀 · 6/13", en: "Capturing Race · 6/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqgqhqcrdrfrfs", white: "bpdpepfpcqfqbrgrgs" },
            correct: ["es"],
            wrong: ["cshr"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-7",
        chapterId: "beginner-level1",
        order: 395,
        title: { zh: "对杀 · 7/13", en: "Capturing Race · 7/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hoepfpgpdqeqhqiqarbrcrgrfs", white: "coeofodpaqbqcqfqgqdrerfr" },
            correct: ["hr"],
            wrong: ["cses"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-8",
        chapterId: "beginner-level1",
        order: 396,
        title: { zh: "对杀 · 8/13", en: "Capturing Race · 8/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eneoepdqfqbrcrdrgr", white: "cmdndodpbqcqeqarerfr" },
            correct: ["gqfphr"],
            wrong: ["dsfs", "bsfs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-9",
        chapterId: "beginner-level1",
        order: 397,
        title: { zh: "对杀 · 9/13", en: "Capturing Race · 9/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmhmfnaobocodofoepfpdqbrdr", white: "clelbmfmengneoapbpcpdpeqgqer" },
            correct: ["go"],
            wrong: ["gpgo", "fqgo", "bnbq", "anbq", "cnbq", "dnbq", "dsbq", "cqcr", "crcq"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-10",
        chapterId: "beginner-level1",
        order: 398,
        title: { zh: "对杀 · 10/13", en: "Capturing Race · 10/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hpbqcqfqgqbrdrerhr", white: "cnbpcpaqdqeqarfrgres" },
            correct: ["ds"],
            wrong: ["bsgs", "hsfsgsis"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-11",
        chapterId: "beginner-level1",
        order: 399,
        title: { zh: "对杀 · 11/13", en: "Capturing Race · 11/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gneodpepcqdqarbrerfr", white: "dmdnbodocpaqbqeqfqgqcrdr" },
            correct: ["bs"],
            wrong: ["grds", "grcs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-12",
        chapterId: "beginner-level1",
        order: 400,
        title: { zh: "对杀 · 12/13", en: "Capturing Race · 12/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dncpdpcqeqfqbrergr", white: "epfphpdqgqcrdrhr" },
            correct: ["es"],
            wrong: ["gsds", "gscs"],
        },
    },
    {
        id: "beginner-level1-bl1-capturing-race-2-13",
        chapterId: "beginner-level1",
        order: 401,
        title: { zh: "对杀 · 13/13", en: "Capturing Race · 13/13" },
        instruction: { zh: "白先。请攻击正确的棋串并赢得对杀。", en: "White to play. Attack the correct chain and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gndoeodqeqarbrcrfrgr", white: "dmcncohpaqbqcqfqgqdrerhr" },
            correct: ["gs", "fs"],
            wrong: ["cses"],
        },
    },
];

const bl1Seki1Levels: Level[] = [
    {
        id: "beginner-level1-bl1-seki-1-1",
        chapterId: "beginner-level1",
        order: 402,
        title: { zh: "双活 · 1/14", en: "Seki · 1/14" },
        instruction: { zh: "标记的两个棋串都有两口气。如果白棋或黑棋在A或B落子，会使自己的棋串被打吃。因此，双方都不会在A或B落子。这叫做‘双活’。棋盘上的局面将保持原样。终局时，双方棋块都是活棋。它们之间的空点将保持为空。这些空点不算作任何一方的领地。", en: "Both marked chains have two liberties. If White or Black plays at A or B, he puts his own chain in atari. So, both players will not play at A or B. This is called 'seki'. The position stays as it is on the board. When the game is finished, neither group is dead. The empty points in between will stay empty. These points do not count as territory for either of the players." },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpcqcrcsdpepfqfrfs", white: "dqdrdseqfpgpgqgrgs" },
            marks: { triangle: "dqdrdseqfqfrfs", A: "er", B: "es" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "标记的两个棋串都有两口气。如果白棋或黑棋在A或B落子，会使自己的棋串被打吃。因此，双方都不会在A或B落子。这叫做‘双活’。棋盘上的局面将保持原样。终局时，双方棋块都是活棋。它们之间的空点将保持为空。这些空点不算作任何一方的领地。", en: "Both marked chains have two liberties. If White or Black plays at A or B, he puts his own chain in atari. So, both players will not play at A or B. This is called 'seki'. The position stays as it is on the board. When the game is finished, neither group is dead. The empty points in between will stay empty. These points do not count as territory for either of the players." },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpcqcrcsdpepfqfrfs", white: "dqdrdseqfpgpgqgrgs" },
                marks: { triangle: "dqdrdseqfqfrfs", A: "er", B: "es" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-2",
        chapterId: "beginner-level1",
        order: 403,
        title: { zh: "双活 · 2/14", en: "Seki · 2/14" },
        instruction: { zh: "这里，标记的两个棋串各有一个眼，并且它们共享A点的一口气。如果白棋或黑棋在A落子，会使自己的棋串被打吃。因此，双方都不会在A落子。这同样是双活。", en: "Here, both marked chains have one eye and they share a common liberty at A. If White or Black plays at A, he puts his own chain in atari. So, both players will not play at A. This is again seki." },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "alarblbrbsclcmcncocpcqdqeqfqgqgrgs", white: "amaoaqbmbnbobpbqcrdrdserfrfs" },
            marks: { triangle: "arbrbscrdrdserfrfs", A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "这里，标记的两个棋串各有一个眼，并且它们共享A点的一口气。如果白棋或黑棋在A落子，会使自己的棋串被打吃。因此，双方都不会在A落子。这同样是双活。", en: "Here, both marked chains have one eye and they share a common liberty at A. If White or Black plays at A, he puts his own chain in atari. So, both players will not play at A. This is again seki." },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "alarblbrbsclcmcncocpcqdqeqfqgqgrgs", white: "amaoaqbmbnbobpbqcrdrdserfrfs" },
                marks: { triangle: "arbrbscrdrdserfrfs", A: "cs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-3",
        chapterId: "beginner-level1",
        order: 404,
        title: { zh: "双活 · 3/14", en: "Seki · 3/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpdpepfpbqfqbrerbses", white: "cqdqeqgqcrfrhrcsfs" },
            marks: { triangle: "escsercreqdqcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpepfpbqfqbrerbses", white: "cqdqeqgqcrfrhrcsfs" },
                marks: { triangle: "escsercreqdqcq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-4",
        chapterId: "beginner-level1",
        order: 405,
        title: { zh: "双活 · 4/14", en: "Seki · 4/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "codoeocpfpcqfqcrfrcsfs", white: "fogodpepgpdqgqdrgrdsgs" },
            marks: { triangle: "fsdsfrdrfqdqfpepdp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codoeocpfpcqfqcrfrcsfs", white: "fogodpepgpdqgqdrgrdsgs" },
                marks: { triangle: "fsdsfrdrfqdqfpepdp" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-5",
        chapterId: "beginner-level1",
        order: 406,
        title: { zh: "双活 · 5/14", en: "Seki · 5/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "codpaqbqcqdrerfrdsfs", white: "dqeqfqgqarbrcrgrbsgs" },
            marks: { triangle: "fsdsbsfrerdrcrbrar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codpaqbqcqdrerfrdsfs", white: "dqeqfqgqarbrcrgrbsgs" },
                marks: { triangle: "fsdsbsfrerdrcrbrar" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-6",
        chapterId: "beginner-level1",
        order: 407,
        title: { zh: "双活 · 6/14", en: "Seki · 6/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eofogodpgpdqeqgqcrdrgrcsgs", white: "codocpepfpcqfqbrfrbsesfs" },
            marks: { triangle: "fsescsfrdrcrfqeqdqfpepdp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eofogodpgpdqeqgqcrdrgrcsgs", white: "codocpepfpcqfqbrfrbsesfs" },
                marks: { triangle: "fsescsfrdrcrfqeqdqfpepdp" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-7",
        chapterId: "beginner-level1",
        order: 408,
        title: { zh: "双活 · 7/14", en: "Seki · 7/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bqcqdqbrerbses", white: "eqfqgqdrgrdsgs" },
            marks: { triangle: "esdserdr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "White",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bqcqdqbrerbses", white: "eqfqgqdrgrdsgs" },
                marks: { triangle: "esdserdr" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-8",
        chapterId: "beginner-level1",
        order: 409,
        title: { zh: "双活 · 8/14", en: "Seki · 8/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "doeodpfpbqcqdqfqbrfrgrbsgs", white: "fogoepgpeqhqcrdrerhrcseshs" },
            marks: { triangle: "gsescsgrfrerdrcrfqeqfpep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "White",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "doeodpfpbqcqdqfqbrfrgrbsgs", white: "fogoepgpeqhqcrdrerhrcseshs" },
                marks: { triangle: "gsescsgrfrerdrcrfqeqfpep" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-9",
        chapterId: "beginner-level1",
        order: 410,
        title: { zh: "双活 · 9/14", en: "Seki · 9/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpdpbqeqbrerbses", white: "epfpcqdqfqcrgrcsgs" },
            marks: { triangle: "escsercreqdqcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "Black",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpbqeqbrerbses", white: "epfpcqdqfqcrgrcsgs" },
                marks: { triangle: "escsercreqdqcq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-10",
        chapterId: "beginner-level1",
        order: 411,
        title: { zh: "双活 · 10/14", en: "Seki · 10/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bocpdpbqeqfqbrfrgrhrbsfs", white: "epfpcqdqgqhqiqcrerircsdshs" },
            marks: { triangle: "fsdscshrgrfrercrfqeqdqcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "White",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocpdpbqeqfqbrfrgrhrbsfs", white: "epfpcqdqgqhqiqcrerircsdshs" },
                marks: { triangle: "fsdscshrgrfrercrfqeqdqcq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-11",
        chapterId: "beginner-level1",
        order: 412,
        title: { zh: "双活 · 11/14", en: "Seki · 11/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "aqbqcqcrdrercses", white: "doapbpcpdqeqfqarfrbsfs" },
            marks: { triangle: "escsbserdrcrarcqbqaq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aqbqcqcrdrercses", white: "doapbpcpdqeqfqarfrbsfs" },
                marks: { triangle: "escsbserdrcrarcqbqaq" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-12",
        chapterId: "beginner-level1",
        order: 413,
        title: { zh: "双活 · 12/14", en: "Seki · 12/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "aobocodobpdpfpgpbqeqgqhqbrerhrbseshs", white: "bncndneneocpepcqdqfqcrfrcsfs" },
            marks: { triangle: "escsercreqdqcqcp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "Black",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobocodobpdpfpgpbqeqgqhqbrerhrbseshs", white: "bncndneneocpepcqdqfqcrfrcsfs" },
                marks: { triangle: "escsercreqdqcqcp" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-13",
        chapterId: "beginner-level1",
        order: 414,
        title: { zh: "双活 · 13/14", en: "Seki · 13/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eqfqgqhqbrcrdrhrhs", white: "aqbqcqdqarerfrgras" },
            marks: { triangle: "grfrerdrcrbr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "White",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eqfqgqhqbrcrdrhrhs", white: "aqbqcqdqarerfrgras" },
                marks: { triangle: "grfrerdrcrbr" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-seki-1-14",
        chapterId: "beginner-level1",
        order: 415,
        title: { zh: "双活 · 14/14", en: "Seki · 14/14" },
        instruction: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpdpcqeqfqgqarbrcrergrbsfs", white: "bocodobpepfpgphpaqbqdqhqdrhrdsgshs" },
            marks: { triangle: "fsdsbsgrerdrcrbrargqfqeqdqcqdpcp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。这场对杀谁会赢，还是双活？", en: "White to play. Who will win this capturing race, or is it seki?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "seki", label: { zh: "双活", en: "Seki" } }],
            correctValue: "seki",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpcqeqfqgqarbrcrergrbsfs", white: "bocodobpepfpgphpaqbqdqhqdrhrdsgshs" },
                marks: { triangle: "fsdsbsgrerdrcrbrargqfqeqdqcqdpcp" },
            },
        },
    },
];

const bl1Seki2Levels: Level[] = [
    {
        id: "beginner-level1-bl1-seki-2-1",
        chapterId: "beginner-level1",
        order: 416,
        title: { zh: "制造双活 · 1/13", en: "Make Seki · 1/13" },
        instruction: { zh: "黑先。黑棋可以通过下成双活来救出标记的棋子。请下成双活并救出标记的棋子。", en: "Black to play. Black can save the marked stones by making seki. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmcoapbpcp", white: "anbncndodpaqbqcqdq" },
            marks: { triangle: "apbpcpco", cross: "dn" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-2",
        chapterId: "beginner-level1",
        order: 417,
        title: { zh: "制造双活 · 2/13", en: "Make Seki · 2/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmdnapbpcp", white: "anbncndodpaqbqcqdq" },
            marks: { triangle: "apbpcp" },
            correct: ["co"],
            wrong: ["boco", "aoco"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-3",
        chapterId: "beginner-level1",
        order: 418,
        title: { zh: "制造双活 · 3/13", en: "Make Seki · 3/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fpgphpdqeqhqdrhrdshs", white: "cpdpepcqfqgqcrgrcsfsgs" },
            marks: { triangle: "dqeqdrds" },
            correct: ["er"],
            wrong: ["eser", "frer"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-4",
        chapterId: "beginner-level1",
        order: 419,
        title: { zh: "制造双活 · 4/13", en: "Make Seki · 4/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmemeneoapbpcp", white: "anbncndndoepaqbqcqdqeq" },
            marks: { triangle: "apbpcp" },
            correct: ["dp"],
            wrong: ["codp", "bodp", "aodp"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-5",
        chapterId: "beginner-level1",
        order: 420,
        title: { zh: "制造双活 · 5/13", en: "Make Seki · 5/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eneodpfpgpdqgqcrgrcsgs", white: "fogohoephpeqhqdrerfrhrdshs" },
            marks: { triangle: "fpgpgqgrgs" },
            correct: ["fs"],
            wrong: ["esfs", "fqfs"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-6",
        chapterId: "beginner-level1",
        order: 421,
        title: { zh: "制造双活 · 6/13", en: "Make Seki · 6/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofocpfpcqfqcrfrfs", white: "cncobpdpepbqeqbrerbses" },
            marks: { triangle: "cpcqcr" },
            correct: ["cs"],
            wrong: ["dscs", "drcs", "dqcs"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-7",
        chapterId: "beginner-level1",
        order: 422,
        title: { zh: "制造双活 · 7/13", en: "Make Seki · 7/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codocpepfpcqfqfrfs", white: "eofohodpgpdqgqdrgrdsgs" },
            marks: { triangle: "epfpfqfrfs" },
            correct: ["creqcs"],
            wrong: ["creqeres", "creqeser", "eser", "eres", "eqer"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-8",
        chapterId: "beginner-level1",
        order: 423,
        title: { zh: "制造双活 · 8/13", en: "Make Seki · 8/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcldldmcncoapbpcp", white: "bmcmanbndndodpaqbqdqcr" },
            marks: { triangle: "cncoapbpcp" },
            correct: ["alcqam"],
            wrong: ["alcqboao", "alcqaobo", "cqbo", "bocq", "aocq", "amalakcq", "amalcqbo", "amalbocq", "amalaocq"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-9",
        chapterId: "beginner-level1",
        order: 424,
        title: { zh: "制造双活 · 9/13", en: "Make Seki · 9/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmcncodpaqbqcqdq", white: "alblcldldmdnbodoapbpcp" },
            marks: { triangle: "ambmcmcnco" },
            correct: ["an"],
            wrong: ["bnan", "aoan"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-10",
        chapterId: "beginner-level1",
        order: 425,
        title: { zh: "制造双活 · 10/13", en: "Make Seki · 10/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmdndodpcqbrcrbs", white: "anbncnaocoapbpcpepaqdqfqdrcsds" },
            marks: { triangle: "cqbrcrbs" },
            correct: ["ar"],
            wrong: ["bqar", "asar"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-11",
        chapterId: "beginner-level1",
        order: 426,
        title: { zh: "制造双活 · 11/13", en: "Make Seki · 11/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncodoeofoapbpfpfqergrbscses", white: "cpdpepaqbqcqeqcrdrds" },
            marks: { triangle: "bscs" },
            correct: ["ar"],
            wrong: ["brar", "asbr"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-12",
        chapterId: "beginner-level1",
        order: 427,
        title: { zh: "制造双活 · 12/13", en: "Make Seki · 12/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdmemendobpcpdp", white: "anbncndneoepaqbqcqdqer" },
            marks: { triangle: "dobpcpdp" },
            correct: ["ap"],
            wrong: ["aoap", "boap", "coap"],
        },
    },
    {
        id: "beginner-level1-bl1-seki-2-13",
        chapterId: "beginner-level1",
        order: 428,
        title: { zh: "制造双活 · 13/13", en: "Make Seki · 13/13" },
        instruction: { zh: "黑先。请下成双活并救出标记的棋子。", en: "Black to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmemenapbpcpdp", white: "anbndncoeoepaqbqcqdqer" },
            marks: { triangle: "apbpcpdp" },
            correct: ["docnam"],
            wrong: ["docnboao", "docnaobo", "cndoambo", "cndoboao", "cndoaobo", "bodo", "aobo", "amdoboao", "amdoaobo", "amdocnbo"],
        },
    },
];

const bl1LifeDeath1Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-1-1",
        chapterId: "beginner-level1",
        order: 429,
        title: { zh: "生死 · 1/8", en: "Life&Death · 1/8" },
        instruction: { zh: "一个棋块需要两个眼才能活棋。白先。请通过制造第二个眼来使白棋块活棋，并阻止黑棋将此眼做成假眼。", en: "A group needs two eyes to live. White to play. Make the white group alive by creating a second eye and prevent Black from making this eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bebfbgcdchdddhedehfdfhgeghhehfhg", white: "dedgeeefegfefggfgg" },
            marks: { cross: "cf" },
            correct: ["cfcecg"],
            wrong: ["cecf", "cgcf"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-2",
        chapterId: "beginner-level1",
        order: 430,
        title: { zh: "生死 · 2/8", en: "Life&Death · 2/8" },
        instruction: { zh: "白棋下在A点可以在角上做出两只眼。如果黑棋下在A点，白棋块就死了。这个A点被称为'要点'。白先。请下在要点上使白棋块活棋。", en: "By playing at point A, White makes two eyes in the corner. If Black plays at A, the white group is dead. This point A is called the 'vital point'. White to play. Make the white group alive by playing at the vital point." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "afbecdcfdfdgdiehfg", white: "bfbgbicgchdh" },
            marks: { A: "ah" },
            correct: ["ah"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-3",
        chapterId: "beginner-level1",
        order: 431,
        title: { zh: "生死 · 3/8", en: "Life&Death · 3/8" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gfhfiffgfhfi", white: "hgigghhi" },
            correct: ["ihgggi"],
            wrong: ["ggih", "giih"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-4",
        chapterId: "beginner-level1",
        order: 432,
        title: { zh: "生死 · 4/8", en: "Life&Death · 4/8" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "deeefecfgfcgggchghci", white: "efdgfgdhehfhdi" },
            correct: ["fiffdf"],
            wrong: ["fffi", "dffi", "gifi"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-5",
        chapterId: "beginner-level1",
        order: 433,
        title: { zh: "生死 · 5/8", en: "Life&Death · 5/8" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdddedfdgdbehebfhfbghgchdhehfhgh", white: "deeefecfefdgegfggg" },
            correct: ["gfcecg"],
            wrong: ["cegf", "gegf", "cggf"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-6",
        chapterId: "beginner-level1",
        order: 434,
        title: { zh: "生死 · 6/8", en: "Life&Death · 6/8" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdddedfdgdbehebfhfbghgchdhehfhgh", white: "deeefecfgfdgegfg" },
            correct: ["ef"],
            wrong: ["ggef", "geef", "cgef", "ceef"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-7",
        chapterId: "beginner-level1",
        order: 435,
        title: { zh: "生死 · 7/8", en: "Life&Death · 7/8" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "deeefecfgfcgggchghcigi", white: "effgdhehfhdifi" },
            correct: ["dgffdf"],
            wrong: ["dfdg", "ffdg"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-1-8",
        chapterId: "beginner-level1",
        order: 436,
        title: { zh: "生死 · 8/8", en: "Life&Death · 8/8" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ffgfhfiffgfhfi", white: "gghgghih" },
            correct: ["higiig"],
            wrong: ["gihi", "ighi"],
        },
    },
];

const bl1LifeDeath2Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-2-1",
        chapterId: "beginner-level1",
        order: 437,
        title: { zh: "生死 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cgdgegchehfhdi", white: "bfcfdfefbgfgggbhghbigi" },
            correct: ["fi"],
            wrong: ["cifi", "eifi"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-2",
        chapterId: "beginner-level1",
        order: 438,
        title: { zh: "生死 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dgegfgfhgheigi", white: "cfdfefffcggghgchhhci" },
            correct: ["dh"],
            wrong: ["didh", "hidh", "ehdh"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-3",
        chapterId: "beginner-level1",
        order: 439,
        title: { zh: "生死 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dgegfgdhfhghgi", white: "cfdfefffcggghgchhhci" },
            correct: ["ei"],
            wrong: ["diei", "hiei", "fiei", "ehei"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-4",
        chapterId: "beginner-level1",
        order: 440,
        title: { zh: "生死 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dgegfgdhgheigi", white: "cfdfefffcggghgchhhci" },
            correct: ["fh"],
            wrong: ["hifh", "difh", "ehfh", "fifh"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-5",
        chapterId: "beginner-level1",
        order: 441,
        title: { zh: "生死 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gghgigghhi", white: "ffgfhfiffgfhfi" },
            correct: ["ih"],
            wrong: ["giih", "hhih", "iiih"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-6",
        chapterId: "beginner-level1",
        order: 442,
        title: { zh: "生死 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ggigghihhi", white: "ffgfhfiffgfhfi" },
            correct: ["hg"],
            wrong: ["gihg", "hhhg"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-7",
        chapterId: "beginner-level1",
        order: 443,
        title: { zh: "生死 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ggghihgihi", white: "ffgfhffgfhfi" },
            correct: ["hg"],
            wrong: ["ighg", "hhhg", "ifhg"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-8",
        chapterId: "beginner-level1",
        order: 444,
        title: { zh: "生死 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "igghihgihi", white: "ffgfhfiffgfhfi" },
            correct: ["hg"],
            wrong: ["gghg", "hhhg"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-9",
        chapterId: "beginner-level1",
        order: 445,
        title: { zh: "生死 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gghgfhghih", white: "gfhfifegfgehfi" },
            correct: ["hi"],
            wrong: ["gihiigeigifi", "gihiigeifigi", "gihiigeidifi", "gihieiig"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-10",
        chapterId: "beginner-level1",
        order: 446,
        title: { zh: "生死 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "deeefeefgfdgegfg", white: "cdddedfdgdbehebfhfbghgchdhehfhgh" },
            correct: ["cf", "gecfgg", "gecfcgcegg", "gecfcecggg", "ggcfge", "ggcfcgcege", "ggcfcecgge", "cgcfce", "cgcfgggece", "cgcfgeggce"],
            wrong: ["dfcfcecggegg", "dfcfcecgggge", "dfcfcgceggge", "dfcfcgcegegg", "dfcfgeggcecg", "dfcfgeggcgce", "dfcfgggecgce", "dfcfgggececg"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-11",
        chapterId: "beginner-level1",
        order: 447,
        title: { zh: "生死 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hgghhhgiii", white: "ffhfifggfhfi" },
            correct: ["ig"],
            wrong: ["ihig"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-2-12",
        chapterId: "beginner-level1",
        order: 448,
        title: { zh: "生死 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "白先。请阻止黑棋做出第二个眼，并吃掉黑棋块。", en: "White to play. Prevent a second eye and capture the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gghgigihhi", white: "ffgfhfiffgfhfi" },
            correct: ["gh"],
            wrong: ["gigh", "hhgh"],
        },
    },
];

const bl1LifeDeath3Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-3-1",
        chapterId: "beginner-level1",
        order: 449,
        title: { zh: "生死 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeofocpgpbqgqbrfrgr", white: "dpepfpcqdqfqcrer" },
            correct: ["ds"],
            wrong: ["esds", "csds"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-2",
        chapterId: "beginner-level1",
        order: 450,
        title: { zh: "生死 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocoeoapdpcqdqfq", white: "bpcpbqarcr" },
            correct: ["bs"],
            wrong: ["drbs", "csbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-3",
        chapterId: "beginner-level1",
        order: 451,
        title: { zh: "生死 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocodoeofohoapfqfresfs", white: "bpcpepbqarbrcrdrercs" },
            correct: ["dq"],
            wrong: ["dpdq", "eqdq"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-4",
        chapterId: "beginner-level1",
        order: 452,
        title: { zh: "生死 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnenfngnincohobphpbqhqbrcrfrgr", white: "dofogocpdpgpcqfqgqdrer" },
            correct: ["epeoeq"],
            wrong: ["eqep", "eoep"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-5",
        chapterId: "beginner-level1",
        order: 453,
        title: { zh: "生死 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpfpgpipbqcqhqbrdrhr", white: "dqeqgqcrgrcsdsesgs" },
            correct: ["frfqer"],
            wrong: ["fqfr", "erfr", "epfq"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-6",
        chapterId: "beginner-level1",
        order: 454,
        title: { zh: "生死 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocoeodpdqdrds", white: "apbpcpcqarcr" },
            correct: ["bscsbr"],
            wrong: ["brbs", "bqcs", "csbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-7",
        chapterId: "beginner-level1",
        order: 455,
        title: { zh: "生死 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codpepfpbqcqfqgqhqarhr", white: "dqeqbrcrerfrgrbs" },
            correct: ["dsgses"],
            wrong: ["esds", "fsgs", "gsds"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-8",
        chapterId: "beginner-level1",
        order: 456,
        title: { zh: "生死 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "encodobpepfpbqfqhqbrgr", white: "cpdpcqeqcrerfrfs" },
            correct: ["dscsdr"],
            wrong: ["drds", "csds"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-9",
        chapterId: "beginner-level1",
        order: 457,
        title: { zh: "生死 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofohocpdpgpbqgqbrhrgs", white: "epfpcqdqfqcrfrgrcs" },
            correct: ["eresdr"],
            wrong: ["fseresds", "fserdses", "eserdsfs", "eserfsds", "drer"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-10",
        chapterId: "beginner-level1",
        order: 458,
        title: { zh: "生死 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codpepaqbqcqfqgqhqarhr", white: "dqeqbrcrerfrgr" },
            correct: ["dsgses", "dsgscsbses"],
            wrong: ["dsgscsbsdres", "dsgsdres", "bsds", "csds", "esds", "gsds", "fsgs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-11",
        chapterId: "beginner-level1",
        order: 459,
        title: { zh: "生死 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpgpbqeqfqhq", white: "aqcqdqbrdr" },
            correct: ["csbsdseresfsfrcresdsar", "csbsdseresfsfrcrar", "csbsdseresfsar", "csbsdserar", "csbsdserfresar", "csbsar", "csbserdsar"],
            wrong: ["csbsdseresfsfrcresdsgsar", "csbsdseresfsfrcrgsar", "ercs", "dscs", "arcsaserfres", "arcsaseresfr", "arcseras", "bscs", "asarcsbsdser", "asarcsbserds", "asarercs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-3-12",
        chapterId: "beginner-level1",
        order: 460,
        title: { zh: "生死 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "黑先。请下在要点上，吃掉白棋块。", en: "Black to play. Play at the vital point and capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpfpeqer", white: "bqcqdqardr" },
            correct: ["bscsbr"],
            wrong: ["bscsasbr", "bscsesbr", "dsbscscr", "dsbscrcs", "csbscrds", "csbsdscr", "crcs", "brbs"],
        },
    },
];

const bl1LifeDeath4Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-4-1",
        chapterId: "beginner-level1",
        order: 461,
        title: { zh: "生死 · 1/13", en: "Life&Death · 1/13" },
        instruction: { zh: "白棋可以选择下在A点做成一只眼，或者下在B点来封闭自己的领地。但下在B点是错误的（请尝试一下）。你应该先做一只眼。白先。请先做成一只眼，使白棋块活棋。", en: "White can choose to play at A and make an eye, or play at B to close his territory. But playing at B is a mistake (try it). You should first make an eye. White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqcsdqeqfqfrhr", white: "arbrcrdrer" },
            marks: { A: "bs", B: "es" },
            correct: ["bsesds"],
            wrong: ["esbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-2",
        chapterId: "beginner-level1",
        order: 462,
        title: { zh: "生死 · 2/13", en: "Life&Death · 2/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncodofoapbpaqdqeqfqcrfrcs", white: "cpbqcqarbrdrer" },
            correct: ["bsesds"],
            wrong: ["dsbs", "esbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-3",
        chapterId: "beginner-level1",
        order: 463,
        title: { zh: "生死 · 3/13", en: "Life&Death · 3/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfpbqcqgqhqbrerhrbs", white: "dqeqfqcrfrgrcsgs" },
            correct: ["es"],
            wrong: ["dres"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-4",
        chapterId: "beginner-level1",
        order: 464,
        title: { zh: "生死 · 4/13", en: "Life&Death · 4/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpcpaqdqeqergrcs", white: "bqcqarbrdrds" },
            correct: ["bs"],
            wrong: ["crbs", "esbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-5",
        chapterId: "beginner-level1",
        order: 465,
        title: { zh: "生死 · 5/13", en: "Life&Death · 5/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpdpfpaqeqerbses", white: "bqcqdqarbrdr" },
            correct: ["cs"],
            wrong: ["dscs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-6",
        chapterId: "beginner-level1",
        order: 466,
        title: { zh: "生死 · 6/13", en: "Life&Death · 6/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpdpfpbqeqercses", white: "dqarbrdrds" },
            correct: ["bscqcr"],
            wrong: ["cqbs", "crbs", "aqbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-7",
        chapterId: "beginner-level1",
        order: 467,
        title: { zh: "生死 · 7/13", en: "Life&Death · 7/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeofogoiocphpcqhqcrgrhr", white: "epfpgpgqdrfrfs" },
            correct: ["eqdses"],
            wrong: ["dqdseseq", "dpdqeqds", "cseqdqer", "dseqdqer"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-8",
        chapterId: "beginner-level1",
        order: 468,
        title: { zh: "生死 · 8/13", en: "Life&Death · 8/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "focpdpepbqfqgqhqbrdrhrjrds", white: "cqdqeqcrfrgrcsgs" },
            correct: ["es"],
            wrong: ["eres", "hses", "bses"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-9",
        chapterId: "beginner-level1",
        order: 469,
        title: { zh: "生死 · 9/13", en: "Life&Death · 9/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpepfpbqcqfqgqhqbrhrbs", white: "dqeqcrerfrgrcs" },
            correct: ["dsgsfs"],
            wrong: ["gsdsdres", "gsdsesdr", "esgs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-10",
        chapterId: "beginner-level1",
        order: 470,
        title: { zh: "生死 · 10/13", en: "Life&Death · 10/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofohobpcpdpgpbqgqbrgrfsgs", white: "epfpcqdqfqcrfrcs" },
            correct: ["er"],
            wrong: ["eser"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-11",
        chapterId: "beginner-level1",
        order: 471,
        title: { zh: "生死 · 11/13", en: "Life&Death · 11/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "godpepfpbqcqgqhqbrerhrbs", white: "dqeqfqcrgrcses" },
            correct: ["drgsfr"],
            wrong: ["frdrdsgs", "frdrgsds", "gsdr", "hsdr", "fsdr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-12",
        chapterId: "beginner-level1",
        order: 472,
        title: { zh: "生死 · 12/13", en: "Life&Death · 12/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cneobpcpeqbrer", white: "bqardr" },
            correct: ["bscrcq"],
            wrong: ["cqbs", "crbs", "dqcq", "dscq"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-4-13",
        chapterId: "beginner-level1",
        order: 473,
        title: { zh: "生死 · 13/13", en: "Life&Death · 13/13" },
        instruction: { zh: "白先。请先做成一只眼，使白棋块活棋。", en: "White to play. First make an eye and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "coeodpfpgpipbqcqhqbrhrhs", white: "dqeqgqcrdrgrcsgs" },
            correct: ["esfqfr"],
            wrong: ["fqes", "fres"],
        },
    },
];

const bl1LifeDeath5Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-5-1",
        chapterId: "beginner-level1",
        order: 474,
        title: { zh: "生死 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmeneoepaqdqbrcr", white: "cndnaobodocpbqcq" },
            correct: ["ap"],
            wrong: ["bnap", "dpap"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-2",
        chapterId: "beginner-level1",
        order: 475,
        title: { zh: "生死 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndndodpcqcrer", white: "coapbpcpbqarbs" },
            correct: ["br"],
            wrong: ["csbr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-3",
        chapterId: "beginner-level1",
        order: 476,
        title: { zh: "生死 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbocoepeqcrdr", white: "aoapbpaqcqdqbrbs" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-4",
        chapterId: "beginner-level1",
        order: 477,
        title: { zh: "生死 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepbqcqfqgqhqbrhrgs", white: "dqeqcrdrfrgres" },
            correct: ["cs"],
            wrong: ["fscs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-5",
        chapterId: "beginner-level1",
        order: 478,
        title: { zh: "生死 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blbncocpcqeqdrds", white: "aoapbqarbrcr" },
            correct: ["bp"],
            wrong: ["csbp", "bsbp"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-6",
        chapterId: "beginner-level1",
        order: 479,
        title: { zh: "生死 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbococpcqcrcs", white: "aobpbqarbrbs" },
            correct: ["ap"],
            wrong: ["anap"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-7",
        chapterId: "beginner-level1",
        order: 480,
        title: { zh: "生死 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmanbndndodpcqeqcrcs", white: "bococpaqbqbrbs" },
            correct: ["ao"],
            wrong: ["apao", "bpao"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-8",
        chapterId: "beginner-level1",
        order: 481,
        title: { zh: "生死 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmdndodpcqeqbrcr", white: "bncnaocobpcpbqar" },
            correct: ["aq"],
            wrong: ["bsaq", "asaq", "anaq"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-9",
        chapterId: "beginner-level1",
        order: 482,
        title: { zh: "生死 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmdneneodpcqeqcrbs", white: "anbnbocodocpbqar" },
            correct: ["ap"],
            wrong: ["brap", "aqap", "bpap", "asap"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-10",
        chapterId: "beginner-level1",
        order: 483,
        title: { zh: "生死 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblclcmcncocpbqcqcrcs", white: "ambmbnboapbpaqbrbs" },
            correct: ["ar"],
            wrong: ["asar"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-11",
        chapterId: "beginner-level1",
        order: 484,
        title: { zh: "生死 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndodpdqcrercs", white: "aobocpaqbqcqbr" },
            correct: ["bs"],
            wrong: ["cobs", "apbs", "bpbs", "asbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-5-12",
        chapterId: "beginner-level1",
        order: 485,
        title: { zh: "生死 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "白先。请使白棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocoapcpepcqeqergrds", white: "bpbqarcrdrbses" },
            correct: ["aq"],
            wrong: ["csaq", "fsaq"],
        },
    },
];

const bl1LifeDeath6Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-6-1",
        chapterId: "beginner-level1",
        order: 486,
        title: { zh: "生死 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldlelflcmfmbnfnbofobpfpbqfqcrdrer", white: "dmemcnencodocpepcqdq" },
            correct: ["eo"],
            wrong: ["eqeo"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-2",
        chapterId: "beginner-level1",
        order: 487,
        title: { zh: "生死 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbocpdpepeqdrfrds", white: "apbpaqcqdqbrbs" },
            correct: ["cr"],
            wrong: ["aocr", "arcr", "ascr", "cscr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-3",
        chapterId: "beginner-level1",
        order: 488,
        title: { zh: "生死 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blbncnaococpcqcrcs", white: "anbobpbqarbrbs" },
            correct: ["ap"],
            wrong: ["amap", "aqap"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-4",
        chapterId: "beginner-level1",
        order: 489,
        title: { zh: "生死 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnaobododpeqcrdrer", white: "bpcpaqcqdqbrbs" },
            correct: ["ap"],
            wrong: ["csap", "coap", "arap", "asap"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-5",
        chapterId: "beginner-level1",
        order: 490,
        title: { zh: "生死 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmdndocpcqcr", white: "bncnaocoapbpbqar" },
            correct: ["br"],
            wrong: ["anam", "bsbr", "ambranbs", "ambrbsan", "asbr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-6",
        chapterId: "beginner-level1",
        order: 491,
        title: { zh: "生死 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbmcncocpcqeqdrcs", white: "anbnaobpaqbqbrcrbs" },
            correct: ["bo"],
            wrong: ["ambo"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-7",
        chapterId: "beginner-level1",
        order: 492,
        title: { zh: "生死 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmdndodpcqbrcr", white: "bncnaocobpbqar" },
            correct: ["aq", "cpanaq"],
            wrong: ["anam", "cpanbsaq", "cpanamaq", "cpanasaq", "bsaq", "asaq", "amaq"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-8",
        chapterId: "beginner-level1",
        order: 493,
        title: { zh: "生死 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnenfobpcpepeqerdses", white: "dodpcqdqarbrdrcs" },
            correct: ["bq"],
            wrong: ["bsbq", "asbq", "aqbq", "cobq", "eobq"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-9",
        chapterId: "beginner-level1",
        order: 494,
        title: { zh: "生死 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndneodpcqeqcrcs", white: "bocoapcpaqbqbrbs" },
            correct: ["ao"],
            wrong: ["doao"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-10",
        chapterId: "beginner-level1",
        order: 495,
        title: { zh: "生死 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmancncodoeoepcqdqfqdr", white: "bnboapcpdpaqbqcrbscs" },
            correct: ["ar"],
            wrong: ["asar", "aoar", "amar", "dsar", "brar"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-11",
        chapterId: "beginner-level1",
        order: 496,
        title: { zh: "生死 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmbndncocpdqardrcsds", white: "anbobpaqbqcqcrbs" },
            correct: ["ao"],
            wrong: ["asao", "brao", "apao", "amao"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-6-12",
        chapterId: "beginner-level1",
        order: 497,
        title: { zh: "生死 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "黑先。请吃掉白棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnbododpeqarercsdses", white: "cocpaqbqdqcrdrbs" },
            correct: ["bp", "brasbp"],
            wrong: ["apbp", "asbp"],
        },
    },
];

const bl1LifeDeath7Levels: Level[] = [
    {
        id: "beginner-level1-bl1-life-death-7-1",
        chapterId: "beginner-level1",
        order: 498,
        title: { zh: "生死 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrds", white: "aqbqcqdqfqeras" },
            correct: ["bs"],
            wrong: ["esbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-2",
        chapterId: "beginner-level1",
        order: 499,
        title: { zh: "生死 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqdrbsds", white: "bpcpdpfpeqbrcrer" },
            correct: ["ar"],
            wrong: ["ascs", "apar", "esar", "csar"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-3",
        chapterId: "beginner-level1",
        order: 500,
        title: { zh: "生死 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdreres", white: "bqcqdqeqgqfrascs" },
            correct: ["bsdsbs"],
            wrong: ["aqbs", "fsbs", "dsbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-4",
        chapterId: "beginner-level1",
        order: 501,
        title: { zh: "生死 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqcrdrds", white: "bpcpdpeqarbreras" },
            correct: ["bs"],
            wrong: ["apbs", "esbs", "csbs", "dqbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-5",
        chapterId: "beginner-level1",
        order: 502,
        title: { zh: "生死 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqeqarbrerases", white: "bocodpepgpfqcrfrbsds" },
            correct: ["csdrcs"],
            wrong: ["fsdr", "apdr", "bpdr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-6",
        chapterId: "beginner-level1",
        order: 503,
        title: { zh: "生死 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpbqbrcr", white: "bocodpdqdrds" },
            correct: ["csbsar", "arcsas"],
            wrong: ["bscs", "asar", "aoar", "aqar", "cqar", "cpar"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-7",
        chapterId: "beginner-level1",
        order: 504,
        title: { zh: "生死 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpaqdqeqarerasbscsdses", white: "bocodoeofpbqcqfqbrfr" },
            correct: ["cr"],
            wrong: ["drcr", "aocr", "fscr", "dpcr", "epcr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-8",
        chapterId: "beginner-level1",
        order: 505,
        title: { zh: "生死 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqardrds", white: "bpcpdpepeqbrcrer" },
            correct: ["bs"],
            wrong: ["csbs", "asbs", "apbs", "esbs"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-9",
        chapterId: "beginner-level1",
        order: 506,
        title: { zh: "生死 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpaqcqcrcs", white: "bocoeodpbqdqardrbs" },
            correct: ["brasbr"],
            wrong: ["aobr", "dsbr", "asbr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-10",
        chapterId: "beginner-level1",
        order: 507,
        title: { zh: "生死 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpdpbqdqarbrdrds", white: "aobocodofoapepeqerbs" },
            correct: ["cpcqcs"],
            wrong: ["cscp", "crcs", "cqcp", "ascs", "aqcp", "escp"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-11",
        chapterId: "beginner-level1",
        order: 508,
        title: { zh: "生死 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqeqarfrasbsdsesfs", white: "bpcpdpepfpgqbrcrgrcs" },
            correct: ["drercr"],
            wrong: ["fqdr", "gsdr", "apdr"],
        },
    },
    {
        id: "beginner-level1-bl1-life-death-7-12",
        chapterId: "beginner-level1",
        order: 509,
        title: { zh: "生死 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "白先。请先压缩眼位空间，然后吃掉黑棋块。", en: "White to play. Capture the black group by first reducing the eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbobpbqbrbs", white: "bmcmcncocpcqarcr" },
            correct: ["anaoaq"],
            wrong: ["aqan", "csan", "apaq", "asan", "aoan", "aman"],
        },
    },
];

const bl1SerialAtariLevels: Level[] = [
    {
        id: "beginner-level1-bl1-serial-atari-1",
        chapterId: "beginner-level1",
        order: 510,
        title: { zh: "连续打吃 · 1/24", en: "Serial Atari · 1/24" },
        instruction: { zh: "一种众所周知的吃棋方法是连续打吃（追吃）。这里白棋可以通过一次打吃来吃掉标记的棋子。如果黑棋试图连接来救它们，白棋可以再次打吃。白先。请用连续打吃的方法吃掉标记的棋子。", en: "A well-known way to capture stones is serial atari (oi-otoshi) them. Here White can capture the marked stones with an atari. If Black tries to save them by connecting, White can play atari again. White to play. Capture the marked stones with a serial atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmanbobpcqdq", white: "blcmbncncocp" },
            marks: { triangle: "ambman", cross: "al" },
            correct: ["alaobq"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-2",
        chapterId: "beginner-level1",
        order: 511,
        title: { zh: "连续打吃 · 2/24", en: "Serial Atari · 2/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcnbobpaqbrasbs", white: "cocpbqcqcr" },
            marks: { triangle: "brasbs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-3",
        chapterId: "beginner-level1",
        order: 512,
        title: { zh: "连续打吃 · 3/24", en: "Serial Atari · 3/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmanbnaobpaqbqdqcrerbs", white: "alblcmcnbococpcqbr" },
            marks: { triangle: "bmanbnao" },
            correct: ["am"],
            wrong: ["arasamap"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-4",
        chapterId: "beginner-level1",
        order: 513,
        title: { zh: "连续打吃 · 4/24", en: "Serial Atari · 4/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeofodpfpeqhqcrdrfrgr", white: "dnenfngncogocpgpcqdqgqbr" },
            marks: { triangle: "doeofodpfp" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-5",
        chapterId: "beginner-level1",
        order: 514,
        title: { zh: "连续打吃 · 5/24", en: "Serial Atari · 5/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbncndnaobpaqcqbr", white: "blcmdmenbocodoeo" },
            marks: { triangle: "bmbncndn" },
            correct: ["am", "anamal"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-6",
        chapterId: "beginner-level1",
        order: 515,
        title: { zh: "连续打吃 · 6/24", en: "Serial Atari · 6/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fneodpfpdqeq", white: "dnendocpgpcqfqdrfr" },
            marks: { triangle: "dpdqeq" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-7",
        chapterId: "beginner-level1",
        order: 516,
        title: { zh: "连续打吃 · 7/24", en: "Serial Atari · 7/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodobpaqbrasbs", white: "cpbqcqeqfqcr" },
            marks: { triangle: "brasbs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-8",
        chapterId: "beginner-level1",
        order: 517,
        title: { zh: "连续打吃 · 8/24", en: "Serial Atari · 8/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbobpbqcqdrergrdsfsgs", white: "bmcmcncocpdqeqfqgqhqfrhr" },
            marks: { triangle: "grfsgs" },
            correct: ["hsescr"],
            wrong: ["hsescscr"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-9",
        chapterId: "beginner-level1",
        order: 518,
        title: { zh: "连续打吃 · 9/24", en: "Serial Atari · 9/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnbpcpdpaqbrasbscs", white: "bqcqeqfqcrdr" },
            marks: { triangle: "brasbscs" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-10",
        chapterId: "beginner-level1",
        order: 519,
        title: { zh: "连续打吃 · 10/24", en: "Serial Atari · 10/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eodpfphpaqbqdqeqgqhqbrcrascs", white: "gocpgpcqfqdrerfr" },
            marks: { triangle: "dpdqeq" },
            correct: ["doepen"],
            wrong: ["doepfoen", "foco"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-11",
        chapterId: "beginner-level1",
        order: 520,
        title: { zh: "连续打吃 · 11/24", en: "Serial Atari · 11/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "amanbnboapdpbqcqeq", white: "flbmcmcncobpcp" },
            marks: { triangle: "amanbnbo" },
            correct: ["al"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-12",
        chapterId: "beginner-level1",
        order: 521,
        title: { zh: "连续打吃 · 12/24", en: "Serial Atari · 12/24" },
        instruction: { zh: "白先。请打吃并吃掉标记的棋子。", en: "White to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdmcnboapcpdpbqcq", white: "dndoepaqdqfqarbrcr" },
            marks: { triangle: "cpdpbqcq" },
            correct: ["cobpbn"],
            wrong: ["cobpaoan"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-13",
        chapterId: "beginner-level1",
        order: 522,
        title: { zh: "连续打吃 · 13/24", en: "Serial Atari · 13/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epbqcqdqdrcsds", white: "cnbpcpaqbrcras" },
            marks: { triangle: "brcras" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-14",
        chapterId: "beginner-level1",
        order: 523,
        title: { zh: "连续打吃 · 14/24", en: "Serial Atari · 14/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alblclcmcncobpcp", white: "bmanbnboapdpbqcqeq" },
            marks: { triangle: "bmanbnbo" },
            correct: ["am"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-15",
        chapterId: "beginner-level1",
        order: 524,
        title: { zh: "连续打吃 · 15/24", en: "Serial Atari · 15/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpepfpcqgqhqcrdrhr", white: "engobpcpgpbqdqeqfqbrergr" },
            marks: { triangle: "dqeqfqer" },
            correct: ["esfrgs", "esfrfs"],
            wrong: ["gsds", "fsds", "dses"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-16",
        chapterId: "beginner-level1",
        order: 525,
        title: { zh: "连续打吃 · 16/24", en: "Serial Atari · 16/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmcndndobpcpdp", white: "anbnbocoapbqcqdqfq" },
            marks: { triangle: "anbnboco" },
            correct: ["am"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-17",
        chapterId: "beginner-level1",
        order: 526,
        title: { zh: "连续打吃 · 17/24", en: "Serial Atari · 17/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbnaocodoapdpdq", white: "bocpbqeqcrdr" },
            marks: { triangle: "bocp" },
            correct: ["cqbpbr"],
            wrong: ["cqbpaqbr", "bpcq", "aqbp"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-18",
        chapterId: "beginner-level1",
        order: 527,
        title: { zh: "连续打吃 · 18/24", en: "Serial Atari · 18/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndoapbpdpcqcr", white: "epaqdqfqarbrdrascs" },
            marks: { triangle: "aqarbras" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-19",
        chapterId: "beginner-level1",
        order: 528,
        title: { zh: "连续打吃 · 19/24", en: "Serial Atari · 19/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepfpcqfqfrfs", white: "bncobpbqdqeqcrerds" },
            marks: { triangle: "dqeqer" },
            correct: ["esdrbr", "brbses"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-20",
        chapterId: "beginner-level1",
        order: 529,
        title: { zh: "连续打吃 · 20/24", en: "Serial Atari · 20/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epbqcqdqcrcs", white: "cnbpcpaqbras" },
            marks: { triangle: "bras" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-21",
        chapterId: "beginner-level1",
        order: 530,
        title: { zh: "连续打吃 · 21/24", en: "Serial Atari · 21/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbnfnaodoepfpcqdq", white: "cmcnboapcpdpbqeqer" },
            marks: { triangle: "bocpdp" },
            correct: ["cobpbr"],
            wrong: ["brco"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-22",
        chapterId: "beginner-level1",
        order: 531,
        title: { zh: "连续打吃 · 22/24", en: "Serial Atari · 22/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "coeoepcqdqbrdrgrfs", white: "fpeqgqcrerfrhrcsds" },
            marks: { triangle: "crcsds" },
            correct: ["bs"],
            wrong: ["gses"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-23",
        chapterId: "beginner-level1",
        order: 532,
        title: { zh: "连续打吃 · 23/24", en: "Serial Atari · 23/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpepbqcqdrcsds", white: "cmcnbobpaqbrcras" },
            marks: { triangle: "brcras" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level1-bl1-serial-atari-24",
        chapterId: "beginner-level1",
        order: 533,
        title: { zh: "连续打吃 · 24/24", en: "Serial Atari · 24/24" },
        instruction: { zh: "黑先。请打吃并吃掉标记的棋子。", en: "Black to play. Atari and capture the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndncododpdqarbrcr", white: "bmcmdmcnboapcpbqcq" },
            marks: { triangle: "cpbqcq" },
            correct: ["aq", "anamaq"],
        },
    },
];

const bl1KoLevels: Level[] = [
    {
        id: "beginner-level1-bl1-ko-1",
        chapterId: "beginner-level1",
        order: 534,
        title: { zh: "劫 · 1/24", en: "Ko · 1/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocpcqdrcs", white: "bpbqarcr" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-2",
        chapterId: "beginner-level1",
        order: 535,
        title: { zh: "劫 · 2/24", en: "Ko · 2/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocoapcpdqeqer", white: "bpcqbrdr" },
            correct: ["aq"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-3",
        chapterId: "beginner-level1",
        order: 536,
        title: { zh: "劫 · 3/24", en: "Ko · 3/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnaocododpdqcrdr", white: "bocpbqcqbrbs" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-4",
        chapterId: "beginner-level1",
        order: 537,
        title: { zh: "劫 · 4/24", en: "Ko · 4/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldlelemendoeoapcpbqdq", white: "bmcmdmbndncobp" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-5",
        chapterId: "beginner-level1",
        order: 538,
        title: { zh: "劫 · 5/24", en: "Ko · 5/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobpcpdpdqdrbs", white: "bndnbobqcqarcr" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-6",
        chapterId: "beginner-level1",
        order: 539,
        title: { zh: "劫 · 6/24", en: "Ko · 6/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocofocpepeqerbsdses", white: "apbpbqcqdqdrcs" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-7",
        chapterId: "beginner-level1",
        order: 540,
        title: { zh: "劫 · 7/24", en: "Ko · 7/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bndndodpeqfqcrdrfrbs", white: "bpcpaqcqdqbrer" },
            correct: ["as"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-8",
        chapterId: "beginner-level1",
        order: 541,
        title: { zh: "劫 · 8/24", en: "Ko · 8/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbpdpepcqfq", white: "cndocpbq" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-9",
        chapterId: "beginner-level1",
        order: 542,
        title: { zh: "劫 · 9/24", en: "Ko · 9/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndneoeqfqarcrdrbs", white: "bocobpdpcqdqbr" },
            correct: ["aq"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-10",
        chapterId: "beginner-level1",
        order: 543,
        title: { zh: "劫 · 10/24", en: "Ko · 10/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cododpdqerds", white: "cpcqbrdr" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-11",
        chapterId: "beginner-level1",
        order: 544,
        title: { zh: "劫 · 11/24", en: "Ko · 11/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncocpcqeqdrcs", white: "bobpbqarcr" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-12",
        chapterId: "beginner-level1",
        order: 545,
        title: { zh: "劫 · 12/24", en: "Ko · 12/24" },
        instruction: { zh: "白先。请制造一个劫。", en: "White to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobpcpdpepeqerbses", white: "clcnbobqcqdqardr" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-13",
        chapterId: "beginner-level1",
        order: 546,
        title: { zh: "劫 · 13/24", en: "Ko · 13/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "boapcpdpepeqeres", white: "aqcqdqbrdrcs" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-14",
        chapterId: "beginner-level1",
        order: 547,
        title: { zh: "劫 · 14/24", en: "Ko · 14/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "drfrgrcs", white: "eqerfs" },
            correct: ["es"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-15",
        chapterId: "beginner-level1",
        order: 548,
        title: { zh: "劫 · 15/24", en: "Ko · 15/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndocpbq", white: "bpdpepcqfq" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-16",
        chapterId: "beginner-level1",
        order: 549,
        title: { zh: "劫 · 16/24", en: "Ko · 16/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocododpdqcrer", white: "bpcpcqbrcs" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-17",
        chapterId: "beginner-level1",
        order: 550,
        title: { zh: "劫 · 17/24", en: "Ko · 17/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobobpdpcqeqcrcs", white: "bncncocpbqarbrbs" },
            correct: ["aq"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-18",
        chapterId: "beginner-level1",
        order: 551,
        title: { zh: "劫 · 18/24", en: "Ko · 18/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmbnbpcpaqcqbr", white: "anbocodo" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-19",
        chapterId: "beginner-level1",
        order: 552,
        title: { zh: "劫 · 19/24", en: "Ko · 19/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doepbqdqeqbrer", white: "bncnaocobpcqcrdr" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-20",
        chapterId: "beginner-level1",
        order: 553,
        title: { zh: "劫 · 20/24", en: "Ko · 20/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpcqdrcs", white: "dncocpbqarbs" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-21",
        chapterId: "beginner-level1",
        order: 554,
        title: { zh: "劫 · 21/24", en: "Ko · 21/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnapbpdpepcqbr", white: "blcmcnaobodo" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-22",
        chapterId: "beginner-level1",
        order: 555,
        title: { zh: "劫 · 22/24", en: "Ko · 22/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bococpbqdqfqbr", white: "anbncndnaoaq" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-23",
        chapterId: "beginner-level1",
        order: 556,
        title: { zh: "劫 · 23/24", en: "Ko · 23/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbpcpcqcrbs", white: "dpbqdqbrdrcsds" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level1-bl1-ko-24",
        chapterId: "beginner-level1",
        order: 557,
        title: { zh: "劫 · 24/24", en: "Ko · 24/24" },
        instruction: { zh: "黑先。请制造一个劫。", en: "Black to play. Make a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocododpbqdqardr", white: "anbncndnaobpcp" },
            correct: ["ap"],
        },
    },
];

const bl1GoodPlayLevels: Level[] = [
    {
        id: "beginner-level1-bl1-good-play-1",
        chapterId: "beginner-level1",
        order: 558,
        title: { zh: "好手 · 1/9", en: "Good Play · 1/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpdpcqcr", white: "cpfpdq" },
            marks: { A: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpdpcqcr", white: "cpfpdq" },
                marks: { A: "do" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-2",
        chapterId: "beginner-level1",
        order: 559,
        title: { zh: "好手 · 2/9", en: "Good Play · 2/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ephpdqfqdr", white: "cmdodpcqeqcr" },
            marks: { A: "er" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ephpdqfqdr", white: "cmdodpcqeqcr" },
                marks: { A: "er" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-3",
        chapterId: "beginner-level1",
        order: 560,
        title: { zh: "好手 · 3/9", en: "Good Play · 3/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fphqdrerfs", white: "cobqdses" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fphqdrerfs", white: "cobqdses" },
                marks: { A: "cs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-4",
        chapterId: "beginner-level1",
        order: 561,
        title: { zh: "好手 · 4/9", en: "Good Play · 4/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpgpeqfq", white: "epfp" },
            marks: { A: "en" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dpgpeqfq", white: "epfp" },
                marks: { A: "en" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-5",
        chapterId: "beginner-level1",
        order: 562,
        title: { zh: "好手 · 5/9", en: "Good Play · 5/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dncpdqeqfqgqcrgrds", white: "hphqdrerfrhresgs" },
            marks: { A: "fs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dncpdqeqfqgqcrgrds", white: "hphqdrerfrhresgs" },
                marks: { A: "fs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-6",
        chapterId: "beginner-level1",
        order: 563,
        title: { zh: "好手 · 6/9", en: "Good Play · 6/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clendodpeqfq", white: "epfpipiq" },
            marks: { A: "eo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "clendodpeqfq", white: "epfpipiq" },
                marks: { A: "eo" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-7",
        chapterId: "beginner-level1",
        order: 564,
        title: { zh: "好手 · 7/9", en: "Good Play · 7/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codqeqcrfrgr", white: "hofqgqdrerhr" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codqeqcrfrgr", white: "hofqgqdrerhr" },
                marks: { A: "cs" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-8",
        chapterId: "beginner-level1",
        order: 565,
        title: { zh: "好手 · 8/9", en: "Good Play · 8/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnepdqfqdr", white: "hoeqgqgr" },
            marks: { A: "er" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "not good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dnepdqfqdr", white: "hoeqgqgr" },
                marks: { A: "er" },
            },
        },
    },
    {
        id: "beginner-level1-bl1-good-play-9",
        chapterId: "beginner-level1",
        order: 566,
        title: { zh: "好手 · 9/9", en: "Good Play · 9/9" },
        instruction: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpdrerfs", white: "cocqbrdses" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。在A落子是一步好棋吗？", en: "White to play. Is playing at A a good move?" },
            options: [{ value: "good", label: { zh: "好", en: "Good" } }, { value: "not good", label: { zh: "不好", en: "Not good" } }],
            correctValue: "good",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fpdrerfs", white: "cocqbrdses" },
                marks: { A: "cs" },
            },
        },
    },
];

const bl1BlockLevels: Level[] = [
    {
        id: "beginner-level1-bl1-block-1",
        chapterId: "beginner-level1",
        order: 567,
        title: { zh: "挡 · 1/13", en: "Block · 1/13" },
        instruction: { zh: "白棋下了1，并威胁要将黑棋切断成两块独立的棋块。黑先。请挡住白棋。", en: "White has played 1 and threatens to cut the black stones into two separate groups. Black to play. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqepfqhp", white: "bpckcpdmdp" },
            marks: { 1: "dp", cross: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level1-bl1-block-2",
        chapterId: "beginner-level1",
        order: 568,
        title: { zh: "挡 · 2/13", en: "Block · 2/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldncocq", white: "dodpdqgq" },
            marks: { 1: "dp" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level1-bl1-block-3",
        chapterId: "beginner-level1",
        order: 569,
        title: { zh: "挡 · 3/13", en: "Block · 3/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcodpcq", white: "epdqeqhq" },
            marks: { 1: "ep" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level1-bl1-block-4",
        chapterId: "beginner-level1",
        order: 570,
        title: { zh: "挡 · 4/13", en: "Block · 4/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gocpdpephq", white: "gpcqdqfqfr" },
            marks: { 1: "gp" },
            correct: ["hp"],
        },
    },
    {
        id: "beginner-level1-bl1-block-5",
        chapterId: "beginner-level1",
        order: 571,
        title: { zh: "挡 · 5/13", en: "Block · 5/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpfpcqgqcr", white: "dpdqdr" },
            marks: { 1: "dp" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level1-bl1-block-6",
        chapterId: "beginner-level1",
        order: 572,
        title: { zh: "挡 · 6/13", en: "Block · 6/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dkdndodpcqcr", white: "eoepipdqeqdr" },
            marks: { 1: "eo" },
            correct: ["en"],
        },
    },
    {
        id: "beginner-level1-bl1-block-7",
        chapterId: "beginner-level1",
        order: 573,
        title: { zh: "挡 · 7/13", en: "Block · 7/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enep", white: "eodpdq" },
            marks: { 1: "eo" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level1-bl1-block-8",
        chapterId: "beginner-level1",
        order: 574,
        title: { zh: "挡 · 8/13", en: "Block · 8/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dndocpfpcq", white: "eodpdq" },
            marks: { 1: "dp" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level1-bl1-block-9",
        chapterId: "beginner-level1",
        order: 575,
        title: { zh: "挡 · 9/13", en: "Block · 9/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcndodpepfphqiq", white: "gleofogogpeqfq" },
            marks: { 1: "fq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level1-bl1-block-10",
        chapterId: "beginner-level1",
        order: 576,
        title: { zh: "挡 · 10/13", en: "Block · 10/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epfpfqjq", white: "cncpdqeqfr" },
            marks: { 1: "fr" },
            correct: ["gr"],
        },
    },
    {
        id: "beginner-level1-bl1-block-11",
        chapterId: "beginner-level1",
        order: 577,
        title: { zh: "挡 · 11/13", en: "Block · 11/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldndocqdq", white: "dpephpeq" },
            marks: { 1: "dp" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level1-bl1-block-12",
        chapterId: "beginner-level1",
        order: 578,
        title: { zh: "挡 · 12/13", en: "Block · 12/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbobpbqdqeqfqhq", white: "dmemfocpdpepcq" },
            marks: { 1: "cq" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level1-bl1-block-13",
        chapterId: "beginner-level1",
        order: 579,
        title: { zh: "挡 · 13/13", en: "Block · 13/13" },
        instruction: { zh: "黑先。白棋已落子1。挡住白棋。", en: "Black to play. White has played 1. Block White." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcocpfpcqdqfqfr", white: "dnfndodpeqdrer" },
            marks: { 1: "eq" },
            correct: ["ep"],
        },
    },
];

const bl1StretchLevels: Level[] = [
    {
        id: "beginner-level1-bl1-stretch-1",
        chapterId: "beginner-level1",
        order: 580,
        title: { zh: "延伸 · 1/13", en: "Stretch · 1/13" },
        instruction: { zh: "标记的白棋棋子容易被黑棋攻击。白先。延伸这串棋子以增加气，并使白棋更容易连接到另一颗白棋。在日语中，这种延伸称为'nobi'（延伸）。", en: "The marked white stones can easily be attacked by Black. White to play. Stretch this chain to create more liberties and to make it more easy for White to connect to the other white stone. In Japanese this stretch is called 'nobi' (伸び)." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcocqdmdq", white: "cpdpgp" },
            marks: { triangle: "cpdp", cross: "ep" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-2",
        chapterId: "beginner-level1",
        order: 581,
        title: { zh: "延伸 · 2/13", en: "Stretch · 2/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "docqdr", white: "dqgq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-3",
        chapterId: "beginner-level1",
        order: 582,
        title: { zh: "延伸 · 3/13", en: "Stretch · 3/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cocpcqeqdr", white: "dodpdq" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-4",
        chapterId: "beginner-level1",
        order: 583,
        title: { zh: "延伸 · 4/13", en: "Stretch · 4/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbndnbodobpcqcr", white: "cncocpdphq" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-5",
        chapterId: "beginner-level1",
        order: 584,
        title: { zh: "延伸 · 5/13", en: "Stretch · 5/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpbqdqeqfqhr", white: "clcmdpcqbrcrdr" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-6",
        chapterId: "beginner-level1",
        order: 585,
        title: { zh: "延伸 · 6/13", en: "Stretch · 6/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqfq", white: "dlbpcpdp" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-7",
        chapterId: "beginner-level1",
        order: 586,
        title: { zh: "延伸 · 7/13", en: "Stretch · 7/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpcqdqgq", white: "codocp" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-8",
        chapterId: "beginner-level1",
        order: 587,
        title: { zh: "延伸 · 8/13", en: "Stretch · 8/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpbqcqdqhq", white: "cmdobpcp" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-9",
        chapterId: "beginner-level1",
        order: 588,
        title: { zh: "延伸 · 9/13", en: "Stretch · 9/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpepeqhq", white: "bpcqdq" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-10",
        chapterId: "beginner-level1",
        order: 589,
        title: { zh: "延伸 · 10/13", en: "Stretch · 10/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobpcqcr", white: "cocpdqdr" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-11",
        chapterId: "beginner-level1",
        order: 590,
        title: { zh: "延伸 · 11/13", en: "Stretch · 11/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpcqdqer", white: "cncododpeq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-12",
        chapterId: "beginner-level1",
        order: 591,
        title: { zh: "延伸 · 12/13", en: "Stretch · 12/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcpdpepcq", white: "dqeqiq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level1-bl1-stretch-13",
        chapterId: "beginner-level1",
        order: 592,
        title: { zh: "延伸 · 13/13", en: "Stretch · 13/13" },
        instruction: { zh: "白先。以最佳方式延伸。", en: "White to play. Stretch the best way." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepbqcqgq", white: "cldmcp" },
            correct: ["co"],
        },
    },
];

export const LEVELS: Level[] = [
    ...bl1AtariLevels,
    ...escapeFromNetLevels,
    ...bl1CalculateEscapeLevels,
    ...bl1CalculateLadderLevels,
    ...bl1LadderLevels,
    ...bl1DoubleAtariLevels,
    ...bl1SnapbackLevels,
    ...bl1NetLevels,
    ...bl1ChaseDownLevels,
    ...bl1Capture1Levels,
    ...bl1Capture2Levels,
    ...bl1Capture3Levels,
    ...bl1Capture4Levels,
    ...bl1ConnectLevels,
    ...bl1CutLevels,
    ...bl1CancelCutLevels,
    ...bl1EyeLevels,
    ...bl1FalseEyeLevels,
    ...bl1CountEyesLevels,
    ...bl1CloseTerritoryLevels,
    ...bl1ReduceTerritoryLevels,
    ...bl1CapturingRace1Levels,
    ...bl1CapturingRace2Levels,
    ...bl1Seki1Levels,
    ...bl1Seki2Levels,
    ...bl1LifeDeath1Levels,
    ...bl1LifeDeath2Levels,
    ...bl1LifeDeath3Levels,
    ...bl1LifeDeath4Levels,
    ...bl1LifeDeath5Levels,
    ...bl1LifeDeath6Levels,
    ...bl1LifeDeath7Levels,
    ...bl1SerialAtariLevels,
    ...bl1KoLevels,
    ...bl1GoodPlayLevels,
    ...bl1BlockLevels,
    ...bl1StretchLevels,
];
